"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3095],{

/***/ 34743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30132);
/* harmony import */ var svgIcons_ExpandMore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40934);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    height: 50px;\n    padding: 13px 10px 13px 15px;\n    border-radius: 8px;\n    border: solid 1px ",
        ";\n    background-color: ",
        ";\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    &[data-focused='true'] {\n      border: solid 1px ",
        ";\n    }\n\n    &[data-errors='true'] {\n      border: solid 1px ",
        ";\n\n      & > p,\n      & > span {\n        color: ",
        ";\n      }\n    }\n\n    &[data-disabled='true'] {\n      background-color: ",
        ";\n\n      & > p,\n      & > span {\n        color: ",
        ";\n      }\n    }\n\n    & > [aria-describedby='placeholder'],\n    & > p {\n      height: 24px;\n      font-size: 16px;\n      line-height: 24px;\n      letter-spacing: -0.64px;\n      text-align: left;\n    }\n\n    & > [aria-describedby='placeholder'] {\n      font-weight: normal;\n      color: ",
        ";\n    }\n\n    & > p {\n      font-weight: 500;\n      color: ",
        ";\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 5px;\n\n      & > .icon-select-option {\n        width: 16px;\n        height: 16px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n\n    & > i {\n      width: 24px;\n      height: 24px;\n      text-align: center;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var SelectBox = function(param) {
    var placeholder = param.placeholder, selectValue = param.selectValue, icon = param.icon, isFocused = param.isFocused, isErrors = param.isErrors, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, onClick = param.onClick;
    var handleClick = function() {
        if (!disabled) {
            onClick();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        onClick: handleClick,
        "data-focused": isFocused,
        "data-errors": isErrors,
        "data-disabled": disabled,
        children: [
            selectValue ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                children: [
                    icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                        className: "icon-select-option",
                        children: icon
                    }),
                    selectValue
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                "aria-describedby": "placeholder",
                children: placeholder
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                className: "icon-arrow",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons_ExpandMore__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectBox);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SelectBox__StyledWrapper",
    componentId: "sc-61a4499e-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), theme.line.line_2, theme.background.bg_8, theme.color.primary_2, theme.color.error_1, theme.color.error_1, theme.background.bg_3, theme.color.text_2, theme.color.text_3, theme.color.text_1);
});


/***/ }),

/***/ 67308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    height: fit-content;\n    max-height: 320px;\n    overflow-y: auto;\n    border: solid 1px ",
        ";\n    border-radius: 8px;\n    background-color: ",
        ";\n    position: absolute;\n    left: 0;\n    top: 54px;\n    z-index: 10;\n\n    & > li {\n      height: 40px;\n      display: flex;\n      align-items: center;\n      padding: 10px 15px;\n\n      &:hover {\n        background-color: ",
        ";\n      }\n\n      p {\n        height: 20px;\n        font-size: 14px;\n        font-weight: normal;\n        line-height: 20px;\n        letter-spacing: -0.56px;\n        text-align: left;\n        color: ",
        ";\n\n        &:not(:first-child) {\n          margin-left: 5px;\n        }\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var SelectOption = function(param) {
    var options = param.options, onClick = param.onClick, className = param.className;
    var handleClick = function(e) {
        onClick({
            value: e.currentTarget.dataset.selectValue || "",
            label: e.currentTarget.dataset.selectLabel || ""
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        className: className,
        children: options.map(function(option) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                onClick: handleClick,
                "data-select-value": option.value,
                "data-select-label": option.label,
                children: [
                    option.icon,
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        children: option.label
                    })
                ]
            }, "option-id-".concat(option.value));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectOption);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    displayName: "SelectOption__StyledWrapper",
    componentId: "sc-9fed5b23-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), theme.line.line_1, theme.background.bg_8, theme.background.bg_3, theme.color.text_1);
});


/***/ }),

/***/ 11923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52737);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53893);
/* harmony import */ var _app_components_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85025);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: ",
        ";\n  border-radius: 10px;\n  gap: 4px;\n\n  background-color: #004eff;\n\n  &:hover {\n    background-color: #003ee6;\n  }\n\n  .arrow-icon {\n    width: ",
        ";\n    height: ",
        ";\n  }\n\n  > span {\n    font-size: ",
        ";\n    font-weight: bold;\n    line-height: 1.95;\n    letter-spacing: -0.88px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ExamContainedButton = function(_param) {
    var children = _param.children, _isEndIcon = _param.isEndIcon, isEndIcon = _isEndIcon === void 0 ? true : _isEndIcon, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children",
        "isEndIcon"
    ]);
    var isMobile = (0,context__WEBPACK_IMPORTED_MODULE_2__/* .useUA */ .nD)().isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        isMobile: !!isMobile
    }, props), {
        endIcon: isEndIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRight */ .ol, {
            className: "arrow-icon"
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
            children: children
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ExamContainedButton);
var StyledWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_app_components_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    displayName: "ExamContainedButton__StyledWrapper",
    componentId: "sc-14b4426d-0"
})(_templateObject(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "50px" : "76px";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "14px" : "18px";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "14px" : "18px";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "16px" : "22px";
});


/***/ }),

/***/ 75606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_exam_context_ExamContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49546);
/* harmony import */ var hooks_usePagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27914);
/* harmony import */ var svgIcons_ArrowLeft__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5039);
/* harmony import */ var svgIcons_ArrowRight__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14615);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  > button {\n    width: 39px;\n    height: 39px;\n    margin: 0 0 0 6px;\n    border-radius: 5px;\n    border: solid 1px #dedede;\n    background-color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 15px;\n    font-weight: 500;\n    letter-spacing: -0.6px;\n    color: #333;\n    cursor: pointer;\n    &:disabled {\n      color: #999;\n      cursor: default;\n    }\n\n    &.active-page {\n      font-weight: bold;\n      color: #004eff;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var Pagination = function(param) {
    var totalCount = param.totalCount;
    var handleCheckReservation = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_app_feature_exam_context_ExamContext__WEBPACK_IMPORTED_MODULE_4__/* .ExamContext */ .J).handleCheckReservation;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var query = router.query;
    var setActivePage = function(clickedPage) {
        handleCheckReservation({
            onReservated: function() {
                router.replace({
                    query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, router.query), {
                        page: clickedPage
                    })
                }, undefined, {
                    shallow: true
                });
            }
        });
    };
    var ref = (0,hooks_usePagination__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        activePage: Number(query.page) || 1,
        setActivePage: setActivePage,
        numberOfPages: Math.ceil(totalCount / 6),
        maxButtons: 5
    }), goToPage = ref.goToPage, activePage = ref.activePage, computeVisiblePieces = ref.computeVisiblePieces;
    var visiblePieces = computeVisiblePieces({
        maxButtons: 5,
        activePage: Number(query.page) || 1,
        numberOfPages: Math.ceil(totalCount / 6)
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        children: visiblePieces.map(function(piece) {
            if (piece.type === "next") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    disabled: piece.isDisabled,
                    className: "button-arrow-next",
                    onClick: function() {
                        return goToPage(piece.pageNumber);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons_ArrowRight__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: "icon-arrow"
                    })
                }, "next");
            }
            if (piece.type === "previous") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    disabled: piece.isDisabled,
                    className: "button-arrow-previous",
                    onClick: function() {
                        return goToPage(piece.pageNumber);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons_ArrowLeft__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: "icon-arrow"
                    })
                }, "previous");
            }
            if (piece.type === "page-number") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    className: "button-page-number' ".concat(activePage === piece.pageNumber ? "active-page" : ""),
                    onClick: function() {
                        return goToPage(piece.pageNumber);
                    },
                    children: piece.pageNumber
                }, piece.pageNumber);
            }
            return null;
        })
    });
};
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Pagination__StyledWrapper",
    componentId: "sc-d23aac42-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 39088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30132);
/* harmony import */ var _app_components_Portal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20901);
/* harmony import */ var _gsat2024_2_desktop_SectionFive_components_stepFive_components_loading_ExternalLoading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31698);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    z-index: 500;\n    top: 0;\n    left: 0;\n    background: rgba(0, 0, 0, 0.7);\n\n    & > .popup-content {\n      width: 280px;\n      height: 300px;\n      background-color: ",
        ";\n      border-radius: 20px;\n      padding: 40px;\n      position: absolute;\n      z-index: 600;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n\n      & > strong {\n        width: 100%;\n        height: 26px;\n        font-size: 18px;\n        font-weight: bold;\n        line-height: 26px;\n        letter-spacing: -0.72px;\n        text-align: center;\n        color: ",
        ";\n        margin-bottom: 8px;\n        display: block;\n      }\n\n      & > p.loading-description {\n        // 전역으로 잡힌 스타일보다 우선순위를 높게 잡아야 합니다\n        height: 40px;\n        font-size: 14px;\n        font-weight: normal;\n        line-height: 20px;\n        letter-spacing: -0.56px;\n        text-align: center;\n        color: ",
        ";\n        margin-bottom: 20px;\n      }\n\n      & > .loading-image-wrapper {\n        width: 140px;\n        height: 140px;\n        margin: 0 auto 20px;\n\n        & > figure {\n          width: 100%;\n          height: 100%;\n          margin: 0;\n          padding: 0;\n\n          & > figcaption {\n            width: 0;\n            height: 0;\n            font-size: 0;\n          }\n        }\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ScoringLoadingPopup = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Portal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        id: "scoring-loading-popup",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "popup-content",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                        children: "잠시만 기다려주세요."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "loading-image-wrapper",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("figure", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("figcaption", {
                                    children: "가채점 입력 답안 제출 로딩 팝업"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "/static/images/career/external_data_loading.png",
                                    width: 140,
                                    height: 140,
                                    alt: "가채점 입력 답안 제출 로딩"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_gsat2024_2_desktop_SectionFive_components_stepFive_components_loading_ExternalLoading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ScoringLoadingPopup);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].article.withConfig */ .ZP.article.withConfig({
    displayName: "ScoringLoadingPopup__StyledWrapper",
    componentId: "sc-ee0f13b2-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject(), theme.background.bg_8, theme.color.text_1, theme.color.text_1);
});


/***/ }),

/***/ 88808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Al": function() { return /* binding */ GSAT_REVIEW_PATHNAME; },
/* harmony export */   "C8": function() { return /* binding */ TOPIC_ID; },
/* harmony export */   "rd": function() { return /* binding */ GSAT_REVIEW_SLUG_QUERY; },
/* harmony export */   "sn": function() { return /* binding */ SAMSUNG_INTERVIEW_BOARD_SLUG; },
/* harmony export */   "yN": function() { return /* binding */ GSAT_REVIEW_BOARD_ID; }
/* harmony export */ });
/* unused harmony export SAMSUNG_INTERVIEW_BOARD_ID */
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15125);

var GSAT_REVIEW_PATHNAME = "cbt-samsung";
var TOPIC_ID = {
    GSAT: utils_config__WEBPACK_IMPORTED_MODULE_0__/* .LINKAREER_DOMAIN */ .sJ === "linkareer.com" ? "4185046" : "979159"
};
var GSAT_REVIEW_SLUG_QUERY = {
    topicId: TOPIC_ID.GSAT
};
var SAMSUNG_INTERVIEW_BOARD_SLUG = "samsung_interview";
// GSAT 응시후기 게시판 ID
// 환경변수로 관리하기엔 각 이벤트 서비스마다 게시판이 생성되어 변경될 수 있어 도메인을 통해 테스트서버, 상용서버 ID를 분리하여 설정합니다
var GSAT_REVIEW_BOARD_ID = utils_config__WEBPACK_IMPORTED_MODULE_0__/* .LINKAREER_DOMAIN */ .sJ === "linkareer.com" ? "3738530" : "977524";
var SAMSUNG_INTERVIEW_BOARD_ID = utils_config__WEBPACK_IMPORTED_MODULE_0__/* .LINKAREER_DOMAIN */ .sJ === "linkareer.com" ? "3519922" : "978654";


/***/ }),

/***/ 38695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ND": function() { return /* binding */ FIRST_HALF_ID_GSAT; },
/* harmony export */   "Y7": function() { return /* binding */ GSAT_2025_2_EXAM_TERM_ID; },
/* harmony export */   "h_": function() { return /* binding */ SAMSUNG_COMPANY_ID; },
/* harmony export */   "hv": function() { return /* binding */ SECOND_HALF_ID; }
/* harmony export */ });
var SAMSUNG_COMPANY_ID = "1";
var SECOND_HALF_ID = "1";
var FIRST_HALF_ID_GSAT = "2";
var GSAT_2025_2_EXAM_TERM_ID = "4" // 2025 하반기
;


/***/ }),

/***/ 82708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ds": function() { return /* binding */ EXAM_STAGE_TAB; },
/* harmony export */   "G7": function() { return /* binding */ EXAM_STAGE_TAB_SECTION; },
/* harmony export */   "eY": function() { return /* binding */ GSAT_2025_TAB_OPTIONS_MOBILE; },
/* harmony export */   "mj": function() { return /* binding */ EXAM_TAB_OPTIONS; }
/* harmony export */ });
/* unused harmony export EXAM_TAB_OPTIONS_MOBILE */
var EXAM_STAGE_TAB = {
    FULL_RESERVATION: "full-reservation",
    REAL_TIME_RESTORE: "real-time-restore",
    EXAM_REVIEW: "exam-review",
    EXAM_VOTE: "exam-vote",
    PREDICTION_SCORE: "prediction-score"
};
var EXAM_STAGE_TAB_SECTION = {
    FULL_RESERVATION: "section1",
    REAL_TIME_RESTORE: "section2",
    EXAM_REVIEW: "section2",
    EXAM_VOTE: "section2",
    PREDICTION_SCORE: "section2"
};
var EXAM_TAB_OPTIONS = [
    {
        id: EXAM_STAGE_TAB.FULL_RESERVATION,
        sectionId: EXAM_STAGE_TAB_SECTION.FULL_RESERVATION,
        label: "STEP 1",
        name: "풀서비스 사전예약"
    },
    {
        id: EXAM_STAGE_TAB.REAL_TIME_RESTORE,
        sectionId: EXAM_STAGE_TAB_SECTION.REAL_TIME_RESTORE,
        label: "STEP 2",
        name: "실시간 기출복원"
    },
    {
        id: EXAM_STAGE_TAB.EXAM_REVIEW,
        sectionId: EXAM_STAGE_TAB_SECTION.EXAM_REVIEW,
        label: "STEP 3",
        name: "GSAT 응시후기"
    },
    {
        id: EXAM_STAGE_TAB.EXAM_VOTE,
        sectionId: EXAM_STAGE_TAB_SECTION.EXAM_VOTE,
        label: "STEP 4",
        name: "GSAT 난이도투표"
    },
    {
        id: EXAM_STAGE_TAB.PREDICTION_SCORE,
        sectionId: EXAM_STAGE_TAB_SECTION.PREDICTION_SCORE,
        label: "STEP 5",
        name: "가채점&합격예측"
    }, 
];
var EXAM_TAB_OPTIONS_MOBILE = [
    {
        id: EXAM_STAGE_TAB.FULL_RESERVATION,
        sectionId: EXAM_STAGE_TAB_SECTION.FULL_RESERVATION,
        label: "STEP 1",
        name: "풀서비스\n사전예약"
    },
    {
        id: EXAM_STAGE_TAB.REAL_TIME_RESTORE,
        sectionId: EXAM_STAGE_TAB_SECTION.REAL_TIME_RESTORE,
        label: "STEP 2",
        name: "실시간\n기출복원"
    },
    {
        id: EXAM_STAGE_TAB.EXAM_REVIEW,
        sectionId: EXAM_STAGE_TAB_SECTION.EXAM_REVIEW,
        label: "STEP 3",
        name: "GSAT\n응시후기"
    },
    {
        id: EXAM_STAGE_TAB.EXAM_VOTE,
        sectionId: EXAM_STAGE_TAB_SECTION.EXAM_VOTE,
        label: "STEP 4",
        name: "GSAT\n난이도\n투표"
    },
    {
        id: EXAM_STAGE_TAB.PREDICTION_SCORE,
        sectionId: EXAM_STAGE_TAB_SECTION.PREDICTION_SCORE,
        label: "STEP 5",
        name: "GSAT\n가채점&\n합격예측"
    }, 
];
var GSAT_2025_TAB_OPTIONS_MOBILE = [
    {
        id: EXAM_STAGE_TAB.FULL_RESERVATION,
        sectionId: EXAM_STAGE_TAB_SECTION.FULL_RESERVATION,
        label: "STEP 1",
        name: "풀서비스\n사전예약"
    },
    {
        id: EXAM_STAGE_TAB.REAL_TIME_RESTORE,
        sectionId: EXAM_STAGE_TAB_SECTION.REAL_TIME_RESTORE,
        label: "STEP 2",
        name: "실시간\n기출복원"
    },
    {
        id: EXAM_STAGE_TAB.EXAM_REVIEW,
        sectionId: EXAM_STAGE_TAB_SECTION.EXAM_REVIEW,
        label: "STEP 3",
        name: "GSAT\n응시후기"
    },
    {
        id: EXAM_STAGE_TAB.EXAM_VOTE,
        sectionId: EXAM_STAGE_TAB_SECTION.EXAM_VOTE,
        label: "STEP 4",
        name: "GSAT\n난이도 투표"
    },
    {
        id: EXAM_STAGE_TAB.PREDICTION_SCORE,
        sectionId: EXAM_STAGE_TAB_SECTION.PREDICTION_SCORE,
        label: "STEP 5",
        name: "가채점&\n합격예측"
    }, 
];


/***/ }),

/***/ 49546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ ExamContext; },
/* harmony export */   "_": function() { return /* binding */ ExamContextProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52737);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var hooks_useCurrentUser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38405);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15125);
/* harmony import */ var _gsat2024_2_components_alert_ExamAlert__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66263);
/* harmony import */ var _hooks_useGetIsPreReserved__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95200);










var ExamContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isAdmin: false,
    isLogin: false,
    isPreReserved: false,
    isReservationCompleted: false,
    handleCheckReservation: function() {}
});
var ExamContextProvider = function(param) {
    var children = param.children, companyId = param.companyId, termId = param.termId;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var user = (0,hooks_useCurrentUser__WEBPACK_IMPORTED_MODULE_4__/* .useCurrentUserContext */ .O)().user;
    var isMobile = (0,context__WEBPACK_IMPORTED_MODULE_2__/* .useUA */ .nD)().isMobile;
    var isPreReserved = (0,_hooks_useGetIsPreReserved__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        companyId: companyId,
        termId: termId
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isOpenAlert = ref[0], setIsOpenAlert = ref[1];
    var isReservationCompleted = !!router.query.testId;
    var isAdmin = !!(user === null || user === void 0 ? void 0 : user.isSuperuser);
    var isLogin = !!user;
    var confirmLoginAlert = function() {
        setIsOpenAlert(function() {
            return true;
        });
    };
    var handleClickCancel = function() {
        setIsOpenAlert(function() {
            return false;
        });
    };
    var handleClickConfirm = function() {
        if (isLogin) {
            router.replace({
                query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, router.query), {
                    tab: "full-reservation"
                }),
                hash: "#section1"
            }, undefined, {
                shallow: true
            });
            setIsOpenAlert(function() {
                return false;
            });
        } else {
            router.push({
                pathname: "/login",
                query: {
                    next: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_5__/* .LINKAREER_BASE_URL */ .dN).concat(router.pathname, "#section1")
                }
            });
        }
    };
    var handleCheckReservation = function(param) {
        var onReservated = param.onReservated, onNotReservated = param.onNotReservated;
        if (isReservationCompleted) {
            if (onReservated) {
                return onReservated();
            }
        } else {
            confirmLoginAlert();
            if (onNotReservated) {
                return onNotReservated();
            }
        }
    };
    var initialValue = {
        isAdmin: isAdmin,
        isLogin: isLogin,
        isPreReserved: isPreReserved,
        isReservationCompleted: isReservationCompleted,
        handleCheckReservation: handleCheckReservation
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ExamContext.Provider, {
        value: initialValue,
        children: [
            children,
            isOpenAlert && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_gsat2024_2_components_alert_ExamAlert__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                type: "confirm",
                message: isLogin ? "서비스 이용 신청이 완료되지 않았습니다.\n서비스 이용을 위해 신청을 먼저 진행해주세요." : "로그인이 필요한 서비스입니다.\n로그인 후 이용해주세요.",
                isMobile: isMobile,
                onClickConfirm: handleClickConfirm,
                onClickCloseModal: handleClickCancel
            })
        ]
    });
};



/***/ }),

/***/ 64015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Table_PredictionTable; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/components/Table/PredictionTableBody.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > tr {\n    &:first-child {\n      border-left: none;\n    }\n    &:last-child {\n      border-right: none;\n    }\n\n    > .basic-body {\n      padding: 14px 0px;\n      &:empty {\n        &::before {\n          content: '-';\n        }\n      }\n    }\n    > td {\n      border: 1px solid #eeeeee;\n      font-size: 16px;\n      font-weight: normal;\n      letter-spacing: -0.64px;\n      text-align: center;\n      color: #333;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var PredictionTableBody = function(param) {
    var tableDataList = param.tableDataList, tableColumns = param.tableColumns;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: tableDataList.map(function(data, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                children: tableColumns.map(function(column, index) {
                    return column.render ? /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        children: column.render(data)
                    }, "".concat(column.id, "-").concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: "basic-body",
                        children: data[column.dataIndex]
                    }, "".concat(column.id, "-").concat(index));
                })
            }, index);
        })
    });
};
/* harmony default export */ var Table_PredictionTableBody = (PredictionTableBody);
var StyledWrapper = styled_components_browser_esm/* default.tbody.withConfig */.ZP.tbody.withConfig({
    displayName: "PredictionTableBody__StyledWrapper",
    componentId: "sc-6634326-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/components/Table/PredictionTableHead.tsx

function PredictionTableHead_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > tr {\n    &:first-child {\n      border-left: none;\n    }\n    &:last-child {\n      border-right: none;\n    }\n\n    > th {\n      border-collapse: collapse;\n      border: 1px solid #eeeeee;\n      background-color: #fafafa;\n      text-align: center;\n      padding: 14px 0px;\n      font-size: 16px;\n      font-weight: 500;\n      letter-spacing: -0.64px;\n      color: #333;\n    }\n  }\n"
    ]);
    PredictionTableHead_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var PredictionTableHead = function(param) {
    var tableColumns = param.tableColumns;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictionTableHead_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
            children: tableColumns.map(function(column) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                    children: column.label
                }, column.id);
            })
        })
    });
};
/* harmony default export */ var Table_PredictionTableHead = (PredictionTableHead);
var PredictionTableHead_StyledWrapper = styled_components_browser_esm/* default.thead.withConfig */.ZP.thead.withConfig({
    displayName: "PredictionTableHead__StyledWrapper",
    componentId: "sc-430404f3-0"
})(PredictionTableHead_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/components/Table/PredictionTable.tsx

function PredictionTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  table-layout: fixed;\n  width: 100%;\n  border-top: 1px solid #eeeeee;\n  border-bottom: 1px solid #eeeeee;\n"
    ]);
    PredictionTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var PredictionTable = function(param) {
    var tableColumns = param.tableColumns, tableDataList = param.tableDataList, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PredictionTable_StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table_PredictionTableHead, {
                tableColumns: tableColumns
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table_PredictionTableBody, {
                tableDataList: tableDataList,
                tableColumns: tableColumns
            })
        ]
    });
};
/* harmony default export */ var Table_PredictionTable = (PredictionTable);
var PredictionTable_StyledWrapper = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    displayName: "PredictionTable__StyledWrapper",
    componentId: "sc-6da04a89-0"
})(PredictionTable_templateObject());


/***/ }),

/***/ 66263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30132);
/* harmony import */ var _app_components_Portal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20901);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100vw;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.7);\n    position: fixed;\n    top: 0;\n    z-index: 10000;\n    overflow-y: auto;\n\n    & > .alert-modal-content {\n      min-width: 340px;\n      padding: 45px 20px 40px;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      background-color: ",
        ";\n      border-radius: 20px;\n\n      & > p {\n        font-size: 20px;\n        font-weight: normal;\n        line-height: 1.5;\n        letter-spacing: -0.8px;\n        text-align: center;\n        color: ",
        ";\n        white-space: pre-wrap;\n        overflow-wrap: break-word;\n        margin-bottom: 30px;\n\n        &[data-device-type='mobile'] {\n          font-size: 16px;\n        }\n      }\n\n      & > .button-wrap {\n        height: 50px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 10px;\n        margin: 0 auto;\n\n        & > button {\n          width: 93px;\n          height: 50px;\n          padding: 13px 30px;\n          font-size: 16px;\n          font-weight: bold;\n          letter-spacing: -0.64px;\n          text-align: center;\n          color: #ffffff;\n          border: 0;\n          border-radius: 8px;\n          cursor: pointer;\n\n          &.button-cancel-route {\n            background-color: #bbbbbb;\n          }\n\n          &.button-change-route {\n            width: 102px;\n            background-color: ",
        ";\n          }\n        }\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ExamAlert = function(param) {
    var message = param.message, _type = param.type, type = _type === void 0 ? "alert" : _type, _buttonLabel = param.buttonLabel, buttonLabel = _buttonLabel === void 0 ? "확인" : _buttonLabel, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, onClickCloseModal = param.onClickCloseModal, onClickConfirm = param.onClickConfirm;
    var handleClickCloseModal = function() {
        if (onClickCloseModal) {
            onClickCloseModal();
        }
    };
    var handleClickConfirm = function() {
        onClickConfirm();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Portal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        id: "career-alert-modal",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("article", {
                className: "alert-modal-content",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        "data-device-type": isMobile ? "mobile" : "desktop",
                        children: message
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "button-wrap",
                        children: [
                            type === "confirm" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                type: "button",
                                className: "button-cancel-route",
                                onClick: handleClickCloseModal,
                                children: "취소"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                type: "button",
                                className: "button-change-route",
                                onClick: handleClickConfirm,
                                children: buttonLabel
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ExamAlert);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].aside.withConfig */ .ZP.aside.withConfig({
    displayName: "ExamAlert__StyledWrapper",
    componentId: "sc-6831a35f-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), theme.background.bg_8, theme.color.text_1, theme.color.primary_2);
});


/***/ }),

/***/ 69224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53893);
/* harmony import */ var _app_components_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85025);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 460px;\n  height: 76px;\n  border-radius: 10px;\n  gap: 4px;\n\n  .arrow-icon {\n    width: 18px;\n    height: 18px;\n  }\n\n  > span {\n    font-size: 22px;\n    font-weight: bold;\n    line-height: 1.95;\n    letter-spacing: -0.88px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var PredictionButton = function(_param) {
    var children = _param.children, _color = _param.color, color = _color === void 0 ? "prediction" : _color, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "color"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        color: color
    }, props), {
        endIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_2__/* .ArrowRight */ .ol, {
            className: "arrow-icon"
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
            children: children
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PredictionButton);
var StyledWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_app_components_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    displayName: "PredictionButton.desktop__StyledWrapper",
    componentId: "sc-66b7cc79-0"
})(_templateObject());


/***/ }),

/***/ 45285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PredictionButton_mobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
;// CONCATENATED MODULE: ./src/svgIcons/PredictionArrow.tsx



var PredictionArrow = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "17",
        viewBox: "0 0 17 17"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "오른쪽 화살표"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                d: "M0 0h17v17H0z",
                "data-name": "사각형 30017"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M6.78 4.287l4.984 4.984-4.984 4.984",
                "data-name": "패스 15793"
            })
        ]
    }));
};
/* harmony default export */ var svgIcons_PredictionArrow = (PredictionArrow);

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/components/button/PredictionButton.mobile.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 50px;\n  border-radius: 8px;\n  gap: 4px;\n\n  .arrow-icon {\n    width: 18px;\n    height: 18px;\n  }\n\n  > span {\n    font-size: 16px;\n    font-weight: bold;\n    letter-spacing: -0.64px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var PredictionButton = function(_param) {
    var children = _param.children, _color = _param.color, color = _color === void 0 ? "prediction" : _color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "color"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        color: color
    }, props), {
        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons_PredictionArrow, {
            className: "arrow-icon"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: children
        })
    }));
};
/* harmony default export */ var PredictionButton_mobile = (PredictionButton);
var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "PredictionButton.mobile__StyledWrapper",
    componentId: "sc-acf3e360-0"
})(_templateObject());


/***/ }),

/***/ 98722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ detailInfoTable_DetailInfoTable; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/components/detailInfoTable/DetailInfoTableBody.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > tr {\n    > td {\n      padding: 14px 0px;\n      font-size: 15px;\n      font-weight: 500;\n      letter-spacing: -0.6px;\n      text-align: center;\n      color: #333;\n      border: 1px solid #eeeeee;\n      border-collapse: collapse;\n\n      &:first-child {\n        border-left: 0;\n        background-color: #fafafa;\n      }\n\n      &:last-child {\n        border-right: 0;\n      }\n\n      &.correct-rate {\n        font-weight: bold;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var DetailInfoTableBody = function(param) {
    var tableDataList = param.tableDataList;
    if (!tableDataList) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: Object.keys(tableDataList).map(function(key) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        children: key === "math" ? "수리" : "추리"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                        children: [
                            ((ref = tableDataList[key]) === null || ref === void 0 ? void 0 : ref.correctCount) || 0,
                            "문항"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                        className: "correct-rate",
                        children: [
                            ((ref1 = tableDataList[key]) === null || ref1 === void 0 ? void 0 : ref1.answeredCount) || 0,
                            "문항"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                        children: [
                            ((ref2 = tableDataList[key]) === null || ref2 === void 0 ? void 0 : ref2.allUserAverageCorrectCount) || 0,
                            "문항"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                        className: "correct-rate",
                        children: [
                            ((ref3 = tableDataList[key]) === null || ref3 === void 0 ? void 0 : ref3.allUserAverageAnsweredCount) || 0,
                            "문항"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                        children: [
                            ((ref4 = tableDataList[key]) === null || ref4 === void 0 ? void 0 : ref4.top30UserAverageCorrectCount) || 0,
                            "문항"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                        className: "correct-rate",
                        children: [
                            ((ref5 = tableDataList[key]) === null || ref5 === void 0 ? void 0 : ref5.top30UserAverageAnsweredCount) || 0,
                            "문항"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                        children: [
                            ((ref6 = tableDataList[key]) === null || ref6 === void 0 ? void 0 : ref6.sameInfoAverageCorrectCount) || 0,
                            "문항"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                        className: "correct-rate",
                        children: [
                            ((ref7 = tableDataList[key]) === null || ref7 === void 0 ? void 0 : ref7.sameInfoAverageAnsweredCount) || 0,
                            "문항"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                        children: [
                            ((ref8 = tableDataList[key]) === null || ref8 === void 0 ? void 0 : ref8.top30SameInfoAverageCorrectCount) || 0,
                            "문항"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                        className: "correct-rate",
                        children: [
                            ((ref9 = tableDataList[key]) === null || ref9 === void 0 ? void 0 : ref9.top30SameInfoAverageAnsweredCount) || 0,
                            "문항"
                        ]
                    })
                ]
            }, key);
        })
    });
};
/* harmony default export */ var detailInfoTable_DetailInfoTableBody = (DetailInfoTableBody);
var StyledWrapper = styled_components_browser_esm/* default.tbody.withConfig */.ZP.tbody.withConfig({
    displayName: "DetailInfoTableBody__StyledWrapper",
    componentId: "sc-135ec8ff-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/components/detailInfoTable/DetailInfoTableHeader.tsx

function DetailInfoTableHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    & > tr {\n      background-color: ",
        ";\n\n      &:nth-child(2),\n      &:nth-child(3) {\n        height: 32px;\n      }\n\n      &:nth-child(4) {\n        height: 50px;\n      }\n\n      & > th {\n        padding: 8px 0px;\n        font-size: 15px;\n        font-weight: 500;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 1.47;\n        letter-spacing: -0.6px;\n        text-align: center;\n        color: ",
        ";\n        border-right: 1px solid #eeeeee;\n        border-top: 1px solid #eeeeee;\n        vertical-align: middle;\n\n        &:not([rowspan='4']):last-child {\n          border-right: 0;\n        }\n      }\n    }\n  "
    ]);
    DetailInfoTableHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var DetailInfoTableHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailInfoTableHeader_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        rowSpan: 4,
                        children: "구분"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                        rowSpan: 4,
                        children: [
                            "본인 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " 맞은 문항수"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                        rowSpan: 4,
                        children: [
                            "본인 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " 푼 문항수"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        colSpan: 4,
                        children: "전체 결과"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        colSpan: 4,
                        children: "지원 계열사/직무"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        colSpan: 2,
                        children: "응시자 평균"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        colSpan: 2,
                        children: "상위 30%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        colSpan: 2,
                        children: "응시자 평균"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        colSpan: 2,
                        children: "상위 30%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                        colSpan: 1,
                        children: [
                            "맞은 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " 문항수"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                        colSpan: 1,
                        children: [
                            "푼 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "문항수"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                        colSpan: 1,
                        children: [
                            "맞은 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "문항수"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                        colSpan: 1,
                        children: [
                            "푼 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "문항수"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                        colSpan: 1,
                        children: [
                            "맞은 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " 문항수"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                        colSpan: 1,
                        children: [
                            "푼 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "문항수"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                        colSpan: 1,
                        children: [
                            "맞은 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "문항수"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                        colSpan: 1,
                        children: [
                            "푼 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "문항수"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var detailInfoTable_DetailInfoTableHeader = (DetailInfoTableHeader);
var DetailInfoTableHeader_StyledWrapper = styled_components_browser_esm/* default.thead.withConfig */.ZP.thead.withConfig({
    displayName: "DetailInfoTableHeader__StyledWrapper",
    componentId: "sc-f764de6b-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(DetailInfoTableHeader_templateObject(), theme.background.bg_3, theme.color.text_1);
});

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/components/detailInfoTable/DetailInfoTable.tsx

function DetailInfoTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  table-layout: fixed;\n  width: 948px;\n  border-top: 1px solid #eeeeee;\n  border-bottom: 1px solid #eeeeee;\n\n  & > caption {\n    width: 0;\n    height: 0;\n    font-size: 0;\n  }\n"
    ]);
    DetailInfoTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var DetailInfoTable = function(param) {
    var tableDataList = param.tableDataList;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailInfoTable_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                children: "영역별 세부결과 분석"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        width: 158
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        width: 158
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        width: 158
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        width: 58
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        width: 58
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        width: 58
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        width: 58
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        width: 58
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        width: 58
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        width: 58
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailInfoTable_DetailInfoTableHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailInfoTable_DetailInfoTableBody, {
                tableDataList: tableDataList
            })
        ]
    });
};
/* harmony default export */ var detailInfoTable_DetailInfoTable = (DetailInfoTable);
var DetailInfoTable_StyledWrapper = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    displayName: "DetailInfoTable__StyledWrapper",
    componentId: "sc-85a8f75f-0"
})(DetailInfoTable_templateObject());


/***/ }),

/***/ 63174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tentativeScoringResultTable_TentativeScoringResultTable; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/context/TentativeScoringQuestionContext.tsx
var TentativeScoringQuestionContext = __webpack_require__(1074);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/components/tentativeScoringResultTable/TentativeScoringTableBody.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    & > tr {\n      height: 52px;\n\n      & > td {\n        height: 52px;\n        border: solid 1px #eeeeee;\n        border-collapse: collapse;\n        text-align: center;\n        vertical-align: middle;\n        font-weight: normal;\n        font-size: 16px;\n        line-height: 52px;\n        letter-spacing: -0.64px;\n        text-align: center;\n        color: ",
        ";\n\n        &:last-child {\n          border-right: 0;\n        }\n\n        &:first-child {\n          border-left: 0;\n        }\n\n        &.correct-answer {\n          color: #004eff;\n        }\n\n        &.cell-bold {\n          font-weight: 500;\n        }\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var answerNumberMap = [
    "①",
    "②",
    "③",
    "④",
    "⑤"
];
var TentativeScoringTableBody = function() {
    var examGradingQuestions = (0,react.useContext)(TentativeScoringQuestionContext/* TentativeScoringQuestionContext */.A).examGradingQuestions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: examGradingQuestions === null || examGradingQuestions === void 0 ? void 0 : examGradingQuestions.map(function(question) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: "cell-bold",
                        children: question.seq.toString().padStart(2, "0")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: "cell-bold",
                        children: answerNumberMap[question.answers[0] - 1]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: "cell-bold ".concat(question.answers[0] === question.userAnswers[0] ? "correct-answer" : ""),
                        children: answerNumberMap[question.userAnswers[0] - 1]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                        children: [
                            question.statistics[0].rate,
                            "%"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                        children: [
                            question.statistics[1].rate,
                            "%"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                        children: [
                            question.statistics[2].rate,
                            "%"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                        children: [
                            question.statistics[3].rate,
                            "%"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                        children: [
                            question.statistics[4].rate,
                            "%"
                        ]
                    })
                ]
            }, "exam-grading-question-".concat(question.subject, "-id-").concat(question.seq));
        })
    });
};
/* harmony default export */ var tentativeScoringResultTable_TentativeScoringTableBody = (TentativeScoringTableBody);
var StyledWrapper = styled_components_browser_esm/* default.tbody.withConfig */.ZP.tbody.withConfig({
    displayName: "TentativeScoringTableBody__StyledWrapper",
    componentId: "sc-4eafcfc8-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.color.text_1);
});

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/components/tentativeScoringResultTable/TentativeScoringTableHeader.tsx

function TentativeScoringTableHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > tr {\n    &:first-child {\n      & > th:first-child {\n        border-left: 0;\n      }\n    }\n\n    > th {\n      height: 52px;\n      background-color: #fafafa;\n      border: solid 1px #eeeeee;\n      border-collapse: collapse;\n      font-size: 16px;\n      font-weight: 500;\n      letter-spacing: -0.64px;\n      text-align: center;\n      vertical-align: middle;\n      color: #333;\n\n      &:last-child {\n        border-right: 0;\n      }\n    }\n  }\n"
    ]);
    TentativeScoringTableHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TentativeScoringTableHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TentativeScoringTableHeader_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        rowSpan: 3,
                        children: "문항 번호"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        rowSpan: 3,
                        children: "복원 답안"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        rowSpan: 3,
                        children: "내 답안"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                    colSpan: 5,
                    children: "응시자 선택 비율"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        children: "①"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        children: "②"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        children: "③"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        children: "④"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        children: "⑤"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var tentativeScoringResultTable_TentativeScoringTableHeader = (TentativeScoringTableHeader);
var TentativeScoringTableHeader_StyledWrapper = styled_components_browser_esm/* default.thead.withConfig */.ZP.thead.withConfig({
    displayName: "TentativeScoringTableHeader__StyledWrapper",
    componentId: "sc-3e8ddedb-0"
})(TentativeScoringTableHeader_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/components/tentativeScoringResultTable/TentativeScoringResultTable.tsx

function TentativeScoringResultTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 820px;\n\n  & > caption {\n    width: 0;\n    height: 0;\n    font-size: 0;\n  }\n"
    ]);
    TentativeScoringResultTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var TentativeScoringResultTable = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TentativeScoringResultTable_StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                children: "영역별 응시자 답안 선택 비율"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        width: 136
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        width: 136
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        width: 136
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        width: 82
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        width: 82
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        width: 82
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        width: 82
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        width: 82
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tentativeScoringResultTable_TentativeScoringTableHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tentativeScoringResultTable_TentativeScoringTableBody, {})
        ]
    });
};
/* harmony default export */ var tentativeScoringResultTable_TentativeScoringResultTable = (TentativeScoringResultTable);
var TentativeScoringResultTable_StyledWrapper = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    displayName: "TentativeScoringResultTable__StyledWrapper",
    componentId: "sc-134c30fb-0"
})(TentativeScoringResultTable_templateObject());


/***/ }),

/***/ 1170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ANSWER_NUMVER_MAP; }
/* harmony export */ });
var ANSWER_NUMVER_MAP = [
    "①",
    "②",
    "③",
    "④",
    "⑤"
];


/***/ }),

/***/ 38706:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var DEFAULT_TEST_ID = "1";
/* harmony default export */ __webpack_exports__["Z"] = (DEFAULT_TEST_ID);


/***/ }),

/***/ 90152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ preReservationSchema; }
/* harmony export */ });
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16310);

var preReservationSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    companyId: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required(),
    termId: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required(),
    subsidiaryId: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required(),
    departmentId: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required(),
    jobId: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required(),
    testId: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required(),
    phoneNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().test({
        name: "is-valid-number",
        test: function(phoneNumber) {
            var isEmpty = !phoneNumber;
            if (isEmpty) {
                return true;
            }
            var onlyNumber = phoneNumber.replace(/-/g, "");
            var isLength = onlyNumber.length === 11 || onlyNumber.length === 10;
            return isLength;
        }
    }).required(),
    hasAgreedToPrivacy: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().test("is-agreed-to-privacy", function(value) {
        return value === true;
    })
});


/***/ }),

/***/ 83958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ GSAT_CHAT_ROOM_NAME; }
/* harmony export */ });
var GSAT_CHAT_ROOM_NAME = "삼성 GSAT 시험논의";


/***/ }),

/***/ 63374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OR": function() { return /* binding */ ERROR_PHONE_NUMBER_REQUIRED; },
/* harmony export */   "YI": function() { return /* binding */ ERROR_AGREE_TO_PRIVACY_REQUIRED; },
/* harmony export */   "ZP": function() { return /* binding */ SUCCES_UPDATE_MESSAGE; },
/* harmony export */   "nS": function() { return /* binding */ SUCCESS_MESSAGE; },
/* harmony export */   "u5": function() { return /* binding */ ERROR_ALL_FIELDS_REQUIRED; }
/* harmony export */ });
var SUCCESS_MESSAGE = "신청이 완료되었습니다. 삼성 GSAT 합격을 기원합니다.";
var SUCCES_UPDATE_MESSAGE = "신청 정보 수정이 완료되었습니다.";
var ERROR_AGREE_TO_PRIVACY_REQUIRED = "개인정보 수집/이용 및 마케팅 수신\n동의가 필요합니다.\n동의 체크를 완료 해주세요.";
var ERROR_ALL_FIELDS_REQUIRED = "모든 입력란은 필수적으로 입력해야 합니다.";
var ERROR_PHONE_NUMBER_REQUIRED = "전화번호를 입력해주세요.";


/***/ }),

/***/ 96826:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var QUESTION_SUBJECT_MAP = {
    "1": "suri",
    "2": "churi"
};
/* harmony default export */ __webpack_exports__["Z"] = (QUESTION_SUBJECT_MAP);


/***/ }),

/***/ 56599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SPREAD_SCORE_INFO_REQUEST_INPUT_SCORE_RANGES; },
/* harmony export */   "v": function() { return /* binding */ STEP_FIVE_STAGE; }
/* harmony export */ });
var STEP_FIVE_STAGE = {
    INPUT_ANSWER: "INPUT_ANSWER",
    RESULT: "RESULT",
    REPORT: "REPORT"
};
var SPREAD_SCORE_INFO_REQUEST_INPUT_SCORE_RANGES = [
    {
        from: 0,
        to: 6
    },
    {
        from: 7,
        to: 12
    },
    {
        from: 13,
        to: 18
    },
    {
        from: 19,
        to: 24
    },
    {
        from: 25,
        to: 30
    },
    {
        from: 31,
        to: 36
    },
    {
        from: 37
    }, 
];


/***/ }),

/***/ 10937:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var SUBJECT_MAX_QUESTION_COUNT = {
    suri: 20,
    churi: 30
};
/* harmony default export */ __webpack_exports__["Z"] = (SUBJECT_MAX_QUESTION_COUNT);


/***/ }),

/***/ 91181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ TAB_LIST; }
/* harmony export */ });
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);

var TAB_LIST = [
    {
        id: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ExamSubject.MATH */ .rHe.MATH,
        label: "수리 영역"
    },
    {
        id: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ExamSubject.REASONING */ .rHe.REASONING,
        label: "추리 영역"
    }, 
];


/***/ }),

/***/ 87552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ PredictionOfPassedContainerContext; },
/* harmony export */   "x": function() { return /* binding */ PredictionOfPassedContainerContextProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44119);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(graphql_tag__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47079);
/* harmony import */ var _app_feature_exam_gsat2024_2_constants_defaultTestId__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38706);
/* harmony import */ var _constants_stepFive_constant__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56599);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment PredictionOfPassedContainer_examReserveInformation on ExamReserveInformation {\n    ...TestUserInfoArticle_examReserveInformation\n    hasAgreedToPrivacy\n  }\n\n  fragment PredictionOfPassedContainer_examGradingResult on ExamGradingResult {\n    allExamGradingResultOfSameInfo: examGradingResultOfSameInfo(type: $type) {\n      answeredCount\n      correctCount\n      correctRate\n      detail {\n        answeredCount\n        correctCount\n        correctRate\n        subject\n        totalCount\n      }\n    }\n    subsidiaryJobExamGradingResultOfSameInfo: examGradingResultOfSameInfo(\n      type: $subsidiaryJobExamGradingResultOfSameInfoType\n    ) {\n      answeredCount\n      correctCount\n      correctRate\n      detail {\n        answeredCount\n        correctCount\n        correctRate\n        subject\n        totalCount\n      }\n    }\n    averageScore: examGradingResultOfSameInfoFromTest(type: $averageScoreType) {\n      answeredCount\n      correctRate\n      correctCount\n    }\n    sameInfoAverage: examGradingResultOfSameInfoFromTest(\n      type: $sameInfoAverageType\n    ) {\n      answeredCount\n      correctRate\n      correctCount\n    }\n    overallExamGradingResult {\n      answeredCount\n      correctCount\n      correctRate\n      detail {\n        answeredCount\n        correctCount\n        correctRate\n        subject\n        totalCount\n      }\n    }\n    subsidiaryJobtop30percentExamGradingResultOfSameInfo: top30percentExamGradingResultOfSameInfo(\n      type: $top30PercentExamGradingResultOfSameInfoType2\n    ) {\n      answeredCount\n      correctCount\n      correctRate\n      detail {\n        answeredCount\n        correctCount\n        correctRate\n        subject\n        totalCount\n      }\n    }\n    top30percentOfOverallExamGradingResult {\n      answeredCount\n      correctCount\n      correctRate\n      detail {\n        answeredCount\n        correctCount\n        correctRate\n        subject\n        totalCount\n      }\n    }\n    subsidiaryJobViewerRankOfSameInfo: viewerRankOfSameInfo(\n      type: $subsidiaryJobViewerRankOfSameInfoType\n    )\n    ...SynthesisScoreInfoArticle_examGradingResult\n  }\n\n  fragment PredictionOfPassedContainer_examGradingResultDistribution on ExamGradingResultDistribution {\n    range\n    rate\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







graphql_tag__WEBPACK_IMPORTED_MODULE_3___default()(_templateObject());
var PredictionOfPassedContainerContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({
    isLoading: false,
    companyId: "",
    termId: ""
});
var PredictionOfPassedContainerContextProvider = function(param) {
    var children = param.children, companyId = param.companyId, termId = param.termId;
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var shouldFetchRankData = router.pathname !== "/prediction/gsat2024-2";
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .useGqlExamGradingResultLazyQuery */ .tJD)(), 2), examGradingResult = ref2[0], ref3 = ref2[1], examGradingResultData = ref3.data, gradingResultLoading = ref3.loading;
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .useGqlExamGradingRankFromTestLazyQuery */ .aqd)({
        fetchPolicy: "no-cache"
    }), 2), examGradingRankFromTest = ref4[0], ref5 = ref4[1], examGradingRankFromTestRate = ref5.data;
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .useGqlExamGradingRankOfSameInfoFromTestLazyQuery */ .eSe)({
        fetchPolicy: "no-cache"
    }), 2), examGradingRankOfSameInfoFromTest = ref6[0], ref7 = ref6[1], examGradingRankOfSameInfoFromTestRate = ref7.data;
    var ref8 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .useGqlExamGradingResultDistributionAllDataLazyQuery */ .H83)(), 2), examGradingResultDistributionAll = ref8[0], ref9 = ref8[1], examGradingResultDistributionAllData = ref9.data, examGradingResultDistributionAllLoading = ref9.loading;
    var ref10 = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .useGqlViewerExamReserveInformationInResultQuery */ .ZKX)({
        variables: {
            input: {
                companyId: companyId,
                termId: termId
            }
        },
        fetchPolicy: "network-only",
        onCompleted: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(data) {
                var ref, ref1, ref2, ref3, ref4;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                    examGradingResult({
                        variables: {
                            testId: ((ref = data.viewerExamReserveInformation) === null || ref === void 0 ? void 0 : ref.examTest.id) || _app_feature_exam_gsat2024_2_constants_defaultTestId__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z,
                            subsidiaryJobExamGradingResultOfSameInfoType: generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .SameExamInfoType.SUBSIDIARY_JOB */ .OXr.SUBSIDIARY_JOB,
                            type: generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .SameExamInfoType.ALL */ .OXr.ALL,
                            viewerRankOfSameInfoType2: generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .SameExamInfoType.SUBSIDIARY_JOB */ .OXr.SUBSIDIARY_JOB,
                            top30PercentExamGradingResultOfSameInfoType2: generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .SameExamInfoType.SUBSIDIARY_JOB */ .OXr.SUBSIDIARY_JOB,
                            averageScoreType: generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .SameExamInfoType.ALL */ .OXr.ALL,
                            sameInfoAverageType: generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .SameExamInfoType.SUBSIDIARY_JOB */ .OXr.SUBSIDIARY_JOB,
                            subsidiaryJobViewerRankOfSameInfoType: generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .SameExamInfoType.SUBSIDIARY_JOB */ .OXr.SUBSIDIARY_JOB
                        },
                        fetchPolicy: "network-only"
                    });
                    examGradingResultDistributionAll({
                        variables: {
                            inputAllInfo: {
                                scoreRanges: _constants_stepFive_constant__WEBPACK_IMPORTED_MODULE_6__/* .SPREAD_SCORE_INFO_REQUEST_INPUT_SCORE_RANGES */ .Z,
                                testId: ((ref1 = data.viewerExamReserveInformation) === null || ref1 === void 0 ? void 0 : ref1.examTest.id) || _app_feature_exam_gsat2024_2_constants_defaultTestId__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z
                            },
                            inputSameInfo: {
                                scoreRanges: _constants_stepFive_constant__WEBPACK_IMPORTED_MODULE_6__/* .SPREAD_SCORE_INFO_REQUEST_INPUT_SCORE_RANGES */ .Z,
                                testId: ((ref2 = data.viewerExamReserveInformation) === null || ref2 === void 0 ? void 0 : ref2.examTest.id) || _app_feature_exam_gsat2024_2_constants_defaultTestId__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z
                            }
                        },
                        fetchPolicy: "network-only"
                    });
                    if (shouldFetchRankData) {
                        ;
                        examGradingRankFromTest({
                            variables: {
                                testId: ((ref3 = data.viewerExamReserveInformation) === null || ref3 === void 0 ? void 0 : ref3.examTest.id) || _app_feature_exam_gsat2024_2_constants_defaultTestId__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z
                            }
                        });
                        examGradingRankOfSameInfoFromTest({
                            variables: {
                                testId: ((ref4 = data.viewerExamReserveInformation) === null || ref4 === void 0 ? void 0 : ref4.examTest.id) || _app_feature_exam_gsat2024_2_constants_defaultTestId__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z
                            }
                        });
                    }
                    return [
                        2
                    ];
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }()
    }), examReserveInformationData = ref10.data, reserveInfomationLoading = ref10.loading;
    var ref11 = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .useGqlExamTestsQuery */ .nsG)({
        variables: {
            input: {
                companyId: companyId,
                termId: termId
            }
        }
    }), examTestsData = ref11.data, examTestLoading = ref11.loading;
    var ref12, ref13;
    var initialValue = {
        examReserveInformation: examReserveInformationData === null || examReserveInformationData === void 0 ? void 0 : examReserveInformationData.viewerExamReserveInformation,
        examGradingResultData: examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.examGradingResult,
        examTestsData: examTestsData === null || examTestsData === void 0 ? void 0 : examTestsData.examTests,
        examGradingResultDistribution: examGradingResultDistributionAllData === null || examGradingResultDistributionAllData === void 0 ? void 0 : examGradingResultDistributionAllData.examGradingResultDistribution,
        examGradingResultDistributionSameInfo: examGradingResultDistributionAllData === null || examGradingResultDistributionAllData === void 0 ? void 0 : examGradingResultDistributionAllData.examGradingResultDistributionSameInfo,
        examGradingRankFromTestRate: (ref12 = examGradingRankFromTestRate === null || examGradingRankFromTestRate === void 0 ? void 0 : examGradingRankFromTestRate.examGradingRankFromTest) !== null && ref12 !== void 0 ? ref12 : examGradingResultData === null || examGradingResultData === void 0 ? void 0 : (ref = examGradingResultData.examGradingResult) === null || ref === void 0 ? void 0 : ref.viewerRank,
        examGradingRankOfSameInfoFromTestRate: (ref13 = examGradingRankOfSameInfoFromTestRate === null || examGradingRankOfSameInfoFromTestRate === void 0 ? void 0 : examGradingRankOfSameInfoFromTestRate.examGradingRankOfSameInfoFromTest) !== null && ref13 !== void 0 ? ref13 : examGradingResultData === null || examGradingResultData === void 0 ? void 0 : (ref1 = examGradingResultData.examGradingResult) === null || ref1 === void 0 ? void 0 : ref1.viewerRankOfSameInfo,
        isLoading: reserveInfomationLoading || gradingResultLoading || examTestLoading || examGradingResultDistributionAllLoading,
        companyId: companyId,
        termId: termId
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PredictionOfPassedContainerContext.Provider, {
        value: initialValue,
        children: children
    });
};



/***/ }),

/***/ 1074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TentativeScoringQuestionContext; },
/* harmony export */   "S": function() { return /* binding */ TentativeScoringQuestionContextProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47079);
/* harmony import */ var _app_feature_exam_gsat2024_2_constants_defaultTestId__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38706);
/* harmony import */ var _constants_stepFive_constant__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56599);








var TentativeScoringQuestionContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    subject: "math",
    isQuestionOpen: false
});
var TentativeScoringQuestionContextProvider = function(param) {
    var onChangeStage = param.onChangeStage, children = param.children, defaultTestId = param.defaultTestId;
    var ref, ref1;
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().query;
    var data = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_3__/* .useGqlExamGradingQuestionsQuery */ .eh9)({
        variables: {
            mathInput: {
                subject: generated_graphql__WEBPACK_IMPORTED_MODULE_3__/* .ExamSubject.MATH */ .rHe.MATH,
                testId: ((ref = query.testId) === null || ref === void 0 ? void 0 : ref.toString()) || defaultTestId || _app_feature_exam_gsat2024_2_constants_defaultTestId__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z
            },
            reasoningInput: {
                subject: generated_graphql__WEBPACK_IMPORTED_MODULE_3__/* .ExamSubject.REASONING */ .rHe.REASONING,
                testId: ((ref1 = query.testId) === null || ref1 === void 0 ? void 0 : ref1.toString()) || defaultTestId || _app_feature_exam_gsat2024_2_constants_defaultTestId__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z
            }
        },
        fetchPolicy: "network-only"
    }).data;
    var handleChangeResultStage = function() {
        if (onChangeStage) {
            onChangeStage(_constants_stepFive_constant__WEBPACK_IMPORTED_MODULE_4__/* .STEP_FIVE_STAGE.RESULT */ .v.RESULT);
        }
    };
    var handleChangeInputAnswerStage = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                if (onChangeStage) {
                    onChangeStage(_constants_stepFive_constant__WEBPACK_IMPORTED_MODULE_4__/* .STEP_FIVE_STAGE.INPUT_ANSWER */ .v.INPUT_ANSWER);
                }
                return [
                    2
                ];
            });
        });
        return function handleChangeInputAnswerStage() {
            return _ref.apply(this, arguments);
        };
    }();
    var subject = query.subject ? query.subject.toLowerCase() : "math";
    var isQuestionOpen = (data === null || data === void 0 ? void 0 : data.math.length) === 20 && (data === null || data === void 0 ? void 0 : data.reasoning.length) === 30;
    var initialValue = {
        subject: subject,
        isQuestionOpen: isQuestionOpen,
        examGradingQuestions: subject === "math" ? data === null || data === void 0 ? void 0 : data.math : data === null || data === void 0 ? void 0 : data.reasoning,
        examGradingQuestionData: data,
        handleChangeResultStage: handleChangeResultStage,
        handleChangeInputAnswerStage: handleChangeInputAnswerStage
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TentativeScoringQuestionContext.Provider, {
        value: initialValue,
        children: data && children
    });
};



/***/ }),

/***/ 31698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 182px;\n    height: 12px;\n    border-radius: 6px;\n    background-color: #eeeeee;\n    position: relative;\n    overflow: hidden;\n    margin: 0 auto;\n\n    &::after {\n      content: '';\n      width: 100%;\n      height: 100%;\n      background-color: ",
        ";\n      border-radius: 6px;\n      animation: loadingAnimation 1s infinite ease-in-out;\n      position: absolute;\n      top: 0;\n      left: -100%;\n      will-change: left, animation;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @keyframes loadingAnimation {\n    0% {\n      left: -100%;\n    }\n    100% {\n      left: 100%;\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var ExternalLoading = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (ExternalLoading);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ExternalLoading__StyledWrapper",
    componentId: "sc-45b2fbf4-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), theme.color.primary_2);
});


/***/ }),

/***/ 92229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30132);
/* harmony import */ var _app_components_Portal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20901);
/* harmony import */ var _ExternalLoading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31698);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    z-index: 500;\n    top: 0;\n    left: 0;\n    background: rgba(0, 0, 0, 0.7);\n\n    & > .popup-content {\n      width: 280px;\n      height: 300px;\n      background-color: ",
        ";\n      border-radius: 20px;\n      padding: 40px;\n      position: absolute;\n      z-index: 600;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n\n      & > strong {\n        width: 100%;\n        height: 26px;\n        font-size: 18px;\n        font-weight: bold;\n        line-height: 26px;\n        letter-spacing: -0.72px;\n        text-align: center;\n        color: ",
        ";\n        margin-bottom: 8px;\n        display: block;\n      }\n\n      & > p.loading-description {\n        // 전역으로 잡힌 스타일보다 우선순위를 높게 잡아야 합니다\n        height: 40px;\n        font-size: 14px;\n        font-weight: normal;\n        line-height: 20px;\n        letter-spacing: -0.56px;\n        text-align: center;\n        color: ",
        ";\n        margin-bottom: 20px;\n      }\n\n      & > .loading-image-wrapper {\n        width: 140px;\n        height: 140px;\n        margin: 0 auto 20px;\n\n        & > figure {\n          width: 100%;\n          height: 100%;\n          margin: 0;\n          padding: 0;\n\n          & > figcaption {\n            width: 0;\n            height: 0;\n            font-size: 0;\n          }\n        }\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ResultLoadingPopup = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Portal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        id: "result-loading-popup",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "popup-content",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                        children: "결과를 불러오고 있습니다."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "loading-image-wrapper",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("figure", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("figcaption", {
                                    children: "결과 요청 로딩 팝업"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "/static/images/career/external_data_loading.png",
                                    width: 140,
                                    height: 140,
                                    alt: "결과 요청 로딩"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ExternalLoading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ResultLoadingPopup);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].article.withConfig */ .ZP.article.withConfig({
    displayName: "ResultLoadingPopup__StyledWrapper",
    componentId: "sc-317be04a-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject(), theme.background.bg_8, theme.color.text_1, theme.color.text_1);
});


/***/ }),

/***/ 60226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ radio_AnswerRadioButtonGroup; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/components/radio/AnswerRadioButton.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    & > input[type='radio'] {\n      display: none;\n\n      &:checked + label {\n        background-color: #01a0ff;\n        border: 1px solid #01a0ff;\n        color: #fff;\n      }\n    }\n\n    > label {\n      width: 32px;\n      height: 32px;\n      border: solid 1px ",
        ";\n      border-radius: 8px;\n      background-color: ",
        ";\n      color: ",
        ";\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      cursor: pointer;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var AnswerRadioButton = /*#__PURE__*/ (0,react.forwardRef)(function(_param, radioRef) {
    var id = _param.id, label = _param.label, restRadioProps = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "label"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                ref: radioRef,
                id: id,
                type: "radio"
            }, restRadioProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: id,
                children: label
            })
        ]
    });
});
/* harmony default export */ var radio_AnswerRadioButton = (AnswerRadioButton);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AnswerRadioButton__StyledWrapper",
    componentId: "sc-82093872-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.line.line_2, theme.background.bg_8, theme.color.text_1);
});

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/components/radio/AnswerRadioButtonGroup.tsx



function AnswerRadioButtonGroup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"
    ]);
    AnswerRadioButtonGroup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var AnswerRadioButtonGroup = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var id = _param.id, userAnswer = _param.userAnswer, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "userAnswer"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerRadioButtonGroup_StyledWrapper, {
        children: new Array(5).fill(0).map(function(_, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_AnswerRadioButton, (0,_object_spread/* default */.Z)({
                ref: ref,
                id: "".concat(id, "-").concat(index),
                value: index + 1,
                label: index + 1,
                defaultChecked: userAnswer === index + 1
            }, restProps), "".concat(id, "-").concat(index));
        })
    });
});
/* harmony default export */ var radio_AnswerRadioButtonGroup = (AnswerRadioButtonGroup);
var AnswerRadioButtonGroup_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AnswerRadioButtonGroup__StyledWrapper",
    componentId: "sc-2bc7d0b-0"
})(AnswerRadioButtonGroup_templateObject());


/***/ }),

/***/ 48659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ calculateAgeFromTimestamp; },
/* harmony export */   "U": function() { return /* binding */ parseTestResultDate; }
/* harmony export */ });
/* harmony import */ var _app_feature_exam_modules__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5143);

var parseTestResultDate = function(params) {
    var dateList = params.dateList, formatType = params.formatType, testId = params.testId;
    var userTestDate = dateList.filter(function(date) {
        return date.id === testId;
    })[0];
    if (!userTestDate) {
        return "";
    }
    if (formatType === "kor") {
        return (0,_app_feature_exam_modules__WEBPACK_IMPORTED_MODULE_0__/* .formatKorDate */ .U1)(userTestDate.date);
    } else {
        return (0,_app_feature_exam_modules__WEBPACK_IMPORTED_MODULE_0__/* .formatToCustomDate */ .nZ)(userTestDate.date);
    }
};
/**
 * @desc 타임스탬프를 받아서 만 나이를 계산하여 반환합니다
 * @param birthdateTimestamp
 */ var calculateAgeFromTimestamp = function(birthdateTimestamp) {
    if (!birthdateTimestamp) return "-";
    var today = new Date();
    var birthDate = new Date(birthdateTimestamp);
    var date = (0,_app_feature_exam_modules__WEBPACK_IMPORTED_MODULE_0__/* .parseAcquiredDate */ .AR)(birthdateTimestamp);
    var thisYearsBirthday = new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate());
    var age = today.getFullYear() - birthDate.getFullYear() - (today < thisYearsBirthday ? 1 : 0 // 생일이 지났는지 여부에 따라 -1, 0
    );
    return "".concat(date, " (").concat(age, "세)");
};


/***/ }),

/***/ 49359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PassedInfoBox_desktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.feature/exam/hooks/useIsGsat2025SecondRoute.ts
var useIsGsat2025SecondRoute = __webpack_require__(51128);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/passed/TestInfoLayout.desktop.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  > strong {\n    font-size: 22px;\n    font-weight: bold;\n    letter-spacing: -0.88px;\n    text-align: left;\n    color: #333;\n  }\n\n  > .sub-text {\n    font-size: 15px;\n    font-weight: normal;\n    line-height: 1.47;\n    letter-spacing: -0.6px;\n    color: #333;\n    margin-top: 8px;\n  }\n\n  > .info-content {\n    margin-top: 24px;\n  }\n\n  > .guide-text {\n    font-size: 15px;\n    font-weight: normal;\n    line-height: 1.47;\n    letter-spacing: -0.6px;\n    color: #666666;\n    margin-top: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var TestInfoLayoutDesktop = function(param) {
    var title = param.title, children = param.children, subText = param.subText, guideText = param.guideText, className = param.className, _isDisplayedCorrectRate = param.isDisplayedCorrectRate, isDisplayedCorrectRate = _isDisplayedCorrectRate === void 0 ? false : _isDisplayedCorrectRate;
    var isGsat2025SecondRoute = (0,useIsGsat2025SecondRoute/* useIsGsat2025SecondRoute */.L)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: title
            }),
            subText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "sub-text",
                children: subText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "info-content",
                children: children
            }),
            guideText && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "guide-text",
                children: [
                    "※ ",
                    guideText
                ]
            }),
            isGsat2025SecondRoute && isDisplayedCorrectRate && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "guide-text",
                children: "※ 정답률은 맞은 문항 수 / 푼 문항 수를 백분율로 나타낸 값입니다."
            })
        ]
    });
};
/* harmony default export */ var TestInfoLayout_desktop = (TestInfoLayoutDesktop);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TestInfoLayout.desktop__StyledWrapper",
    componentId: "sc-af069ed4-0"
})(_templateObject());

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/context/PredictionOfPassedContainerContext.tsx
var PredictionOfPassedContainerContext = __webpack_require__(87552);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/modules/testResult.module.ts
var testResult_module = __webpack_require__(86690);
// EXTERNAL MODULE: ./src/svgIcons/UpDownIcon.tsx
var UpDownIcon = __webpack_require__(83396);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/passed/circleInfo/CircleInfoItem.desktop.tsx

function CircleInfoItem_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n\n  > .info-circle {\n    width: 224px;\n    height: 224px;\n    border: solid 1px #e8e8e8;\n    background-color: #fff;\n    border-radius: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 16px;\n\n    > p {\n      font-size: 18px;\n      font-weight: 500;\n      line-height: 1.33;\n      letter-spacing: -0.72px;\n      text-align: center;\n      color: #333;\n      white-space: pre-wrap;\n    }\n\n    > .percent-box {\n      display: flex;\n      align-items: center;\n      color: #004eff;\n\n      > span {\n        font-size: 28px;\n        font-weight: bold;\n        letter-spacing: -1.12px;\n        text-align: center;\n      }\n\n      &[data-is-up='true'] {\n        color: #ef2929;\n      }\n    }\n  }\n\n  > p {\n    font-size: 15px;\n    font-weight: normal;\n    line-height: 1.33;\n    letter-spacing: -0.6px;\n    text-align: center;\n    color: #666666;\n    > span {\n      display: block;\n      font-weight: 500;\n    }\n  }\n"
    ]);
    CircleInfoItem_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var CircleInfoItemDesktop = function(param) {
    var averagePercent = param.averagePercent, averageText = param.averageText, infoTitle = param.infoTitle, userPercent = param.userPercent;
    var isUp = userPercent >= 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CircleInfoItem_desktop_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "info-circle",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: infoTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "percent-box",
                        "data-is-up": isUp,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    Math.abs(userPercent),
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UpDownIcon/* default */.Z, {
                                isUp: isUp
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    averageText,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            averagePercent,
                            "문항"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CircleInfoItem_desktop = (CircleInfoItemDesktop);
var CircleInfoItem_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CircleInfoItem.desktop__StyledWrapper",
    componentId: "sc-f01619eb-0"
})(CircleInfoItem_desktop_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/passed/circleInfo/CircleInfoArticle.desktop.tsx


function CircleInfoArticle_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 48px 56px;\n  border-radius: 10px;\n  background-color: #ffffff;\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    CircleInfoArticle_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var CircleInfoArticleDesktop = function() {
    var ref = (0,react.useContext)(PredictionOfPassedContainerContext/* PredictionOfPassedContainerContext */.K), examGradingResultData = ref.examGradingResultData, isLoading = ref.isLoading;
    if (isLoading) return null;
    var compareOverrallGradingRate = (0,testResult_module/* compareCorrectRates */._)((examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.correctRate) || 0, (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.overallExamGradingResult.correctRate) || 0);
    var compareTop30PercentGradingRate = (0,testResult_module/* compareCorrectRates */._)((examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.correctRate) || 0, (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.top30percentOfOverallExamGradingResult.correctRate) || 0);
    var compareSameInfoGradingRate = (0,testResult_module/* compareCorrectRates */._)((examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.correctRate) || 0, (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.subsidiaryJobExamGradingResultOfSameInfo.correctRate) || 0);
    var CICLE_INFO_DATA = [
        {
            infoTitle: "전체 응시생 \n평균 맞은 문항 수보다 약",
            userPercent: compareOverrallGradingRate,
            averageText: "전체 응시생 평균 맞은 문항수",
            averagePercent: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.overallExamGradingResult.correctCount) || 0
        },
        {
            infoTitle: "상위 30% 응시생 \n평균 맞은 문항 수보다 약",
            userPercent: compareTop30PercentGradingRate,
            averageText: "상위 30% 응시생 평균 맞은 문항수",
            averagePercent: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.top30percentOfOverallExamGradingResult.correctCount) || 0
        },
        {
            infoTitle: "동일 계열사/직무 응시생\n평균 맞은 문항 수보다 약",
            userPercent: compareSameInfoGradingRate,
            averageText: "동일 계열사/직무 응시생 평균 맞은 문항수",
            averagePercent: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.subsidiaryJobExamGradingResultOfSameInfo.correctCount) || 0
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleInfoArticle_desktop_StyledWrapper, {
        children: CICLE_INFO_DATA.map(function(data, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleInfoItem_desktop, (0,_object_spread/* default */.Z)({}, data), "circle-info-item-id-".concat(index));
        })
    });
};
/* harmony default export */ var CircleInfoArticle_desktop = (CircleInfoArticleDesktop);
var CircleInfoArticle_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CircleInfoArticle.desktop__StyledWrapper",
    componentId: "sc-40456a4f-0"
})(CircleInfoArticle_desktop_templateObject());

// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/components/detailInfoTable/DetailInfoTable.tsx + 2 modules
var DetailInfoTable = __webpack_require__(98722);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/modules/detailInfoArticleTableData.module.ts
var detailInfoArticleTableData_module = __webpack_require__(31049);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/passed/detailInfo/DetailInfoArticle.tsx


function DetailInfoArticle_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 28px;\n  border-radius: 10px;\n  background-color: #fff;\n"
    ]);
    DetailInfoArticle_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var DetailInfoArticle = function() {
    var examGradingResultData = (0,react.useContext)(PredictionOfPassedContainerContext/* PredictionOfPassedContainerContext */.K).examGradingResultData;
    var tableDataList = {
        math: (0,_object_spread/* default */.Z)({}, examGradingResultData && (0,_object_spread/* default */.Z)({}, (0,detailInfoArticleTableData_module/* generateTableData */.F)(examGradingResultData, graphql/* ExamSubject.MATH */.rHe.MATH))),
        reasoning: (0,_object_spread/* default */.Z)({}, examGradingResultData && (0,_object_spread/* default */.Z)({}, (0,detailInfoArticleTableData_module/* generateTableData */.F)(examGradingResultData, graphql/* ExamSubject.REASONING */.rHe.REASONING)))
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailInfoArticle_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailInfoTable/* default */.Z, {
            tableDataList: tableDataList
        })
    });
};
/* harmony default export */ var detailInfo_DetailInfoArticle = (DetailInfoArticle);
var DetailInfoArticle_StyledWrapper = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "DetailInfoArticle__StyledWrapper",
    componentId: "sc-f51b4b1f-0"
})(DetailInfoArticle_templateObject());

// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/components/Table/PredictionTable.tsx + 2 modules
var PredictionTable = __webpack_require__(64015);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/module/testResult.module.ts
var module_testResult_module = __webpack_require__(48659);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/passed/spreadScoreInfo/components/SpredScoreInfoTableColumns.tsx

function SpredScoreInfoTableColumns_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 14px 0px;\n  width: 100%;\n  font-size: 16px;\n  font-weight: normal;\n  letter-spacing: -0.64px;\n  text-align: center;\n  color: #333;\n\n  > .tooltip {\n    position: absolute;\n    border-radius: 4px;\n    display: block;\n    z-index: 20;\n    font-size: 14px;\n    font-weight: bold;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 2;\n    letter-spacing: -0.56px;\n    text-align: center;\n    color: #fff;\n    padding: 8px 12px;\n    background-color: #666666;\n    transform: translate(100%, -50%);\n    top: 50%;\n    right: -3%;\n    box-shadow: 1px 2px 4px 0 rgba(102, 102, 102, 0.16);\n\n    &[data-tooltip-type='myScore'] {\n      color: #ffdf11;\n      z-index: 30;\n    }\n\n    &[data-tooltip-type='average'] {\n      color: #ffffff;\n    }\n\n    &::after {\n      border-color: transparent #666666;\n      border-style: solid;\n      border-width: 8px 8px 8px 0px;\n      margin-top: -5px;\n      content: '';\n      display: block;\n      top: 50%;\n      position: absolute;\n      left: -6.5px;\n      width: 0;\n      z-index: 1;\n    }\n    &::before {\n      border-color: transparent #bbbbbb;\n      border-style: solid;\n      border-width: 8px 8px 8px 0px;\n      margin-top: -5px;\n      content: '';\n      display: block;\n      top: 50%;\n      position: absolute;\n      left: -8px;\n      width: 0;\n      z-index: 0;\n    }\n  }\n\n  &[data-tooltip-type='myScore'] {\n    background-color: #edf9ff;\n  }\n\n  &[data-tooltip-type='average'] {\n    background-color: #f8fdff;\n  }\n"
    ]);
    SpredScoreInfoTableColumns_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var SpredScoreInfoTableColumns = function(param) {
    var tooltipType = param.tooltipType, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpredScoreInfoTableColumns_StyledWrapper, {
        "data-tooltip-type": tooltipType,
        children: [
            value,
            tooltipType && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                role: "tooltip",
                className: "tooltip",
                "data-tooltip-type": tooltipType,
                children: tooltipType === "myScore" ? "나의 점수" : "전체 평균 점수"
            })
        ]
    });
};
/* harmony default export */ var components_SpredScoreInfoTableColumns = (SpredScoreInfoTableColumns);
var SpredScoreInfoTableColumns_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SpredScoreInfoTableColumns__StyledWrapper",
    componentId: "sc-bc0844d2-0"
})(SpredScoreInfoTableColumns_templateObject());

// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/passed/spreadScoreInfo/module/findTooltipArea.module.ts
var findTooltipArea_module = __webpack_require__(13678);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/passed/spreadScoreInfo/SpreadScoreInfoArticle.desktop.tsx

function SpreadScoreInfoArticle_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 28px;\n  border-radius: 10px;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  gap: 36px;\n\n  > .table-layout {\n    > label {\n      font-size: 16px;\n      font-weight: bold;\n      letter-spacing: -0.64px;\n      color: #333;\n      display: flex;\n      align-items: baseline;\n      margin-bottom: 16px;\n\n      > span {\n        color: #004eff;\n      }\n    }\n  }\n"
    ]);
    SpreadScoreInfoArticle_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var SpreadScoreInfoArticleDesktop = function() {
    var ref = (0,react.useContext)(PredictionOfPassedContainerContext/* PredictionOfPassedContainerContext */.K), examReserveInformation = ref.examReserveInformation, examGradingResultDistribution = ref.examGradingResultDistribution, examGradingResultDistributionSameInfo = ref.examGradingResultDistributionSameInfo, examGradingResultData = ref.examGradingResultData, examTestsData = ref.examTestsData, examGradingRankFromTestRate = ref.examGradingRankFromTestRate, examGradingRankOfSameInfoFromTestRate = ref.examGradingRankOfSameInfoFromTestRate;
    var examDate = (0,module_testResult_module/* parseTestResultDate */.U)({
        dateList: examTestsData || [],
        testId: (examReserveInformation === null || examReserveInformation === void 0 ? void 0 : examReserveInformation.examTest.id) || "",
        formatType: "slash"
    });
    var ref1 = (0,findTooltipArea_module/* findScrorePosition */.m)({
        myScore: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.correctCount) || 0,
        averageScore: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.averageScore.correctCount) || 0,
        smaeInfoAverageScore: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.sameInfoAverage.correctCount) || 0
    }), averageScoreIndex = ref1.averageScoreIndex, myScoreIndex = ref1.myScoreIndex, sameInfoAverageScoreIndex = ref1.sameInfoAverageScoreIndex;
    var COLUMNS = [
        {
            id: "0",
            label: "맞은 문항 수(개)",
            dataIndex: "name"
        },
        {
            id: "1",
            label: "응시자 비율(%)",
            dataIndex: "value",
            render: function(data) {
                var tooltipType = data.isMyScore ? "myScore" : data.isAverageScore ? "average" : false;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SpredScoreInfoTableColumns, {
                    tooltipType: tooltipType,
                    value: data.value
                });
            }
        }, 
    ];
    var spreadScoreInfoAllUser = (examGradingResultDistribution === null || examGradingResultDistribution === void 0 ? void 0 : examGradingResultDistribution.map(function(item, index) {
        return {
            name: item.range,
            value: item.rate,
            isMyScore: index === myScoreIndex,
            isAverageScore: index === averageScoreIndex
        };
    })) || [];
    var spreadScoreInfoSameInfo = (examGradingResultDistributionSameInfo === null || examGradingResultDistributionSameInfo === void 0 ? void 0 : examGradingResultDistributionSameInfo.map(function(item, index) {
        return {
            name: item.range,
            value: item.rate,
            isMyScore: index === myScoreIndex,
            isAverageScore: index === sameInfoAverageScoreIndex
        };
    })) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpreadScoreInfoArticle_desktop_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "table-layout",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        children: [
                            examDate,
                            " 전체 응시생 중\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "상위\xa0",
                                    examGradingRankFromTestRate,
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictionTable/* default */.Z, {
                        tableColumns: COLUMNS,
                        tableDataList: spreadScoreInfoAllUser
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "table-layout",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        children: [
                            examDate,
                            " 동일 사업부/직무 응시생 중\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "상위\xa0",
                                    examGradingRankOfSameInfoFromTestRate,
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictionTable/* default */.Z, {
                        tableColumns: COLUMNS,
                        tableDataList: spreadScoreInfoSameInfo
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SpreadScoreInfoArticle_desktop = (SpreadScoreInfoArticleDesktop);
var SpreadScoreInfoArticle_desktop_StyledWrapper = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "SpreadScoreInfoArticle.desktop__StyledWrapper",
    componentId: "sc-a108824b-0"
})(SpreadScoreInfoArticle_desktop_templateObject());

// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/passed/synthesisInfo/SynthesisScoreInfoArticle.desktop.tsx

function SynthesisScoreInfoArticle_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment SynthesisScoreInfoArticle_examGradingResult on ExamGradingResult {\n    viewerRank\n    viewerRankOfSameInfo(type: $viewerRankOfSameInfoType2)\n    viewerResult {\n      answeredCount\n      correctCount\n      correctRate\n      detail {\n        answeredCount\n        correctCount\n        correctRate\n        subject\n      }\n    }\n  }\n"
    ]);
    SynthesisScoreInfoArticle_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 28px;\n  border-radius: 10px;\n  background-color: #fff;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 14px 0px;\n  font-size: 16px;\n  font-weight: normal;\n  letter-spacing: -0.64px;\n  text-align: center;\n  color: #333;\n\n  > span {\n    font-weight: bold;\n    color: #004eff;\n  }\n\n  &.bg-point {\n    background-color: #e5f5ff;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






src_default()(SynthesisScoreInfoArticle_desktop_templateObject());
var SynthesisScoreInfoArticleDesktop = function() {
    var examGradingResultData = (0,react.useContext)(PredictionOfPassedContainerContext/* PredictionOfPassedContainerContext */.K).examGradingResultData;
    var COLUMNS = [
        {
            id: "0",
            label: "구분",
            dataIndex: "구분"
        },
        {
            id: "1",
            label: "맞은 문항수 / 푼 문항수",
            dataIndex: "correctRate",
            render: function(data) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTableData, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                data.viewerResult.correctCount,
                                "문항"
                            ]
                        }),
                        " /",
                        " ",
                        data.viewerResult.answeredCount,
                        "문항"
                    ]
                });
            }
        },
        {
            id: "2",
            label: "정답률",
            dataIndex: "correctPercentage",
            render: function(data) {
                var correctCount = (data === null || data === void 0 ? void 0 : data.viewerResult.correctCount) || 0;
                var answeredCount = data.viewerResult.answeredCount || 0;
                var avgCorrectRate = answeredCount > 0 ? Math.round(correctCount / answeredCount * 100) : 0;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableData, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            avgCorrectRate,
                            "%"
                        ]
                    })
                });
            }
        },
        {
            id: "3",
            label: "전체석차",
            dataIndex: "viewerRank",
            render: function(data) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTableData, {
                    children: [
                        "상위 ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                data.viewerRank,
                                "%"
                            ]
                        })
                    ]
                });
            }
        },
        {
            id: "4",
            label: "동일 직무 내 석차",
            dataIndex: "viewerRankOfSameInfo",
            render: function(data) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTableData, {
                    className: "bg-point",
                    children: [
                        "상위 ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                data.viewerRankOfSameInfo,
                                "%"
                            ]
                        })
                    ]
                });
            }
        }, 
    ];
    var tableDataList = [
        {
            viewerResult: {
                answeredCount: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.answeredCount) || 0,
                correctCount: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.correctCount) || 0,
                correctRate: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.correctRate) || 0
            },
            viewerRank: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerRank) || 0,
            viewerRankOfSameInfo: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.subsidiaryJobViewerRankOfSameInfo) || 0
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SynthesisScoreInfoArticle_desktop_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictionTable/* default */.Z, {
            tableColumns: COLUMNS,
            tableDataList: tableDataList
        })
    });
};
/* harmony default export */ var SynthesisScoreInfoArticle_desktop = (SynthesisScoreInfoArticleDesktop);
var SynthesisScoreInfoArticle_desktop_StyledWrapper = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "SynthesisScoreInfoArticle.desktop__StyledWrapper",
    componentId: "sc-d0617a4c-0"
})(_templateObject1());
var StyledTableData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SynthesisScoreInfoArticle.desktop__StyledTableData",
    componentId: "sc-d0617a4c-1"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/passed/testUserInfo/PredictionPassedMark.desktop.tsx

function PredictionPassedMark_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 128px;\n  height: 128px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  border: solid 3px #ef2929;\n\n  > strong {\n    font-size: 32px;\n    font-weight: bold;\n    line-height: 1.31;\n    letter-spacing: -1.28px;\n    text-align: center;\n    color: #ef2929;\n  }\n\n  > p {\n    font-size: 15px;\n    font-weight: 500;\n    line-height: 1.6;\n    letter-spacing: -0.6px;\n    color: #ef2929;\n  }\n\n  &[data-is-passed='true'] {\n    border: solid 3px #004eff;\n\n    > strong {\n      color: #004eff;\n    }\n\n    > p {\n      color: #004eff;\n    }\n  }\n"
    ]);
    PredictionPassedMark_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var PredictionPassedMarkDesktop = function(param) {
    var topPercent = param.topPercent;
    var isPassed = topPercent <= 30;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PredictionPassedMark_desktop_StyledWrapper, {
        "data-is-passed": isPassed,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: isPassed ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "합격",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "예상"
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "불합격",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "예상"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "상위 ",
                    topPercent,
                    "%"
                ]
            })
        ]
    });
};
/* harmony default export */ var PredictionPassedMark_desktop = (PredictionPassedMarkDesktop);
var PredictionPassedMark_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PredictionPassedMark.desktop__StyledWrapper",
    componentId: "sc-44ae77e9-0"
})(PredictionPassedMark_desktop_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/passed/testUserInfo/UserInfoTextLayout.desktop.tsx

function UserInfoTextLayout_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  align-self: flex-start;\n\n  > p {\n    font-size: 18px;\n    font-weight: bold;\n    letter-spacing: -0.72px;\n    text-align: left;\n    color: #333;\n  }\n\n  > ul {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n\n    > li {\n      list-style: disc;\n      list-style-position: inside;\n\n      > div {\n        display: inline-flex;\n\n        > label {\n          width: 74px;\n          font-size: 15px;\n          font-weight: 500;\n          line-height: 1.47;\n          letter-spacing: -0.6px;\n          text-align: left;\n          color: #333;\n        }\n\n        > p {\n          width: max-content;\n          font-size: 15px;\n          font-weight: normal;\n          line-height: 1.47;\n          letter-spacing: -0.6px;\n          text-align: left;\n          color: #333;\n        }\n      }\n    }\n  }\n"
    ]);
    UserInfoTextLayout_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var UserInfoTextLayoutDesktop = function(param) {
    var list = param.list, title = param.title, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserInfoTextLayout_desktop_StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: list.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    children: item.label
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        item.value,
                                        " "
                                    ]
                                })
                            ]
                        })
                    }, "".concat(item.label, "-").concat(index));
                })
            })
        ]
    });
};
/* harmony default export */ var UserInfoTextLayout_desktop = (UserInfoTextLayoutDesktop);
var UserInfoTextLayout_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "UserInfoTextLayout.desktop__StyledWrapper",
    componentId: "sc-3b9de245-0"
})(UserInfoTextLayout_desktop_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/passed/testUserInfo/TestUserInfoArticle.desktop.tsx

function TestUserInfoArticle_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment TestUserInfoArticle_examReserveInformation on ExamReserveInformation {\n    examDepartment {\n      id\n      name\n    }\n    examJob {\n      id\n      name\n    }\n    examSubsidiary {\n      id\n      name\n    }\n    examTest {\n      id\n      name\n    }\n    user {\n      phoneNumber\n      birthday\n      username\n    }\n  }\n"
    ]);
    TestUserInfoArticle_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TestUserInfoArticle_desktop_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 10px;\n  padding: 48px 87px;\n  width: 100%;\n  background-color: #fff;\n\n  > .text-section {\n    height: 129px;\n    display: flex;\n    align-items: center;\n    gap: 96px;\n\n    > .basic-info {\n      width: 245px;\n    }\n\n    > .test-info {\n      width: 330px;\n    }\n  }\n"
    ]);
    TestUserInfoArticle_desktop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








src_default()(TestUserInfoArticle_desktop_templateObject());
var TestUserInfoArticleDesktop = function() {
    var ref = (0,react.useContext)(PredictionOfPassedContainerContext/* PredictionOfPassedContainerContext */.K), examReserveInformation = ref.examReserveInformation, examGradingResultData = ref.examGradingResultData, examTestsData = ref.examTestsData;
    var examDate = (0,module_testResult_module/* parseTestResultDate */.U)({
        dateList: examTestsData || [],
        testId: (examReserveInformation === null || examReserveInformation === void 0 ? void 0 : examReserveInformation.examTest.id) || "",
        formatType: "kor"
    });
    var userInfoList = [
        {
            label: "닉네임",
            value: (examReserveInformation === null || examReserveInformation === void 0 ? void 0 : examReserveInformation.user.username) || ""
        },
        {
            label: "생년월일",
            value: (0,module_testResult_module/* calculateAgeFromTimestamp */.K)(examReserveInformation === null || examReserveInformation === void 0 ? void 0 : examReserveInformation.user.birthday)
        },
        {
            label: "응시일자",
            value: examDate
        }, 
    ];
    var testInfoList = [
        {
            label: "계열사",
            value: (examReserveInformation === null || examReserveInformation === void 0 ? void 0 : examReserveInformation.examSubsidiary.name) || ""
        },
        {
            label: "사업부",
            value: (examReserveInformation === null || examReserveInformation === void 0 ? void 0 : examReserveInformation.examDepartment.name) || ""
        },
        {
            label: "직무",
            value: (examReserveInformation === null || examReserveInformation === void 0 ? void 0 : examReserveInformation.examJob.name) || ""
        }, 
    ];
    if (!examReserveInformation) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) // TODO 스켈레톤 처리 필요합니다
    ;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TestUserInfoArticle_desktop_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfoTextLayout_desktop, {
                        title: "기본 정보",
                        list: userInfoList,
                        className: "basic-info"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfoTextLayout_desktop, {
                        title: "응시 정보",
                        list: testInfoList,
                        className: "test-info"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictionPassedMark_desktop, {
                topPercent: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerRank) || 0
            })
        ]
    });
};
/* harmony default export */ var TestUserInfoArticle_desktop = (TestUserInfoArticleDesktop);
var TestUserInfoArticle_desktop_StyledWrapper = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "TestUserInfoArticle.desktop__StyledWrapper",
    componentId: "sc-bd3081db-0"
})(TestUserInfoArticle_desktop_templateObject1());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/passed/PassedInfoBox.desktop.tsx

function PassedInfoBox_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1100px;\n  display: flex;\n  flex-direction: column;\n  padding: 48px 48px 40px 48px;\n  background-color: #fafafa;\n  border-radius: 20px;\n\n  .margin-bottom-48 {\n    margin-bottom: 48px;\n  }\n\n  .margin-bottom-88 {\n    margin-bottom: 88px;\n  }\n"
    ]);
    PassedInfoBox_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var PassedInfoBoxDesktop = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PassedInfoBox_desktop_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestInfoLayout_desktop, {
                title: "응시자 인적사항",
                guideText: "위 결과는 서비스 참여 인원 및 가채점 결과에 따라 변동될 수 있습니다.",
                className: "margin-bottom-48",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestUserInfoArticle_desktop, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestInfoLayout_desktop, {
                title: "종합 점수 결과",
                guideText: "본 결과는 링커리어 합격 예측 서비스 이용자 데이터 기반으로, 실제 결과와 차이가 있을 수 있습니다.",
                className: "margin-bottom-88",
                isDisplayedCorrectRate: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SynthesisScoreInfoArticle_desktop, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestInfoLayout_desktop, {
                title: "전체 성적 비교",
                subText: "내 성적을 전체, 상위 30%, 동일 직무 응시생과 비교합니다.",
                className: "margin-bottom-48",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleInfoArticle_desktop, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestInfoLayout_desktop, {
                title: "성적 분포도",
                subText: "동일한 날짜에 응시한 전체 응시생 및 동일 직무 지원자들의 성적 분포를 시각적으로 분석하여, 내 성적 위치를 파악합니다.",
                className: "margin-bottom-48",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpreadScoreInfoArticle_desktop, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestInfoLayout_desktop, {
                title: "영역별 세부결과 분석",
                subText: "수리 및 추리 영역에서 내 성적을 다양한 응시자 그룹과 비교하여 세부적으로 분석합니다.",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(detailInfo_DetailInfoArticle, {})
            })
        ]
    });
};
/* harmony default export */ var PassedInfoBox_desktop = (PassedInfoBoxDesktop);
var PassedInfoBox_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PassedInfoBox.desktop__StyledWrapper",
    componentId: "sc-c6a1b77d-0"
})(PassedInfoBox_desktop_templateObject());


/***/ }),

/***/ 13678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ findScrorePosition; }
/* harmony export */ });
/* unused harmony export findTooltipPosition */
/* harmony import */ var _app_feature_exam_gsat2024_2_constants_stepFive_constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56599);

/**
 * @description 현재 위치값에 따라 툴팁 위치값을 찾는 함수
 * @param score 현재 위치값
 * @returns
 */ var findTooltipPosition = function(score) {
    return _app_feature_exam_gsat2024_2_constants_stepFive_constant__WEBPACK_IMPORTED_MODULE_0__/* .SPREAD_SCORE_INFO_REQUEST_INPUT_SCORE_RANGES.findIndex */ .Z.findIndex(function(range) {
        if (range.to !== undefined) {
            return score >= range.from && score <= range.to;
        }
        return score >= range.from;
    });
};
var findScrorePosition = function(param) {
    var myScore = param.myScore, averageScore = param.averageScore, smaeInfoAverageScore = param.smaeInfoAverageScore;
    var myScoreIndex = findTooltipPosition(myScore);
    var averageScoreIndex = findTooltipPosition(averageScore);
    var sameInfoAverageScoreIndex = findTooltipPosition(smaeInfoAverageScore);
    return {
        myScoreIndex: myScoreIndex,
        averageScoreIndex: averageScoreIndex,
        sameInfoAverageScoreIndex: sameInfoAverageScoreIndex
    };
};


/***/ }),

/***/ 55679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TentativeScoringResultInfo_desktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.feature/exam/components/Button/ExamContainedButton.tsx
var ExamContainedButton = __webpack_require__(11923);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/components/button/PredictionButton.desktop.tsx
var PredictionButton_desktop = __webpack_require__(69224);
// EXTERNAL MODULE: ./src/svgIcons/GraphIcon.tsx
var GraphIcon = __webpack_require__(12017);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/context/PredictionOfPassedContainerContext.tsx
var PredictionOfPassedContainerContext = __webpack_require__(87552);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/result/AnswerCountingInfo.desktop.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > .top {\n    display: flex;\n    align-items: end;\n    justify-content: space-between;\n    margin-bottom: 20px;\n\n    > strong {\n      font-size: 22px;\n      font-weight: bold;\n      letter-spacing: -0.88px;\n      color: #333;\n    }\n\n    > p {\n      font-size: 12px;\n      font-weight: normal;\n      letter-spacing: -0.48px;\n      text-align: left;\n      color: ",
        ";\n    }\n  }\n\n  > .subject-answer-counting {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 12px;\n\n    > .subject-name {\n      font-size: 16px;\n      font-weight: normal;\n      letter-spacing: -0.64px;\n      color: #333;\n    }\n\n    > .counting-text {\n      font-size: 16px;\n      font-weight: normal;\n      letter-spacing: -0.64px;\n      color: #333;\n\n      > span {\n        font-weight: bold;\n      }\n    }\n  }\n\n  > hr {\n    width: 342px;\n    height: 1px;\n    background-color: #333;\n    margin: 0px;\n  }\n\n  > .all-counting-box {\n    width: 100%;\n    height: 58px;\n    padding: 0px 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 8px;\n    background-color: #f9f9f9;\n    margin-top: 12px;\n\n    > label {\n      font-size: 18px;\n      font-weight: normal;\n      letter-spacing: -0.72px;\n      color: #333;\n    }\n\n    > p {\n      font-size: 18px;\n      font-weight: normal;\n      letter-spacing: -0.72px;\n      color: #333;\n\n      > span {\n        font-weight: bold;\n        color: #004eff;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var AnswerCountingInfoDesktop = function() {
    var examGradingResultData = (0,react.useContext)(PredictionOfPassedContainerContext/* PredictionOfPassedContainerContext */.K).examGradingResultData;
    var viewerMathData = examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.detail.find(function(item) {
        return item.subject === graphql/* ExamSubject.MATH */.rHe.MATH;
    });
    var viewerReasoningData = examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.detail.find(function(item) {
        return item.subject === graphql/* ExamSubject.REASONING */.rHe.REASONING;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "top",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "채점 결과"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "*맞은 문항/푼 문항"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "subject-answer-counting",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "subject-name",
                        children: "수리"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "counting-text",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: viewerMathData === null || viewerMathData === void 0 ? void 0 : viewerMathData.correctCount
                            }),
                            "/",
                            viewerMathData === null || viewerMathData === void 0 ? void 0 : viewerMathData.answeredCount,
                            " 문항"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "subject-answer-counting",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "subject-name",
                        children: "추리"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "counting-text",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: viewerReasoningData === null || viewerReasoningData === void 0 ? void 0 : viewerReasoningData.correctCount
                            }),
                            "/",
                            viewerReasoningData === null || viewerReasoningData === void 0 ? void 0 : viewerReasoningData.answeredCount,
                            " 문항"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "all-counting-box",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        children: "전체"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.correctCount
                            }),
                            "/",
                            examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.answeredCount,
                            "문항"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AnswerCountingInfo_desktop = (AnswerCountingInfoDesktop);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AnswerCountingInfo.desktop__StyledWrapper",
    componentId: "sc-143728f1-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.text_3;
});

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/result/TentativeScoringDetailInfo.desktop.tsx

function TentativeScoringDetailInfo_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        font-size: 12px;\n        color: ",
        ";\n      "
    ]);
    TentativeScoringDetailInfo_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: end;\n\n  > .percent-box {\n    width: 342px;\n    height: 150px;\n    border-radius: 10px;\n    background-color: #f9f9f9;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 7px;\n\n    > p {\n      font-size: 18px;\n      font-weight: 500;\n      letter-spacing: -0.72px;\n      color: #333;\n    }\n\n    > strong {\n      font-size: 32px;\n      font-weight: bold;\n      letter-spacing: -1.28px;\n      text-align: left;\n      color: #004eff;\n    }\n\n    .correct-rate-guide-text {\n      ",
        "\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var TentativeScoringDetailInfoDesktop = function() {
    var examGradingResultData = (0,react.useContext)(PredictionOfPassedContainerContext/* PredictionOfPassedContainerContext */.K).examGradingResultData;
    var router = (0,next_router.useRouter)();
    var isGsat2025SecondRoute = router.pathname === "/prediction/gsat2025-2";
    var correctCount = (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.correctCount) || 0;
    var answeredCount = (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.answeredCount) || 0;
    var avgCorrectRate = answeredCount ? Math.round(correctCount / answeredCount * 100) : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TentativeScoringDetailInfo_desktop_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerCountingInfo_desktop, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "percent-box",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "정답률"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                        children: [
                            avgCorrectRate,
                            "%"
                        ]
                    }),
                    isGsat2025SecondRoute && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "correct-rate-guide-text",
                        children: "ⓘ 정답률은 맞은 문항 수 / 푼 문항 수를 백분율로 나타낸 값입니다."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TentativeScoringDetailInfo_desktop = (TentativeScoringDetailInfoDesktop);
var TentativeScoringDetailInfo_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TentativeScoringDetailInfo.desktop__StyledWrapper",
    componentId: "sc-ae53a482-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(TentativeScoringDetailInfo_desktop_templateObject(), theme.color.text_2);
});

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/result/TentativeScoringResultInfo.desktop.tsx

function TentativeScoringResultInfo_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 820px;\n  padding: 48px;\n  border-radius: 20px;\n  border: solid 1px #e8e8e8;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  margin-bottom: 40px;\n\n  .get-data-button {\n    width: 100%;\n\n    i {\n      margin-right: 10px;\n    }\n  }\n"
    ]);
    TentativeScoringResultInfo_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var TentativeScoringResultInfoDesktop = function(param) {
    var onChangeStage = param.onChangeStage;
    var router = (0,next_router.useRouter)();
    var isGsat2024Route = router.pathname === "/prediction/gsat2024-2";
    var handleChangeStage = function() {
        onChangeStage();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TentativeScoringResultInfo_desktop_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TentativeScoringDetailInfo_desktop, {}),
            isGsat2024Route ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictionButton_desktop/* default */.Z, {
                className: "get-data-button",
                type: "button",
                onClick: handleChangeStage,
                children: "석차분석 및 합격예측 리포트 받아보기"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExamContainedButton/* default */.Z, {
                className: "get-data-button",
                type: "button",
                onClick: handleChangeStage,
                isEndIcon: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GraphIcon/* default */.Z, {})
                    }),
                    "석차분석 및 합격예측 리포트 받아보기"
                ]
            })
        ]
    });
};
/* harmony default export */ var TentativeScoringResultInfo_desktop = (TentativeScoringResultInfoDesktop);
var TentativeScoringResultInfo_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TentativeScoringResultInfo.desktop__StyledWrapper",
    componentId: "sc-c7979687-0"
})(TentativeScoringResultInfo_desktop_templateObject());


/***/ }),

/***/ 57290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TentativeScoringQuestionList_desktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./src/app.feature/exam/context/ExamContext.tsx
var ExamContext = __webpack_require__(49546);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/constants/answerNumberMap.ts
var answerNumberMap = __webpack_require__(1170);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/context/TentativeScoringQuestionContext.tsx
var TentativeScoringQuestionContext = __webpack_require__(1074);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/components/radio/AnswerRadioButtonGroup.tsx + 1 modules
var AnswerRadioButtonGroup = __webpack_require__(60226);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/tentativeScoring/TentativeScoringQuestionItem.desktop.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment TentativeScoringQuestionItemDesktop_examGradingQuestion on ExamGradingQuestion {\n    id\n    answers\n    content\n    seq\n    statistics {\n      answer\n      rate\n    }\n    subject\n    userAnswers\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  min-height: 62px;\n  display: flex;\n  align-items: center;\n  border-top: 1px solid #eeeeee;\n  padding-right: 20px;\n\n  &:first-child {\n    border-top: 0;\n  }\n\n  p {\n    flex-shrink: 0;\n  }\n\n  > .question-number {\n    width: 102px;\n    font-size: 16px;\n    font-weight: normal;\n    letter-spacing: -0.64px;\n    color: #333;\n    text-align: center;\n  }\n  > .question-content {\n    width: 290px;\n    padding-left: 20px;\n    font-size: 16px;\n    font-weight: normal;\n    letter-spacing: -0.64px;\n    text-align: left;\n    color: #333;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    overflow-wrap: break-word;\n  }\n\n  > .prediction-answer-text {\n    width: 115px;\n    font-size: 16px;\n    font-weight: normal;\n    letter-spacing: -0.64px;\n    text-align: center;\n    color: #333;\n  }\n\n  > .selected-answer-text {\n    width: 111px;\n    font-size: 16px;\n    font-weight: normal;\n    letter-spacing: -0.64px;\n    text-align: center;\n    color: #333;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









src_default()(_templateObject());
var TentativeScoringQuestionItemDesktop = function(param) {
    var questionData = param.questionData;
    var handleCheckReservation = (0,react.useContext)(ExamContext/* ExamContext */.J).handleCheckReservation;
    var subject = (0,react.useContext)(TentativeScoringQuestionContext/* TentativeScoringQuestionContext */.A).subject;
    var ref = (0,index_esm/* useFormContext */.Gc)(), setValue = ref.setValue, register = ref.register, resetField = ref.resetField;
    var predictionAnswer = answerNumberMap/* ANSWER_NUMVER_MAP */.e[questionData.answers[0] - 1];
    var handleChangeAnswer = function() {
        handleCheckReservation({
            onReservated: function() {
                setValue("".concat(subject, ".inputQuestions.").concat(questionData.seq - 1, ".questionId"), questionData.id);
            },
            onNotReservated: function() {
                resetField("".concat(subject, ".inputQuestions.").concat(questionData.seq - 1));
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "question-number",
                children: [
                    questionData.seq,
                    "번 문항"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "question-content",
                children: questionData.content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "prediction-answer-text",
                children: [
                    "가답안 ",
                    predictionAnswer,
                    "번"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "selected-answer-text",
                children: "내가 고른답"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerRadioButtonGroup/* default */.Z, (0,_object_spread/* default */.Z)({
                id: "tentative-scoring-".concat(subject, "-question-").concat(questionData.seq)
            }, register("".concat(subject, ".inputQuestions.").concat(questionData.seq - 1, ".selectedAnswer"), {
                onChange: handleChangeAnswer
            })))
        ]
    });
};
/* harmony default export */ var TentativeScoringQuestionItem_desktop = (TentativeScoringQuestionItemDesktop);
var StyledWrapper = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "TentativeScoringQuestionItem.desktop__StyledWrapper",
    componentId: "sc-dbeff8bd-0"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/tentativeScoring/TentativeScoringQuestionList.desktop.tsx

function TentativeScoringQuestionList_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 820px;\n  display: flex;\n  flex-direction: column;\n  margin: 16px 0px 40px;\n"
    ]);
    TentativeScoringQuestionList_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var TentativeScoringQuestionListDesktop = function(param) {
    var examGradingQuestions = param.examGradingQuestions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TentativeScoringQuestionList_desktop_StyledWrapper, {
        children: examGradingQuestions === null || examGradingQuestions === void 0 ? void 0 : examGradingQuestions.map(function(question) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TentativeScoringQuestionItem_desktop, {
                questionData: question
            }, "question-id-".concat(question.id, "-").concat(question.seq));
        })
    });
};
/* harmony default export */ var TentativeScoringQuestionList_desktop = (TentativeScoringQuestionListDesktop);
var TentativeScoringQuestionList_desktop_StyledWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "TentativeScoringQuestionList.desktop__StyledWrapper",
    componentId: "sc-a19532fb-0"
})(TentativeScoringQuestionList_desktop_templateObject());


/***/ }),

/***/ 58258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  > p {\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: -0.64px;\n    color: #333;\n  }\n  > .information-box {\n    display: flex;\n    gap: 8px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var LevelRatingQuestionLabelLayout = function(param) {
    var label = param.label, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "information-box",
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LevelRatingQuestionLabelLayout);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "LevelRatingQuestionLabelLayout__StyledWrapper",
    componentId: "sc-57db9e4a-0"
})(_templateObject());


/***/ }),

/***/ 90977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_exam_gsat2024_2_components_button_PredictionButton_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69224);
/* harmony import */ var _app_feature_exam_gsat2024_2_desktop_components_notice_AccessRestrictionNotice_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81602);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 50px;\n  > .notice-text {\n    font-size: 44px;\n    font-weight: bold;\n    line-height: 1.34;\n    letter-spacing: -1.76px;\n    text-align: center;\n    color: #fff;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StepFourAccessRestrictionNoticeDesktop = function() {
    var isOpenAccessRestrictionNotice = false;
    if (!isOpenAccessRestrictionNotice) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_feature_exam_gsat2024_2_desktop_components_notice_AccessRestrictionNotice_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("strong", {
                    className: "notice-text",
                    children: [
                        "서비스 이용 신청 후",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                        "GSAT 난이도 투표가 가능합니다."
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_feature_exam_gsat2024_2_components_button_PredictionButton_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    color: "primary",
                    children: "서비스 이용 신청"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StepFourAccessRestrictionNoticeDesktop);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "StepFourAccessRestrictionNotice.desktop__StyledWrapper",
    componentId: "sc-21a6dd66-0"
})(_templateObject());


/***/ }),

/***/ 54499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LevelRatingCheckList_desktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/constants/questionSubjectMap.ts
var questionSubjectMap = __webpack_require__(96826);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFour/LevelRatingQuestionLabelLayout.tsx
var LevelRatingQuestionLabelLayout = __webpack_require__(58258);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
// EXTERNAL MODULE: ./src/app.feature/exam/context/ExamContext.tsx
var ExamContext = __webpack_require__(49546);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFour/checklist/ChoiceAnswerItem.desktop.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  > label {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    > span {\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 1.63;\n      letter-spacing: -0.64px;\n      color: #333;\n    }\n\n    > .check-item {\n      width: 24px;\n      height: 24px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border: 1px solid #cccccc;\n      border-radius: 5px;\n      > svg {\n        color: #fff;\n      }\n    }\n  }\n\n  > input {\n    display: none;\n\n    &:checked + label {\n      > .check-item {\n        border: 1px solid #004eff;\n        background-color: #004eff;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ChoiceAnswerItemDesktop = function(param) {
    var label = param.label, id = param.id, questionId = param.questionId, questionSeq = param.questionSeq;
    var handleCheckReservation = (0,react.useContext)(ExamContext/* ExamContext */.J).handleCheckReservation;
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, control = ref.control, setValue = ref.setValue, resetField = ref.resetField;
    var choiceOneQuestionFormKey = "question".concat(questionSeq);
    var question = (0,index_esm/* useWatch */.qo)({
        control: control,
        name: "choiceOneQuestions.".concat(choiceOneQuestionFormKey)
    });
    var handleChangeQuestion = function() {
        handleCheckReservation({
            onReservated: function() {
                setValue("choiceOneQuestions.".concat(choiceOneQuestionFormKey, ".questionId"), questionId);
            },
            onNotReservated: function() {
                resetField("choiceOneQuestions.".concat(choiceOneQuestionFormKey));
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                type: "radio",
                id: "radio-".concat(label, "-").concat(id),
                defaultChecked: (question === null || question === void 0 ? void 0 : question.answerId) === id,
                value: id
            }, register("choiceOneQuestions.".concat(choiceOneQuestionFormKey, ".answerId"), {
                onChange: handleChangeQuestion
            }))),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: "radio-".concat(label, "-").concat(id),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "check-item",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Check */.Jr, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: label
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ChoiceAnswerItem_desktop = (ChoiceAnswerItemDesktop);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ChoiceAnswerItem.desktop__StyledWrapper",
    componentId: "sc-d268660f-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFour/checklist/ChoiceQuestion.desktop.tsx

function ChoiceQuestion_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment ChoiceQuestion_examSurveyAnswer on ExamSurveyAnswer {\n    seq\n    content\n    id\n  }\n"
    ]);
    ChoiceQuestion_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 44px;\n\n  .answer-list-box {\n    display: flex;\n    align-items: center;\n    column-gap: 40px;\n    row-gap: 12px;\n    flex-wrap: wrap;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





src_default()(ChoiceQuestion_desktop_templateObject());
var ChoiceQuestionDesktop = function(param) {
    var questioonLabel = param.questioonLabel, questionSeq = param.questionSeq, questionId = param.questionId, answerList = param.answerList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChoiceQuestion_desktop_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingQuestionLabelLayout/* default */.Z, {
            label: questioonLabel,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "answer-list-box",
                children: answerList.map(function(answer, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChoiceAnswerItem_desktop, {
                        label: answer.content,
                        id: answer.id,
                        questionId: questionId,
                        questionSeq: questionSeq
                    }, "".concat(answer.id, "-").concat(index));
                })
            })
        })
    });
};
/* harmony default export */ var ChoiceQuestion_desktop = (ChoiceQuestionDesktop);
var ChoiceQuestion_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ChoiceQuestion.desktop__StyledWrapper",
    componentId: "sc-678d9880-0"
})(_templateObject1());

// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/constants/subjectMaxQuestionCount.ts
var subjectMaxQuestionCount = __webpack_require__(10937);
// EXTERNAL MODULE: ./src/utils/inputUtils.ts
var inputUtils = __webpack_require__(92681);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFour/checklist/InputAnswerItem.desktop.tsx


function InputAnswerItem_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  > .answer-input {\n    width: 150px;\n    height: 50px;\n    border-radius: 8px;\n    border: solid 1px #ddd;\n    background-color: #fff;\n    padding-left: 16px;\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: -0.64px;\n    text-align: left;\n    color: #333;\n\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n    &::placeholder {\n      font-size: 16px;\n      font-weight: 500;\n      letter-spacing: -0.64px;\n      text-align: left;\n      color: #999999;\n    }\n  }\n\n  > label {\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: -0.64px;\n    color: #333;\n    margin-right: 16px;\n  }\n  > p {\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: -0.64px;\n    color: #333;\n    margin-left: 10px;\n  }\n"
    ]);
    InputAnswerItem_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var InputAnswerItemDesktop = function(param) {
    var answer = param.answer, questionId = param.questionId, inputQuestionSubject = param.inputQuestionSubject, questionSeq = param.questionSeq;
    var handleCheckReservation = (0,react.useContext)(ExamContext/* ExamContext */.J).handleCheckReservation;
    var ref = (0,index_esm/* useFormContext */.Gc)(), setValue = ref.setValue, register = ref.register, resetField = ref.resetField;
    var inputQuestionFormKey = "question".concat(questionSeq);
    var handleChangeQuestion = function(e) {
        handleCheckReservation({
            onReservated: function() {
                (0,inputUtils/* changeOnlyNumber */.TG)(e);
                if (Number(e.target.value) <= subjectMaxQuestionCount/* default */.Z[inputQuestionSubject]) {
                    setValue("inputQuestions.".concat(inputQuestionFormKey, ".").concat(inputQuestionSubject), {
                        answerId: answer.id,
                        questionId: questionId
                    });
                } else {
                    resetField("inputQuestions.".concat(inputQuestionFormKey, ".").concat(inputQuestionSubject));
                }
            },
            onNotReservated: function() {
                resetField("inputQuestions.".concat(inputQuestionFormKey, ".").concat(inputQuestionSubject));
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputAnswerItem_desktop_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                children: answer.content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                placeholder: "못푼 문제 수 입력",
                className: "answer-input",
                inputMode: "decimal",
                maxLength: 2
            }, register("inputQuestions.".concat(inputQuestionFormKey, ".").concat(inputQuestionSubject, ".numericAnswer"), {
                onChange: handleChangeQuestion
            }))),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "개/",
                    subjectMaxQuestionCount/* default */.Z[inputQuestionSubject]
                ]
            })
        ]
    });
};
/* harmony default export */ var InputAnswerItem_desktop = (InputAnswerItemDesktop);
var InputAnswerItem_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InputAnswerItem.desktop__StyledWrapper",
    componentId: "sc-4141c680-0"
})(InputAnswerItem_desktop_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFour/checklist/InputQuestion.desktop.tsx

function InputQuestion_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 44px;\n\n  .input-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n"
    ]);
    InputQuestion_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var InputQuestionDesktop = function(param) {
    var questioonLabel = param.questioonLabel, answerList = param.answerList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputQuestion_desktop_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingQuestionLabelLayout/* default */.Z, {
            label: questioonLabel,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "input-list",
                children: answerList.map(function(param, index) {
                    var answer = param.answer, questionId = param.questionId, questionSeq = param.questionSeq, inputQuestionSubject = param.inputQuestionSubject;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAnswerItem_desktop, {
                        answer: answer,
                        questionId: questionId,
                        inputQuestionSubject: inputQuestionSubject,
                        questionSeq: questionSeq
                    }, "".concat(answer.id, "-").concat(index));
                })
            })
        })
    });
};
/* harmony default export */ var InputQuestion_desktop = (InputQuestionDesktop);
var InputQuestion_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InputQuestion.desktop__StyledWrapper",
    componentId: "sc-603d2957-0"
})(InputQuestion_desktop_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFour/checklist/LevelRatingCheckList.desktop.tsx

function LevelRatingCheckList_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment LevelRatingCheckList_examSurveyQuestion on ExamSurveyQuestion {\n    seq\n    content\n    id\n    maxSelectCount\n    isNumericAnswer\n    isMultiSelectAvailable\n    answer {\n      nodes {\n        ...ChoiceQuestion_examSurveyAnswer\n      }\n    }\n  }\n"
    ]);
    LevelRatingCheckList_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LevelRatingCheckList_desktop_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 48px;\n  width: 820px;\n  min-height: 300px;\n  border-radius: 20px;\n  border: solid 1px #e8e8e8e8;\n  background-color: #fff;\n"
    ]);
    LevelRatingCheckList_desktop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






src_default()(LevelRatingCheckList_desktop_templateObject());
var LevelRatingCheckListDesktop = function(param) {
    var questions = param.questions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingCheckList_desktop_StyledWrapper, {
        children: questions.map(function(question, index) {
            var answerList = question.answer.nodes;
            var questionLabel = "".concat(index + 1, ". ").concat(question.content);
            var inputQuestionArray = question.answer.nodes.map(function(answer) {
                return {
                    answer: answer,
                    questionId: question.id,
                    questionSeq: question.seq,
                    inputQuestionSubject: questionSubjectMap/* default */.Z[answer.seq]
                };
            });
            return question.isNumericAnswer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputQuestion_desktop, {
                questioonLabel: questionLabel,
                answerList: inputQuestionArray
            }, question.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChoiceQuestion_desktop, {
                questioonLabel: questionLabel,
                answerList: answerList,
                questionSeq: question.seq,
                questionId: question.id
            }, question.id);
        })
    });
};
/* harmony default export */ var LevelRatingCheckList_desktop = (LevelRatingCheckListDesktop);
var LevelRatingCheckList_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "LevelRatingCheckList.desktop__StyledWrapper",
    componentId: "sc-eeff5b9c-0"
})(LevelRatingCheckList_desktop_templateObject1());


/***/ }),

/***/ 3448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);



var parseSubmitExamSurvey = function(data) {
    var inputQuestions = [];
    Object.values(data.inputQuestions).map(function(inputQuestion) {
        Object.values(inputQuestion).map(function(answerInput) {
            inputQuestions.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, answerInput), {
                numericAnswer: Number(answerInput.numericAnswer)
            }));
        });
    });
    var parseData = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Object.values(data.choiceOneQuestions)).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(inputQuestions));
    return parseData;
};
/* harmony default export */ __webpack_exports__["Z"] = (parseSubmitExamSurvey);


/***/ }),

/***/ 6651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_feature_exam_gsat2024_2_constants_questionSubjectMap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96826);
/* harmony import */ var _app_feature_exam_gsat2024_2_constants_subjectMaxQuestionCount__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10937);


var parseSurveyResultData = function(resultDatas) {
    var result = {
        question1: parseTableData(resultDatas[0]),
        question2: parseTableData(resultDatas[1]),
        question3: parseQuestion3Data(resultDatas[6]),
        question4: parseQuestion4Data([
            resultDatas[2],
            resultDatas[3]
        ]),
        question5: parseQuestion5Data(resultDatas[4]),
        question6: parseQuestion6Data(resultDatas[5])
    };
    return result;
};
/* harmony default export */ __webpack_exports__["Z"] = (parseSurveyResultData);
var parseTableData = function(resultData) {
    if ((resultData === null || resultData === void 0 ? void 0 : resultData.answerStatistic.__typename) === "ExamSurveyAnswerTurnoutStatistic") {
        var tableDataList = resultData.answerStatistic.answerTurnouts.nodes.map(function(data) {
            return {
                dataText: "".concat(data.turnout, "%"),
                name: data.content
            };
        });
        var tableData = {
            label: "".concat(resultData.seq, ". ").concat(resultData.content),
            tableDataList: tableDataList
        };
        return tableData;
    } else {
        return {
            label: "",
            tableDataList: []
        };
    }
};
var parseQuestion3Data = function(resultData) {
    if ((resultData === null || resultData === void 0 ? void 0 : resultData.answerStatistic.__typename) === "ExamSurveyAnswerAverageSeqStatistic") {
        return {
            label: "3. GSAT 전체 체감 난이도",
            mainDataText: "".concat(resultData.answerStatistic.score),
            subText: "/ 5",
            description: "1: 매우 쉬움 ~ 5: 매우 어려움"
        };
    } else {
        return {
            label: "",
            mainDataText: ""
        };
    }
};
var parseQuestion4Data = function(resultDatas) {
    var cardList = resultDatas.map(function(data) {
        if ((data === null || data === void 0 ? void 0 : data.answerStatistic.__typename) === "ExamSurveyAnswerTurnoutStatistic") {
            var maxTurnout = data.answerStatistic.answerTurnouts.nodes.find(function(node) {
                return node.isMaxTurnout;
            });
            var ref;
            return {
                cardTitle: data.content.slice(0, 5),
                description: "(투표 참여자 중 ".concat(maxTurnout === null || maxTurnout === void 0 ? void 0 : maxTurnout.turnout, "%)"),
                mainDataText: (ref = maxTurnout === null || maxTurnout === void 0 ? void 0 : maxTurnout.content) !== null && ref !== void 0 ? ref : ""
            };
        } else {
            return {
                mainDataText: ""
            };
        }
    });
    return {
        label: "4. GSAT 수리/추리 영역에서 가장 어려웠던 영역",
        cardList: cardList
    };
};
var parseQuestion5Data = function(resultData) {
    if ((resultData === null || resultData === void 0 ? void 0 : resultData.answerStatistic.__typename) === "ExamSurveyAnswerAverageWithoutLastSeqStatistic") {
        return {
            label: "5. 응시자 평균 과거 GSAT 응시 횟수",
            mainDataText: "".concat(resultData.answerStatistic.score),
            description: "4회 이상 응시자 제외",
            subText: "회"
        };
    } else {
        return {
            label: "",
            mainDataText: ""
        };
    }
};
var parseQuestion6Data = function(resultData) {
    if ((resultData === null || resultData === void 0 ? void 0 : resultData.answerStatistic.__typename) === "ExamSurveyAnswerAverageNumericStatistic") {
        var cardList = resultData === null || resultData === void 0 ? void 0 : resultData.answerStatistic.answerAverageNumerics.nodes.map(function(data) {
            return {
                cardTitle: data.content,
                mainDataText: "".concat((_app_feature_exam_gsat2024_2_constants_subjectMaxQuestionCount__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[_app_feature_exam_gsat2024_2_constants_questionSubjectMap__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[data.seq]] - data.averageNumeric).toFixed(1)),
                subText: "/ ".concat(_app_feature_exam_gsat2024_2_constants_subjectMaxQuestionCount__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[_app_feature_exam_gsat2024_2_constants_questionSubjectMap__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[data.seq]])
            };
        });
        return {
            label: "6. GSAT 평균 푼 문제 개수",
            cardList: cardList
        };
    } else {
        return {
            label: "",
            cardList: []
        };
    }
};


/***/ }),

/***/ 261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LevelRatingResultBox_desktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFour/LevelRatingQuestionLabelLayout.tsx
var LevelRatingQuestionLabelLayout = __webpack_require__(58258);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/components/Table/PredictionTable.tsx + 2 modules
var PredictionTable = __webpack_require__(64015);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFour/result/LevelRatingTable.desktop.tsx


var LevelRatingTableDesktop = function(param) {
    var tableDataList = param.tableDataList;
    var columns = [
        {
            id: "data",
            label: "항목",
            dataIndex: "name"
        },
        {
            id: "percent",
            label: "투표율(%)",
            dataIndex: "dataText"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictionTable/* default */.Z, {
        tableColumns: columns,
        tableDataList: tableDataList
    });
};
/* harmony default export */ var LevelRatingTable_desktop = (LevelRatingTableDesktop);

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFour/result/ResultCard.desktop.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 358px;\n  height: 156px;\n  border-radius: 8px;\n  background-color: #fafafa;\n\n  > label {\n    font-size: 16px;\n    font-weight: normal;\n    letter-spacing: -0.64px;\n    color: #333;\n    margin-bottom: 6px;\n  }\n\n  > .data-text-layout {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n\n    > strong {\n      font-size: 28px;\n      font-weight: bold;\n      letter-spacing: -1.12px;\n      color: #004eff;\n    }\n\n    > p {\n      font-size: 18px;\n      font-weight: normal;\n      letter-spacing: -0.72px;\n      color: #666666;\n    }\n  }\n\n  .description-text {\n    font-size: 16px;\n    font-weight: normal;\n    letter-spacing: -0.64px;\n    color: #666666;\n    margin-top: 6px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ResultCardDesktop = function(param) {
    var cardTitle = param.cardTitle, description = param.description, mainDataText = param.mainDataText, subText = param.subText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            cardTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                children: cardTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "data-text-layout",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: mainDataText
                    }),
                    subText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: subText
                    })
                ]
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "description-text",
                children: description
            })
        ]
    });
};
/* harmony default export */ var ResultCard_desktop = (ResultCardDesktop);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ResultCard.desktop__StyledWrapper",
    componentId: "sc-9a727f8d-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFour/result/LevelRatingResultBox.desktop.tsx

function LevelRatingResultBox_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 48px;\n  padding: 48px;\n  width: 820px;\n  min-height: 300px;\n  border-radius: 20px;\n  border: solid 1px #e8e8e8e8;\n  background-color: #fff;\n"
    ]);
    LevelRatingResultBox_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var LevelRatingResultBoxDesktop = function(param) {
    var surveyResultData = param.surveyResultData;
    var question1 = surveyResultData.question1, question2 = surveyResultData.question2, question3 = surveyResultData.question3, question5 = surveyResultData.question5, question6 = surveyResultData.question6, question4 = surveyResultData.question4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LevelRatingResultBox_desktop_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingQuestionLabelLayout/* default */.Z, {
                label: question1.label,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingTable_desktop, {
                    tableDataList: question1.tableDataList
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingQuestionLabelLayout/* default */.Z, {
                label: question2.label,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingTable_desktop, {
                    tableDataList: question2.tableDataList
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingQuestionLabelLayout/* default */.Z, {
                label: question3.label,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultCard_desktop, {
                    mainDataText: question3.mainDataText,
                    description: question3.description,
                    subText: question3.subText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingQuestionLabelLayout/* default */.Z, {
                label: question4.label,
                children: question4.cardList.map(function(card, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultCard_desktop, {
                        mainDataText: card.mainDataText,
                        cardTitle: card.cardTitle,
                        description: card.description
                    }, "".concat(card.cardTitle, "-").concat(index));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingQuestionLabelLayout/* default */.Z, {
                label: question5.label,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultCard_desktop, {
                    mainDataText: question5.mainDataText,
                    description: question5.description,
                    subText: question5.subText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingQuestionLabelLayout/* default */.Z, {
                label: question6.label,
                children: question6.cardList.map(function(card, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultCard_desktop, {
                        mainDataText: card.mainDataText,
                        cardTitle: card.cardTitle,
                        subText: card.subText
                    }, "".concat(card.cardTitle, "-").concat(index));
                })
            })
        ]
    });
};
/* harmony default export */ var LevelRatingResultBox_desktop = (LevelRatingResultBoxDesktop);
var LevelRatingResultBox_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "LevelRatingResultBox.desktop__StyledWrapper",
    componentId: "sc-b68f072e-0"
})(LevelRatingResultBox_desktop_templateObject());


/***/ }),

/***/ 87998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ EXAM_SURVEY_FORM_DEFAULT_VALUE; },
/* harmony export */   "t": function() { return /* binding */ examSurveySchema; }
/* harmony export */ });
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16310);
/* harmony import */ var _app_feature_exam_gsat2024_2_constants_subjectMaxQuestionCount__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10937);


var EXAM_SURVEY_FORM_DEFAULT_VALUE = {
    choiceOneQuestions: {
        question1: {
            answerId: "",
            questionId: ""
        },
        question2: {
            answerId: "",
            questionId: ""
        },
        question3: {
            answerId: "",
            questionId: ""
        },
        question4: {
            answerId: "",
            questionId: ""
        },
        question5: {
            answerId: "",
            questionId: ""
        },
        question7: {
            answerId: "",
            questionId: ""
        }
    },
    inputQuestions: {
        question6: {
            suri: {
                answerId: "",
                questionId: "",
                numericAnswer: null
            },
            churi: {
                answerId: "",
                questionId: "",
                numericAnswer: null
            }
        }
    }
};
var createExamSurveyUserAnswerInputValitate = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry({
    answerId: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required(),
    questionId: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required(),
    numericAnswer: yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx()
});
var examSurveySchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry({
    choiceOneQuestions: yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry({
        question1: createExamSurveyUserAnswerInputValitate,
        question2: createExamSurveyUserAnswerInputValitate,
        question3: createExamSurveyUserAnswerInputValitate,
        question4: createExamSurveyUserAnswerInputValitate,
        question5: createExamSurveyUserAnswerInputValitate,
        question7: createExamSurveyUserAnswerInputValitate
    }),
    inputQuestions: yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry({
        question6: yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry({
            suri: createExamSurveyUserAnswerInputValitate.shape({
                numericAnswer: yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx().max(_app_feature_exam_gsat2024_2_constants_subjectMaxQuestionCount__WEBPACK_IMPORTED_MODULE_1__/* ["default"].suri */ .Z.suri)
            }),
            churi: createExamSurveyUserAnswerInputValitate.shape({
                numericAnswer: yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx().max(_app_feature_exam_gsat2024_2_constants_subjectMaxQuestionCount__WEBPACK_IMPORTED_MODULE_1__/* ["default"].churi */ .Z.churi)
            })
        })
    })
});


/***/ }),

/***/ 7815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 40px;\n\n  > .step-title {\n    white-space: pre;\n    font-size: 32px;\n    font-weight: bold;\n    line-height: 1.25;\n    letter-spacing: -1.28px;\n    text-align: center;\n    color: #333;\n    font-family: 'GmarketSansMedium';\n  }\n\n  > p {\n    font-size: 16px;\n    font-weight: normal;\n    letter-spacing: -0.64px;\n    text-align: center;\n    color: #333;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StepFourTitleLayoutDesktop = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                className: "step-title",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                children: "*제출 후 수정이 불가 합니다."
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StepFourTitleLayoutDesktop);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "StepFourTitleLayout.desktop__StyledWrapper",
    componentId: "sc-4e66dff0-0"
})(_templateObject());


/***/ }),

/***/ 81025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CommunityReviewList_desktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/utils/config.ts
var config = __webpack_require__(15125);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepThree/ReviewItem.desktop.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  width: 668px;\n  height: 62px;\n  padding: 0px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: none;\n  border: none;\n  border-top: 1px solid #eeeeee;\n\n  > .post-title {\n    max-width: 80%;\n    text-align: left;\n    font-size: 16px;\n    font-weight: normal;\n    letter-spacing: -0.64px;\n    color: #333;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n  > .user-nickname {\n    width: 140px;\n    font-size: 16px;\n    font-weight: normal;\n    letter-spacing: -0.64px;\n    color: #333;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ReviewItemDesktop = function(param) {
    var postTitle = param.postTitle, userNickname = param.userNickname;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "post-title",
                children: postTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "user-nickname",
                children: userNickname
            })
        ]
    });
};
/* harmony default export */ var ReviewItem_desktop = (ReviewItemDesktop);
var StyledWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "ReviewItem.desktop__StyledWrapper",
    componentId: "sc-217d9eb2-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepThree/CommunityReviewList.desktop.tsx

function CommunityReviewList_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border-bottom: 1px solid #eeeeee;\n  margin-bottom: 36px;\n"
    ]);
    CommunityReviewList_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var CommunityReviewListDesktop = function(param) {
    var reviewPosts = param.reviewPosts;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityReviewList_desktop_StyledWrapper, {
        children: reviewPosts.map(function(postData) {
            var ref;
            var _title, _username;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: {
                    pathname: "".concat(config/* LINKAREER_ACADEMY_COMMUNITY_BASE_URL */.mw, "/").concat((ref = postData.board) === null || ref === void 0 ? void 0 : ref.slug, "/").concat(postData.id)
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewItem_desktop, {
                        postTitle: (_title = postData.title) !== null && _title !== void 0 ? _title : "",
                        userNickname: (_username = postData.username) !== null && _username !== void 0 ? _username : ""
                    })
                })
            }, postData.id);
        })
    });
};
/* harmony default export */ var CommunityReviewList_desktop = (CommunityReviewListDesktop);
var CommunityReviewList_desktop_StyledWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "CommunityReviewList.desktop__StyledWrapper",
    componentId: "sc-74d34869-0"
})(CommunityReviewList_desktop_templateObject());


/***/ }),

/***/ 46557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);

var SUBJECT_OPTIONS = [
    {
        label: "수리",
        value: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ExamSubject.MATH */ .rHe.MATH
    },
    {
        label: "추리",
        value: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ExamSubject.REASONING */ .rHe.REASONING
    }, 
];
var ORDER_DIRECTION_OPTIONS = [
    {
        label: "오름차순",
        value: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .OrderDirection.ASC */ .N9t.ASC
    },
    {
        label: "내림차순",
        value: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .OrderDirection.DESC */ .N9t.DESC
    }, 
];
var DROP_DOWN_DATA = {
    SUBJECT_OPTIONS: SUBJECT_OPTIONS,
    ORDER_DIRECTION_OPTIONS: ORDER_DIRECTION_OPTIONS
};
/* harmony default export */ __webpack_exports__["Z"] = (DROP_DOWN_DATA);


/***/ }),

/***/ 69626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_exam_context_ExamContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49546);
/* harmony import */ var hooks_useOutSideClick__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19468);
/* harmony import */ var svgIcons_OpenArrowIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28139);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 16px;\n\n  > label {\n    font-size: 18px;\n    font-weight: bold;\n    letter-spacing: -0.72px;\n    color: #333;\n  }\n\n  > .dropdown {\n    position: relative;\n    > .dropdown-toggle {\n      cursor: pointer;\n      width: 150px;\n      height: 50px;\n      border-radius: 8px;\n      border: solid 1px #dddddd;\n      background-color: #fff;\n      padding: 0px 12px 0px 16px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      > span {\n        font-size: 16px;\n        font-weight: 500;\n        letter-spacing: -0.64px;\n        color: #333;\n      }\n\n      > i {\n        > svg {\n          display: block;\n        }\n      }\n    }\n\n    > ul {\n      position: absolute;\n      z-index: 100;\n      top: 55px;\n      left: 0px;\n      padding: 10px 0px;\n      width: 100%;\n      border-radius: 8px;\n      border: solid 1px #dddddd;\n      background-color: #fff;\n\n      > li {\n        cursor: pointer;\n        width: 100%;\n        height: 40px;\n        border-bottom: solid 1px #fafafa;\n        display: flex;\n        align-items: center;\n        padding-left: 16px;\n        font-size: 16px;\n        font-weight: 500;\n        letter-spacing: -0.64px;\n        color: #333;\n\n        &:hover {\n          background-color: #fafafa;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var PredictionDropdownDesktop = function(param) {
    var name = param.name, defaultValue = param.defaultValue, options = param.options, className = param.className, onChange = param.onChange;
    var ref;
    var dropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var handleCheckReservation = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_app_feature_exam_context_ExamContext__WEBPACK_IMPORTED_MODULE_3__/* .ExamContext */ .J).handleCheckReservation;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), selectedOption = ref2[0], setSelectedOption = ref2[1];
    var handleSelect = function(option) {
        return function() {
            onChange(option.value);
            setSelectedOption(option.label);
            setIsOpen(false);
        };
    };
    var handleToggleList = function() {
        handleCheckReservation({
            onReservated: function() {
                setIsOpen(function(prev) {
                    return !prev;
                });
            }
        });
    };
    var handleOutsideClick = function() {
        setIsOpen(false);
    };
    (0,hooks_useOutSideClick__WEBPACK_IMPORTED_MODULE_4__/* .useOutSideClick */ .A)({
        ref: dropdownRef,
        isActive: isOpen,
        onOutsideClick: handleOutsideClick
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        className: className,
        children: [
            name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                children: name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "dropdown",
                ref: dropdownRef,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "dropdown-toggle",
                        onClick: handleToggleList,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                children: selectedOption || defaultValue || ((ref = options[0]) === null || ref === void 0 ? void 0 : ref.label)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons_OpenArrowIcon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    isOpen: isOpen
                                })
                            })
                        ]
                    }),
                    isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                        children: options.map(function(option) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                onClick: handleSelect(option),
                                children: option.label
                            }, option.value);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PredictionDropdownDesktop);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PredictionDropdown.desktop__StyledWrapper",
    componentId: "sc-89ff86ad-0"
})(_templateObject());


/***/ }),

/***/ 32717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ItemKeywordsSection_desktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
// EXTERNAL MODULE: ./src/app.feature/exam/context/ExamContext.tsx
var ExamContext = __webpack_require__(49546);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/components/alert/ExamAlert.tsx
var ExamAlert = __webpack_require__(66263);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/hooks/examRestoredQuestions/useCreateQuestionKeywordForm.ts + 1 modules
var useCreateQuestionKeywordForm = __webpack_require__(46945);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/hooks/useGetQuestionKeywords.ts
var useGetQuestionKeywords = __webpack_require__(5416);
// EXTERNAL MODULE: ./src/hooks/useIsAdmin.ts
var useIsAdmin = __webpack_require__(76707);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/desktop/components/KeywordItem.tsx
var KeywordItem = __webpack_require__(81898);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepTwo/list/item/keywords/KeywordList.desktop.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment KeywordList_examQuestionKeywordConnection on ExamQuestionKeywordConnection {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    nodes {\n      id\n      keyword\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  height: 50px;\n  font-size: 16px;\n  font-weight: 400;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.56;\n  letter-spacing: -0.72px;\n  text-align: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: scroll;\n  max-height: 90px;\n\n  &::-webkit-scrollbar {\n    width: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #cccccc;\n    border-radius: 100px;\n  }\n\n  > .scroll-box {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    column-gap: 8px;\n    row-gap: 10px;\n\n    > .infinite-scroll-ref {\n      width: 100%;\n      height: 1px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






src_default()(_templateObject());
var KeywordListDesktop = function(param) {
    var questionId = param.questionId;
    var ref, ref1;
    var isAdmin = (0,useIsAdmin/* default */.Z)();
    var ref2 = (0,useGetQuestionKeywords/* default */.Z)({
        questionId: questionId
    }), keywords = ref2.keywords, ref3 = ref2.ref;
    if (!(keywords === null || keywords === void 0 ? void 0 : keywords.nodes.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNullKeyword, {
            children: "등록된 키워드가 없습니다."
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "scroll-box",
            children: [
                keywords === null || keywords === void 0 ? void 0 : (ref = keywords.nodes) === null || ref === void 0 ? void 0 : ref.map(function(keywordData) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(KeywordItem/* default */.Z, {
                        id: keywordData.id,
                        label: keywordData.keyword,
                        isAdmin: isAdmin
                    }, "".concat(keywordData.id, "-").concat(keywordData.keyword));
                }),
                (keywords === null || keywords === void 0 ? void 0 : (ref1 = keywords.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.hasNextPage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: ref3,
                    className: "infinite-scroll-ref"
                })
            ]
        })
    });
};
/* harmony default export */ var KeywordList_desktop = (KeywordListDesktop);
var StyledNullKeyword = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "KeywordList.desktop__StyledNullKeyword",
    componentId: "sc-73db90a3-0"
})(_templateObject1());
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "KeywordList.desktop__StyledWrapper",
    componentId: "sc-73db90a3-1"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepTwo/list/item/keywords/ItemKeywordsSection.desktop.tsx




function ItemKeywordsSection_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #fcfcfc;\n  padding: 20px 24px;\n  margin-bottom: 16px;\n  display: flex;\n  flex-direction: column;\n\n  > p {\n    font-size: 16px;\n    font-weight: bold;\n    letter-spacing: -0.64px;\n    color: #333;\n    margin-bottom: 12px;\n  }\n\n  > .add-keyword-layout {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 20px;\n\n    > .add-keyword-input {\n      width: 100%;\n      border-radius: 8px;\n      border: solid 1px #cccccc;\n      background-color: #fff;\n      height: 50px;\n      border-radius: 8px;\n      padding-left: 16px;\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 1.63;\n      letter-spacing: -0.64px;\n      text-align: left;\n      color: #333;\n\n      &::placeholder {\n        font-size: 16px;\n        font-weight: 500;\n        line-height: 1.63;\n        letter-spacing: -0.64px;\n        text-align: left;\n        color: #999;\n      }\n    }\n\n    > .add-keyword-button {\n      min-width: max-content;\n      height: 50px;\n    }\n  }\n"
    ]);
    ItemKeywordsSection_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var ItemKeywordsSectionDesktop = function(param) {
    var questionId = param.questionId;
    var ref = (0,react.useState)(false), isOpenAlert = ref[0], setIsOpenAlert = ref[1];
    var handleCheckReservation = (0,react.useContext)(ExamContext/* ExamContext */.J).handleCheckReservation;
    var ref1 = (0,useCreateQuestionKeywordForm/* default */.Z)(), createQuestionKeywordMutation = ref1.createQuestionKeywordMutation, formMethods = ref1.formMethods;
    var handleSubmit = formMethods.handleSubmit, register = formMethods.register, reset = formMethods.reset;
    var handelAddQuestionKeyword = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                handleCheckReservation({
                    onReservated: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                        var questionKeyword;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    questionKeyword = data.questionKeyword.trim();
                                    if (!(questionKeyword !== "")) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        createQuestionKeywordMutation({
                                            variables: {
                                                keyword: data.questionKeyword,
                                                questionId: questionId
                                            },
                                            onError: function(error) {
                                                if (error.message === "이미 등록한 키워드입니다.") {
                                                    setIsOpenAlert(function() {
                                                        return true;
                                                    });
                                                }
                                            }
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })
                });
                reset();
                return [
                    2
                ];
            });
        });
        return function handelAddQuestionKeyword(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickCloseAlert = function() {
        setIsOpenAlert(function() {
            return false;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemKeywordsSection_desktop_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "복원 키워드"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(KeywordList_desktop, {
                questionId: questionId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "add-keyword-layout",
                onSubmit: handleSubmit(handelAddQuestionKeyword),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        className: "add-keyword-input",
                        placeholder: "키워드는 최대 8자 입력 가능합니다.",
                        maxLength: 8
                    }, register("questionKeyword"))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "primary",
                        className: "add-keyword-button",
                        type: "submit",
                        children: "등록"
                    })
                ]
            }),
            isOpenAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExamAlert/* default */.Z, {
                type: "alert",
                message: "이미 등록한 키워드입니다.",
                onClickConfirm: handleClickCloseAlert
            })
        ]
    });
};
/* harmony default export */ var ItemKeywordsSection_desktop = (ItemKeywordsSectionDesktop);
var ItemKeywordsSection_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemKeywordsSection.desktop__StyledWrapper",
    componentId: "sc-81b34e41-0"
})(ItemKeywordsSection_desktop_templateObject());


/***/ }),

/***/ 83036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: 32px;\n    font-weight: bold;\n    letter-spacing: -1.28px;\n    color: ",
        ";\n    font-family: 'GmarketSansMedium';\n    white-space: pre;\n    text-align: center;\n    & > strong {\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var HeadingTitle = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadingTitle);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    displayName: "HeadingTitle__StyledWrapper",
    componentId: "sc-12804249-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), theme.color.text_1, theme.color.primary_2);
});


/***/ }),

/***/ 50639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var svgIcons_CheckBox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40478);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    align-items: center;\n\n    & > input {\n      display: none;\n\n      &:checked + label {\n        color: ",
        ";\n\n        svg {\n          display: block;\n        }\n      }\n    }\n\n    & > label {\n      width: ",
        ";\n      height: ",
        ";\n      outline: 1px solid ",
        ";\n      border-radius: 5px;\n      background-color: ",
        ";\n      flex-shrink: 0;\n      cursor: pointer;\n\n      svg {\n        width: 100%;\n        height: 100%;\n        display: none;\n      }\n    }\n\n    & > p {\n      margin-left: 8px;\n      text-align: left;\n\n      &.label-item-select {\n        width: 100%;\n        height: 20px;\n        font-size: 14px;\n        font-weight: normal;\n        line-height: 18px;\n        letter-spacing: -0.56px;\n        color: ",
        ";\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n      }\n\n      &.label-option-check {\n        height: 23px;\n        font-size: 16px;\n        font-weight: 500;\n        line-height: 23px;\n        letter-spacing: -0.64px;\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var PredictionInputCheckbox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(_param, inputCheckboxRef) {
    var buttonId = _param.buttonId, _buttonSize = _param.buttonSize, buttonSize = _buttonSize === void 0 ? "medium" : _buttonSize, label = _param.label, isErrors = _param.isErrors, restInputProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "buttonId",
        "buttonSize",
        "label",
        "isErrors"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        isErrors: isErrors,
        buttonSize: buttonSize,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                type: "checkbox",
                ref: inputCheckboxRef,
                id: buttonId,
                className: isErrors ? "error" : ""
            }, restInputProps)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                htmlFor: buttonId,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons_CheckBox__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
            }),
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                className: buttonSize === "small" ? "label-item-select" : "label-option-check",
                children: label
            })
        ]
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (PredictionInputCheckbox);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PredictionInputCheckbox.desktop__StyledWrapper",
    componentId: "sc-9ce323d9-0"
})(_templateObject1(), function(param) {
    var theme = param.theme, buttonSize = param.buttonSize, isErrors = param.isErrors;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject(), theme.color.primary_2, buttonSize === "small" ? "18px" : "23px", buttonSize === "small" ? "18px" : "23px", isErrors ? theme.color.error_1 : theme.line.line_2, theme.background.bg_8, isErrors ? theme.color.error_1 : theme.color.text_1, isErrors ? theme.color.error_1 : theme.color.text_1);
});


/***/ }),

/***/ 29280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_careerManage_desktop_careerContent_components_inputFields_select_components_SelectBox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34743);
/* harmony import */ var _app_feature_careerManage_desktop_careerContent_components_inputFields_select_components_SelectOption__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67308);
/* harmony import */ var hooks_useOutSideClick__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19468);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 200px;\n    height: 50px;\n    & > .select-container {\n      width: 200px;\n      position: relative;\n      cursor: pointer;\n      li {\n        height: 50px;\n        > p {\n          font-size: 16px;\n          font-weight: 500;\n          letter-spacing: -0.64px;\n        }\n      }\n      > div {\n        & > [aria-describedby='placeholder'] {\n          font-weight: 500;\n          color: ",
        ";\n        }\n      }\n    }\n\n    .select-options {\n      & > li {\n        display: flex;\n        align-items: flex-start;\n        height: auto;\n        p {\n          height: auto;\n          text-align: left;\n          color: ",
        ";\n          word-break: break-word;\n          display: -webkit-box;\n          -webkit-line-clamp: 2;\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var PredictionInputSelect = function(param) {
    var options = param.options, isErrors = param.isErrors, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "선택" : _placeholder, errorMessage = param.errorMessage, defaultSelectOption = param.defaultSelectOption, disabled = param.disabled, onChangeSelect = param.onChangeSelect;
    var ref;
    var selectRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isShowOption = ref1[0], setIsShowOption = ref1[1];
    var handleSelectOption = function(selectedOption) {
        onChangeSelect(selectedOption.value);
        setIsShowOption(false);
    };
    var handleShowOption = function() {
        setIsShowOption(function(value) {
            return !value;
        });
    };
    var handleOutsideClick = function() {
        setIsShowOption(false);
    };
    var valueHasIcon = (ref = options === null || options === void 0 ? void 0 : options.find(function(option) {
        return (option === null || option === void 0 ? void 0 : option.label) === (defaultSelectOption === null || defaultSelectOption === void 0 ? void 0 : defaultSelectOption.label);
    })) === null || ref === void 0 ? void 0 : ref.icon;
    (0,hooks_useOutSideClick__WEBPACK_IMPORTED_MODULE_5__/* .useOutSideClick */ .A)({
        ref: selectRef,
        isActive: isShowOption,
        onOutsideClick: handleOutsideClick
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "select-container",
            ref: selectRef,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_feature_careerManage_desktop_careerContent_components_inputFields_select_components_SelectBox__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    placeholder: placeholder,
                    isErrors: isErrors || !!errorMessage,
                    icon: valueHasIcon,
                    disabled: disabled,
                    isFocused: isShowOption,
                    selectValue: (defaultSelectOption === null || defaultSelectOption === void 0 ? void 0 : defaultSelectOption.label) || "",
                    onClick: handleShowOption
                }),
                isShowOption && (options === null || options === void 0 ? void 0 : options.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_feature_careerManage_desktop_careerContent_components_inputFields_select_components_SelectOption__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "select-options",
                    options: options,
                    onClick: handleSelectOption
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PredictionInputSelect);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PredictionInputSelect.desktop__StyledWrapper",
    componentId: "sc-21a26eb9-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject(), theme.color.text_2, theme.color.text_1);
});


/***/ }),

/***/ 50622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87536);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_exam_gsat2024_2_hooks_useGetExamTestSelectOptions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61748);
/* harmony import */ var _input_PredictionInputSelect_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29280);
/* harmony import */ var _label_PredictionFormLabel_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69812);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  margin-right: 66px;\n\n  > p {\n    width: 103px;\n  }\n\n  > div {\n    width: 200px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var FormItemDepartment = function(param) {
    var companyId = param.companyId, termId = param.termId;
    var ref;
    var departments = (0,_app_feature_exam_gsat2024_2_hooks_useGetExamTestSelectOptions__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        companyId: companyId,
        termId: termId
    }).departments;
    var departmentId = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useWatch */ .qo)({
        name: "departmentId"
    });
    var ref1 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useFormContext */ .Gc)(), setValue = ref1.setValue, errors = ref1.formState.errors;
    var handleOnChangeDepartments = function(value) {
        setValue("departmentId", value, {
            shouldValidate: true,
            shouldDirty: true
        });
        setValue("jobId", "", {
            shouldValidate: true,
            shouldDirty: true
        });
    };
    var defaultOption = departments === null || departments === void 0 ? void 0 : departments.find(function(departments) {
        return (departments === null || departments === void 0 ? void 0 : departments.value) === departmentId;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_label_PredictionFormLabel_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                label: "사업부"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_input_PredictionInputSelect_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                placeholder: "사업부 선택",
                isErrors: !!((ref = errors.departmentId) === null || ref === void 0 ? void 0 : ref.message),
                defaultSelectOption: defaultOption,
                options: departments,
                onChangeSelect: handleOnChangeDepartments
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormItemDepartment);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormItemDepartment.desktop__StyledWrapper",
    componentId: "sc-7db53cde-0"
})(_templateObject());


/***/ }),

/***/ 30050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var _input_PredictionInputCheckbox_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50639);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var FormItemHasAgreedToPrivacy = function() {
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useFormContext */ .Gc)(), register = ref.register, errors = ref.formState.errors;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_input_PredictionInputCheckbox_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            buttonId: "hasAgreedToPrivacy",
            label: "개인정보 수집/이용 및 마케팅 수신 동의"
        }, register("hasAgreedToPrivacy")), {
            isErrors: !!errors.hasAgreedToPrivacy
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormItemHasAgreedToPrivacy);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormItemHasAgreedToPrivacy.desktop__StyledWrapper",
    componentId: "sc-d16af55d-0"
})(_templateObject());


/***/ }),

/***/ 31552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87536);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_exam_gsat2024_2_hooks_useGetExamTestSelectOptions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61748);
/* harmony import */ var _input_PredictionInputSelect_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29280);
/* harmony import */ var _label_PredictionFormLabel_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69812);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 50px;\n  display: flex;\n  align-items: center;\n\n  > p {\n    width: 52px;\n  }\n\n  > div {\n    width: 200px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var FormItemJob = function(param) {
    var companyId = param.companyId, termId = param.termId;
    var ref;
    var jobs = (0,_app_feature_exam_gsat2024_2_hooks_useGetExamTestSelectOptions__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        companyId: companyId,
        termId: termId
    }).jobs;
    var jobId = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useWatch */ .qo)({
        name: "jobId"
    });
    var ref1 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useFormContext */ .Gc)(), setValue = ref1.setValue, errors = ref1.formState.errors;
    var handleOnChangeDepartment = function(value) {
        setValue("jobId", value, {
            shouldValidate: true,
            shouldDirty: true
        });
    };
    var defaultOption = jobs === null || jobs === void 0 ? void 0 : jobs.find(function(job) {
        return (job === null || job === void 0 ? void 0 : job.value) === jobId;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_label_PredictionFormLabel_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                label: "직무"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_input_PredictionInputSelect_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                placeholder: "직무 선택",
                isErrors: !!((ref = errors.jobId) === null || ref === void 0 ? void 0 : ref.message),
                defaultSelectOption: defaultOption,
                options: jobs,
                onChangeSelect: handleOnChangeDepartment
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormItemJob);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormItemJob.desktop__StyledWrapper",
    componentId: "sc-5104c08f-0"
})(_templateObject());


/***/ }),

/***/ 3382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FormItemPhoneNumber_desktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/utils/inputUtils.ts
var inputUtils = __webpack_require__(92681);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionThree/preReservation/preReservation.form/input/PredictionInputText.desktop.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    min-height: 50px;\n\n    & > input {\n      width: 100%;\n      height: 50px;\n      padding: 13px 15px;\n      border-radius: 8px;\n      border: solid 1px ",
        ";\n      background-color: ",
        ";\n      font-family: Noto Sans KR;\n      font-size: 16px;\n      font-weight: 500;\n      letter-spacing: -0.64px;\n      text-align: left;\n      color: ",
        ";\n\n      &:focus {\n        outline: none;\n      }\n\n      &::placeholder {\n        color: ",
        ";\n        font-weight: normal;\n      }\n\n      &:disabled {\n        background-color: ",
        ";\n        color: ",
        ";\n      }\n\n      &:read-only {\n        background-color: ",
        ";\n        pointer-events: none;\n      }\n\n      &[type='number'] {\n        -moz-appearance: textfield; // Firefox용 input number 증감 버튼 hidden\n\n        &::-webkit-inner-spin-button, // webkit 기반 (크롬, 사파리)용 input number 증감 버튼 hidden\n        &::-webkit-outer-spin-button {\n          -webkit-appearance: none;\n          margin: 0;\n        }\n      }\n\n      &.error {\n        color: ",
        ";\n        border: solid 1px ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var PredictionInputText = /*#__PURE__*/ (0,react.forwardRef)(function(_param, inputTextRef) {
    var _type = _param.type, type = _type === void 0 ? "text" : _type, isErrors = _param.isErrors, restInputProps = (0,_object_without_properties/* default */.Z)(_param, [
        "type",
        "isErrors"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
            type: type,
            ref: inputTextRef,
            className: isErrors ? "error" : ""
        }, restInputProps))
    });
});
/* harmony default export */ var PredictionInputText_desktop = (PredictionInputText);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PredictionInputText.desktop__StyledWrapper",
    componentId: "sc-1c51c089-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.line.line_2, theme.background.bg_8, theme.color.text_1, theme.color.text_3, theme.background.bg_3, theme.color.text_2, theme.background.bg_3, theme.color.error_1, theme.color.error_1);
});

// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionThree/preReservation/preReservation.form/label/PredictionFormLabel.desktop.tsx
var PredictionFormLabel_desktop = __webpack_require__(69812);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionThree/preReservation/preReservation.form/item/FormItemPhoneNumber.desktop.tsx


function FormItemPhoneNumber_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  > p {\n    width: 103px;\n  }\n  > div {\n    width: 200px;\n  }\n"
    ]);
    FormItemPhoneNumber_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var FormItemPhoneNumber = function(param) {
    var disabled = param.disabled;
    var ref;
    var ref1 = (0,index_esm/* useFormContext */.Gc)(), register = ref1.register, errors = ref1.formState.errors;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormItemPhoneNumber_desktop_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictionFormLabel_desktop/* default */.Z, {
                label: "휴대폰 번호"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictionInputText_desktop, (0,_object_spread/* default */.Z)({
                type: "tel",
                disabled: disabled,
                minLength: 12,
                maxLength: 13,
                isErrors: !!((ref = errors.phoneNumber) === null || ref === void 0 ? void 0 : ref.message),
                placeholder: "010-0000-0000"
            }, register("phoneNumber", {
                onChange: inputUtils/* changePhoneNumber */.Sl
            })))
        ]
    });
};
/* harmony default export */ var FormItemPhoneNumber_desktop = (FormItemPhoneNumber);
var FormItemPhoneNumber_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FormItemPhoneNumber.desktop__StyledWrapper",
    componentId: "sc-7ee24b4-0"
})(FormItemPhoneNumber_desktop_templateObject());


/***/ }),

/***/ 4741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87536);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_exam_gsat2024_2_hooks_useGetExamTestSelectOptions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61748);
/* harmony import */ var _input_PredictionInputSelect_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29280);
/* harmony import */ var _label_PredictionFormLabel_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69812);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  margin-right: 66px;\n\n  > p {\n    width: 85px;\n  }\n\n  > div {\n    width: 200px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var FormItemSubsidiary = function(param) {
    var companyId = param.companyId, termId = param.termId;
    var ref;
    var subsidiaries = (0,_app_feature_exam_gsat2024_2_hooks_useGetExamTestSelectOptions__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        companyId: companyId,
        termId: termId
    }).subsidiaries;
    var ref1 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useFormContext */ .Gc)(), setValue = ref1.setValue, errors = ref1.formState.errors;
    var subsidiaryId = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useWatch */ .qo)({
        name: "subsidiaryId"
    });
    var handleOnChangeSubsidiary = function(value) {
        setValue("subsidiaryId", value, {
            shouldValidate: true,
            shouldDirty: true
        });
        setValue("departmentId", "", {
            shouldValidate: true,
            shouldDirty: true
        });
        setValue("jobId", "", {
            shouldValidate: true,
            shouldDirty: true
        });
    };
    var defaultOption = subsidiaries === null || subsidiaries === void 0 ? void 0 : subsidiaries.find(function(subsidary) {
        return (subsidary === null || subsidary === void 0 ? void 0 : subsidary.value) === subsidiaryId;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_label_PredictionFormLabel_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                label: "계열사"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_input_PredictionInputSelect_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                placeholder: "계열사 선택",
                isErrors: !!((ref = errors.subsidiaryId) === null || ref === void 0 ? void 0 : ref.message),
                defaultSelectOption: defaultOption,
                options: subsidiaries,
                onChangeSelect: handleOnChangeSubsidiary
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormItemSubsidiary);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormItemSubsidiary.desktop__StyledWrapper",
    componentId: "sc-2dd9bc24-0"
})(_templateObject());


/***/ }),

/***/ 37200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87536);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_exam_gsat2024_2_hooks_useGetExamTermSelectOptions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14299);
/* harmony import */ var _app_feature_exam_hooks_useExamQuestionInfo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67913);
/* harmony import */ var _input_PredictionInputSelect_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29280);
/* harmony import */ var _label_PredictionFormLabel_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69812);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  height: 50px;\n  align-items: center;\n  margin-right: 66px;\n\n  > p {\n    width: 85px;\n  }\n\n  > div {\n    width: 200px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var FormItemTestDate = function(param) {
    var companyId = param.companyId, termId = param.termId;
    var ref;
    var ref1 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_8__/* .useFormContext */ .Gc)(), setValue = ref1.setValue, errors = ref1.formState.errors;
    var ref2 = (0,_app_feature_exam_hooks_useExamQuestionInfo__WEBPACK_IMPORTED_MODULE_5__/* .useExamQuestionInfo */ .k)({
        companyId: companyId,
        termId: termId
    }), testDate = ref2.testDate, defaultTest = ref2.defaultTest;
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().query;
    var selectOptions = (0,_app_feature_exam_gsat2024_2_hooks_useGetExamTermSelectOptions__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        companyId: companyId,
        termId: termId
    });
    var testId = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_8__/* .useWatch */ .qo)({
        name: "testId"
    });
    var defaultSelectOption = selectOptions === null || selectOptions === void 0 ? void 0 : selectOptions.find(function(option) {
        return (option === null || option === void 0 ? void 0 : option.value) === testId;
    });
    var handleOnChangeTestDate = function(value) {
        setValue("testId", value, {
            shouldValidate: true,
            shouldDirty: true
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (defaultTest) {
            var ref;
            setValue("testId", (ref = testDate === null || testDate === void 0 ? void 0 : testDate.id) !== null && ref !== void 0 ? ref : defaultTest === null || defaultTest === void 0 ? void 0 : defaultTest.id, {
                shouldValidate: true,
                shouldDirty: true
            });
        }
    }, [
        defaultTest,
        query
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_label_PredictionFormLabel_desktop__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                label: "응시 날짜"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_input_PredictionInputSelect_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                placeholder: "날짜 선택",
                isErrors: !!((ref = errors.testId) === null || ref === void 0 ? void 0 : ref.message),
                defaultSelectOption: defaultSelectOption,
                options: selectOptions,
                onChangeSelect: handleOnChangeTestDate
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormItemTestDate);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormItemTestDate.desktop__StyledWrapper",
    componentId: "sc-ca9291fa-0"
})(_templateObject());


/***/ }),

/***/ 69812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    flex-shrink: 0;\n    font-size: 18px;\n    color: ",
        ";\n    letter-spacing: -0.72px;\n    font-weight: bold;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var PredictionFormLabel = function(param) {
    var label = param.label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        children: label
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PredictionFormLabel);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    displayName: "PredictionFormLabel.desktop__StyledWrapper",
    componentId: "sc-934ddeec-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), theme.color.text_1);
});


/***/ }),

/***/ 81898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53893);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47079);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  padding: 0px 15px;\n  height: 40px;\n  border-radius: 5px;\n  border: solid 1px #d9e9f3;\n  background-color: #f2faff;\n  gap: 7px;\n  > span {\n    font-size: 12px;\n    font-weight: normal;\n    letter-spacing: -0.48px;\n    color: #333;\n  }\n\n  > i {\n    padding: 4px;\n    cursor: pointer;\n    > svg {\n      display: block;\n      width: 10px;\n      height: 10px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var KeywordItem = function(param) {
    var id = param.id, label = param.label, isAdmin = param.isAdmin;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_3__/* .useGqlDeleteExamQuestionKeywordMutation */ .CYg)({
        refetchQueries: [
            generated_graphql__WEBPACK_IMPORTED_MODULE_3__/* .GqlExamRestoredQuestionKeywordsDocument */ .tjS
        ],
        onCompleted: function() {
            alert("키워드가 삭제되었습니다.");
        }
    }), 1), deleteKeywordMutation = ref[0];
    var handleDeleteKeyword = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                if (confirm("해당 키워드를 삭제하시겠습니까?")) {
                    deleteKeywordMutation({
                        variables: {
                            deleteExamQuestionKeywordId: id
                        }
                    });
                }
                return [
                    2
                ];
            });
        });
        return function handleDeleteKeyword() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                children: label
            }),
            isAdmin && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                onClick: handleDeleteKeyword,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_2__/* .Close */ .x8, {})
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (KeywordItem);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "KeywordItem__StyledWrapper",
    componentId: "sc-a3df9454-0"
})(_templateObject());


/***/ }),

/***/ 81602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  min-height: max-content;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(51, 51, 51, 0.9);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var AccessRestrictionNotice = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccessRestrictionNotice);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AccessRestrictionNotice.desktop__StyledWrapper",
    componentId: "sc-6d9d6ce0-0"
})(_templateObject());


/***/ }),

/***/ 46945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ examRestoredQuestions_useCreateQuestionKeywordForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var yup_index_esm = __webpack_require__(16310);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/schemas/createQuestionKeyword.ts

var createQuestionKeyword = yup_index_esm/* object */.Ry({
    questionKeyword: yup_index_esm/* string */.Z_().max(8)
});

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/hooks/examRestoredQuestions/useCreateQuestionKeywordForm.ts





var useCreateQuestionKeywordForm = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,graphql/* useGqlCreateExamQuestionKeywordMutation */.U_J)({
        refetchQueries: [
            graphql/* GqlExamRestoredQuestionsDocument */.SYb,
            graphql/* GqlExamRestoredQuestionKeywordsDocument */.tjS, 
        ]
    }), 1), createQuestionKeywordMutation = ref[0];
    var formMethods = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(createQuestionKeyword),
        mode: "onChange",
        defaultValues: {
            questionKeyword: ""
        }
    });
    return {
        formMethods: formMethods,
        createQuestionKeywordMutation: createQuestionKeywordMutation
    };
};
/* harmony default export */ var examRestoredQuestions_useCreateQuestionKeywordForm = (useCreateQuestionKeywordForm);


/***/ }),

/***/ 40359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ examRestoredQuestions_useExamQuestionSearchKeywordForm; }
});

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var yup_index_esm = __webpack_require__(16310);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/schemas/searchKeyword.ts

var searchKeywordSchema = yup_index_esm/* object */.Ry({
    searchKeyword: yup_index_esm/* string */.Z_(),
    seq: yup_index_esm/* string */.Z_()
});

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/hooks/examRestoredQuestions/useExamQuestionSearchKeywordForm.ts




var useExamQuestionSearchKeywordForm = function() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var ref2, ref3;
    var formMethods = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(searchKeywordSchema),
        mode: "onChange",
        defaultValues: {
            searchKeyword: (ref2 = (ref = router.query.searchKeyword) === null || ref === void 0 ? void 0 : ref.toString()) !== null && ref2 !== void 0 ? ref2 : "",
            seq: (ref3 = (ref1 = router.query.seq) === null || ref1 === void 0 ? void 0 : ref1.toString()) !== null && ref3 !== void 0 ? ref3 : ""
        }
    });
    return formMethods;
};
/* harmony default export */ var examRestoredQuestions_useExamQuestionSearchKeywordForm = (useExamQuestionSearchKeywordForm);


/***/ }),

/***/ 37491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47079);
/* harmony import */ var _app_feature_exam_gsat2024_2_constants_defaultTestId__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38706);



var useGetExamRestoredQuestions = function(param) {
    var defaultTestId = param.defaultTestId;
    var ref, ref1, ref2, ref3, ref4;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var query = router.query;
    var testId = ((ref = query.adminTestId) === null || ref === void 0 ? void 0 : ref.toString()) || ((ref1 = query.testId) === null || ref1 === void 0 ? void 0 : ref1.toString()) || defaultTestId || _app_feature_exam_gsat2024_2_constants_defaultTestId__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;
    var subject = (ref2 = query.subject) === null || ref2 === void 0 ? void 0 : ref2.toString();
    var ref5, ref6;
    var data = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .useGqlExamRestoredQuestionsQuery */ .Mze)({
        variables: {
            filterBy: {
                subject: subject !== null && subject !== void 0 ? subject : generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ExamSubject.MATH */ .rHe.MATH,
                testId: testId,
                keyword: (ref5 = (ref3 = query.searchKeyword) === null || ref3 === void 0 ? void 0 : ref3.toString()) !== null && ref5 !== void 0 ? ref5 : "",
                seq: Number(query.seq) || undefined
            },
            orderBy: {
                direction: (ref6 = (ref4 = query.orderDirection) === null || ref4 === void 0 ? void 0 : ref4.toString()) !== null && ref6 !== void 0 ? ref6 : generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .OrderDirection.ASC */ .N9t.ASC,
                field: generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ExamRestoredQuestionsOrderField.SEQ */ .tFu.SEQ
            },
            pagination: {
                page: query.page ? Number(query.page) : 1,
                pageSize: subject === generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ExamSubject.MATH */ .rHe.MATH ? 21 : 31
            }
        },
        fetchPolicy: "network-only"
    }).data;
    return {
        examRestoredQuestions: data === null || data === void 0 ? void 0 : data.examRestoredQuestions
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetExamRestoredQuestions);


/***/ }),

/***/ 28882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20414);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29496);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47079);
/* harmony import */ var _app_feature_chatting_chattingContext_module_ChattingContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18944);
/* harmony import */ var _constants_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63374);
/* harmony import */ var _modules_form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9729);








var useCreateExamReservation = function(isDirty) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .useGqlCreateExamReserveInformationMutation */ .eTX)(), 2), createExamReservation = ref[0], ref1 = ref[1], createLoading = ref1.loading;
    var reportToChatting = (0,_app_feature_chatting_chattingContext_module_ChattingContext__WEBPACK_IMPORTED_MODULE_2__/* .useChattingContext */ .Y)().reportToChatting;
    var createExam = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(values) {
            var input;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isDirty || createLoading) return [
                            2
                        ];
                        input = (0,_modules_form__WEBPACK_IMPORTED_MODULE_6__/* .parsedCreateInputValues */ .c)(values);
                        return [
                            4,
                            createExamReservation({
                                variables: {
                                    input: input
                                },
                                refetchQueries: [
                                    generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .GqlViewerExamReserveInformationDocument */ .Cfy
                                ],
                                onCompleted: function() {
                                    reportToChatting({
                                        type: "reportChatRefreshMyChatRoom"
                                    });
                                    alert(_constants_message__WEBPACK_IMPORTED_MODULE_7__/* .SUCCESS_MESSAGE */ .nS);
                                },
                                onError: function(error) {
                                    (0,notistack__WEBPACK_IMPORTED_MODULE_0__/* .enqueueSnackbar */ .yv)(error.message);
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function createExam(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        createExam: createExam
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCreateExamReservation);


/***/ }),

/***/ 14299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);
/* harmony import */ var _modules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5143);


var useGetExamTestSelectOptions = function(param) {
    var companyId = param.companyId, termId = param.termId;
    var ref;
    var ref1 = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .useGqlExamTestsQuery */ .nsG)({
        variables: {
            input: {
                companyId: companyId,
                termId: termId
            }
        }
    }), data = ref1.data, loading = ref1.loading, error = ref1.error;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.examTests)) {
        return [];
    }
    return data === null || data === void 0 ? void 0 : (ref = data.examTests) === null || ref === void 0 ? void 0 : ref.map(function(test) {
        return {
            label: (0,_modules__WEBPACK_IMPORTED_MODULE_1__/* .formatToCustomDate */ .nZ)(test.date),
            value: test.id
        };
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetExamTestSelectOptions);


/***/ }),

/***/ 61748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87536);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);



var useGetPredictionSelectOptions = function(param) {
    var companyId = param.companyId, termId = param.termId;
    var ref = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .useGqlExamCompanyQuery */ .ZU3)({
        variables: {
            examCompanyId: Number(companyId),
            termId: termId
        }
    }), data = ref.data, loading = ref.loading, error = ref.error;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .useWatch */ .qo)({
        name: [
            "subsidiaryId",
            "departmentId"
        ]
    }), 2), subsidiaryId = ref1[0], departmentId = ref1[1];
    var getSubsidiaries = function(subsidiaries) {
        if (!subsidiaries) return [];
        return subsidiaries === null || subsidiaries === void 0 ? void 0 : subsidiaries.map(function(subsidiary) {
            return {
                label: subsidiary.name,
                value: subsidiary.id
            };
        });
    };
    var getDepartments = function(subsidiaries) {
        var ref;
        if (!subsidiaryId || !subsidiaries) return [];
        var subsidiary = subsidiaries === null || subsidiaries === void 0 ? void 0 : subsidiaries.find(function(sub) {
            return sub.id === subsidiaryId;
        });
        return subsidiary === null || subsidiary === void 0 ? void 0 : (ref = subsidiary.departments) === null || ref === void 0 ? void 0 : ref.map(function(department) {
            return {
                label: department.name,
                value: department.id
            };
        });
    };
    var getJobs = function(subsidiaries) {
        var ref, ref1;
        if (!subsidiaryId || !subsidiaries || !departmentId) return [];
        var subsidiary = subsidiaries === null || subsidiaries === void 0 ? void 0 : subsidiaries.find(function(sub) {
            return sub.id === subsidiaryId;
        });
        return (ref1 = subsidiary === null || subsidiary === void 0 ? void 0 : (ref = subsidiary.departments) === null || ref === void 0 ? void 0 : ref.find(function(department) {
            return department.id === departmentId;
        })) === null || ref1 === void 0 ? void 0 : ref1.jobs.map(function(job) {
            return {
                label: job.name,
                value: job.id
            };
        });
    };
    if (!loading || !error || (data === null || data === void 0 ? void 0 : data.examCompany)) {
        var ref2, ref3, ref4;
        return {
            subsidiaries: getSubsidiaries(data === null || data === void 0 ? void 0 : (ref2 = data.examCompany) === null || ref2 === void 0 ? void 0 : ref2.subsidiaries),
            departments: getDepartments(data === null || data === void 0 ? void 0 : (ref3 = data.examCompany) === null || ref3 === void 0 ? void 0 : ref3.subsidiaries),
            jobs: getJobs(data === null || data === void 0 ? void 0 : (ref4 = data.examCompany) === null || ref4 === void 0 ? void 0 : ref4.subsidiaries)
        };
    } else {
        return {
            subsidiaries: [],
            departments: [],
            jobs: []
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetPredictionSelectOptions);


/***/ }),

/***/ 65670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20414);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29496);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47079);
/* harmony import */ var _modules__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5143);










var useGetFormInitialValues = function(param) {
    var companyId = param.companyId, termId = param.termId;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var query = router.query;
    var hash = query.tab ? query.tab === "full-reservation" ? "section1" : "section2" : undefined;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isUpdateStatus = ref[0], setIsUpdateStatus = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), disabled = ref1[0], setDisabled = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_3__/* .useGqlViewerExamReserveInformationLazyQuery */ .IA7)({
        variables: {
            input: {
                companyId: companyId,
                termId: termId
            }
        }
    }), 1), viewerExamReservation = ref2[0];
    var fetchInitialData = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, data, defaultValues;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            viewerExamReservation({
                                onError: function(error) {
                                    (0,notistack__WEBPACK_IMPORTED_MODULE_2__/* .enqueueSnackbar */ .yv)(error.message);
                                    router.replace({
                                        query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, query), {
                                            testId: ""
                                        }),
                                        hash: hash
                                    });
                                },
                                onCompleted: function(data) {
                                    var ref, ref1;
                                    setIsUpdateStatus(!!(data === null || data === void 0 ? void 0 : data.viewerExamReserveInformation));
                                    setDisabled(!!(data === null || data === void 0 ? void 0 : (ref = data.currentUser) === null || ref === void 0 ? void 0 : ref.phoneNumber));
                                    router.replace({
                                        query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, query), {
                                            testId: (ref1 = data.viewerExamReserveInformation) === null || ref1 === void 0 ? void 0 : ref1.examTest.id
                                        }),
                                        hash: hash
                                    }, undefined, {
                                        scroll: false
                                    });
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        defaultValues = {
                            companyId: companyId,
                            termId: termId,
                            subsidiaryId: (data === null || data === void 0 ? void 0 : (ref = data.viewerExamReserveInformation) === null || ref === void 0 ? void 0 : (ref1 = ref.examSubsidiary) === null || ref1 === void 0 ? void 0 : ref1.id) || "",
                            departmentId: (data === null || data === void 0 ? void 0 : (ref2 = data.viewerExamReserveInformation) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.examDepartment) === null || ref3 === void 0 ? void 0 : ref3.id) || "",
                            jobId: (data === null || data === void 0 ? void 0 : (ref4 = data.viewerExamReserveInformation) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.examJob) === null || ref5 === void 0 ? void 0 : ref5.id) || "",
                            testId: (data === null || data === void 0 ? void 0 : (ref6 = data.viewerExamReserveInformation) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.examTest) === null || ref7 === void 0 ? void 0 : ref7.id) || "",
                            phoneNumber: (0,_modules__WEBPACK_IMPORTED_MODULE_9__/* .formatPhoneNumber */ .un)(data === null || data === void 0 ? void 0 : (ref8 = data.currentUser) === null || ref8 === void 0 ? void 0 : ref8.phoneNumber),
                            hasAgreedToPrivacy: (data === null || data === void 0 ? void 0 : (ref9 = data.viewerExamReserveInformation) === null || ref9 === void 0 ? void 0 : ref9.hasAgreedToPrivacy) || false
                        };
                        return [
                            2,
                            defaultValues
                        ];
                }
            });
        });
        return function fetchInitialData() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        isUpdateStatus: isUpdateStatus,
        disabled: disabled,
        fetchInitialData: fetchInitialData
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetFormInitialValues);


/***/ }),

/***/ 78244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47079);
/* harmony import */ var _constants_defaultTestId__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38706);



var useGetHasSubmittedExamSurvey = function(params) {
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var ref1 = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .useGqlViewerHasSubmittedExamSurveyQuery */ .RIm)({
        variables: {
            testId: ((ref = router.query.testId) === null || ref === void 0 ? void 0 : ref.toString()) || (params === null || params === void 0 ? void 0 : params.defaultTestId) || _constants_defaultTestId__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
        }
    }), loading = ref1.loading, data = ref1.data;
    var ref2;
    var isSubmitted = (ref2 = data === null || data === void 0 ? void 0 : data.viewerHasSubmittedExamSurvey) !== null && ref2 !== void 0 ? ref2 : false;
    return {
        isSubmitted: isSubmitted,
        loading: loading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetHasSubmittedExamSurvey);


/***/ }),

/***/ 5416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var immutability_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7145);
/* harmony import */ var immutability_helper__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(immutability_helper__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47079);
/* harmony import */ var _app_modules_hooks_useIntersect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23913);



var useGetQuestionKeywords = function(param) {
    var questionId = param.questionId;
    var ref = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .useGqlExamRestoredQuestionKeywordsQuery */ .IUj)({
        variables: {
            cursorPagination: {
                take: 50
            },
            questionId: questionId
        }
    }), data = ref.data, fetchMore = ref.fetchMore;
    var handleIntersect = function() {
        fetchMore({
            variables: {
                cursorPagination: {
                    take: 50,
                    cursor: data === null || data === void 0 ? void 0 : data.examRestoredQuestionKeywords.pageInfo.endCursor
                },
                questionId: questionId
            },
            updateQuery: function(prev, param) {
                var fetchMoreResult = param.fetchMoreResult;
                if (!fetchMoreResult || !fetchMoreResult.examRestoredQuestionKeywords) {
                    return prev;
                }
                var result = immutability_helper__WEBPACK_IMPORTED_MODULE_0___default()(prev, {
                    examRestoredQuestionKeywords: {
                        nodes: {
                            $push: fetchMoreResult.examRestoredQuestionKeywords.nodes
                        },
                        pageInfo: {
                            $set: fetchMoreResult.examRestoredQuestionKeywords.pageInfo
                        },
                        totalCount: {
                            $set: fetchMoreResult.examRestoredQuestionKeywords.totalCount
                        }
                    }
                });
                return result;
            }
        });
    };
    var ref1 = (0,_app_modules_hooks_useIntersect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(handleIntersect, [
        data !== null && data !== void 0 ? data : {}
    ]);
    return {
        keywords: data === null || data === void 0 ? void 0 : data.examRestoredQuestionKeywords,
        ref: ref1
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetQuestionKeywords);


/***/ }),

/***/ 36490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20414);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var _context_TentativeScoringQuestionContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1074);
/* harmony import */ var _modules_tentativeScoringTest_module__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77012);







var useTentativeScoringQuestionListForm = function() {
    var examGradingQuestionData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_TentativeScoringQuestionContext__WEBPACK_IMPORTED_MODULE_1__/* .TentativeScoringQuestionContext */ .A).examGradingQuestionData;
    var formMethods = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useForm */ .cI)({
        mode: "onSubmit",
        defaultValues: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
            var math, reasoning, mathDataList, reasoningDataList;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                if (examGradingQuestionData) {
                    math = examGradingQuestionData.math, reasoning = examGradingQuestionData.reasoning;
                    mathDataList = {
                        math: {
                            inputQuestions: (0,_modules_tentativeScoringTest_module__WEBPACK_IMPORTED_MODULE_2__/* .tentativeScoringQuestionListDefaultValues */ .Kz)(math)
                        }
                    };
                    reasoningDataList = {
                        reasoning: {
                            inputQuestions: (0,_modules_tentativeScoringTest_module__WEBPACK_IMPORTED_MODULE_2__/* .tentativeScoringQuestionListDefaultValues */ .Kz)(reasoning)
                        }
                    };
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, mathDataList, reasoningDataList)
                    ];
                } else {
                    return [
                        2,
                        {
                            math: {
                                inputQuestions: []
                            },
                            reasoning: {
                                inputQuestions: []
                            }
                        }
                    ];
                }
                return [
                    2
                ];
            });
        })
    });
    return formMethods;
};
/* harmony default export */ __webpack_exports__["Z"] = (useTentativeScoringQuestionListForm);


/***/ }),

/***/ 13606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20414);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29496);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47079);
/* harmony import */ var _app_feature_chatting_chattingContext_module_ChattingContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18944);
/* harmony import */ var _constants_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63374);
/* harmony import */ var _modules_form__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9729);











var useUpdateExamReservation = function(isDirty) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var query = router.query;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .useGqlUpdateExamReserveInformationMutation */ .X15)(), 2), updateExamReservation = ref[0], ref1 = ref[1], updateLoading = ref1.loading;
    var reportToChatting = (0,_app_feature_chatting_chattingContext_module_ChattingContext__WEBPACK_IMPORTED_MODULE_3__/* .useChattingContext */ .Y)().reportToChatting;
    var updateExam = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(values) {
            var input;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isDirty || updateLoading) {
                            return [
                                2
                            ];
                        }
                        input = (0,_modules_form__WEBPACK_IMPORTED_MODULE_7__/* .parsedUpdateInputValues */ .V)(values);
                        return [
                            4,
                            updateExamReservation({
                                variables: {
                                    input: input
                                },
                                refetchQueries: [
                                    generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .GqlViewerExamReserveInformationDocument */ .Cfy
                                ],
                                onCompleted: function(data) {
                                    reportToChatting({
                                        type: "reportChatRefreshMyChatRoom"
                                    });
                                    alert(_constants_message__WEBPACK_IMPORTED_MODULE_8__/* .SUCCES_UPDATE_MESSAGE */ .ZP);
                                    router.replace({
                                        query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, query), {
                                            testId: data.updateExamReserveInformation.updatedExamReserveInformation.examTest.id
                                        }),
                                        hash: "section1"
                                    }, undefined, {
                                        scroll: false
                                    });
                                },
                                onError: function(error) {
                                    (0,notistack__WEBPACK_IMPORTED_MODULE_1__/* .enqueueSnackbar */ .yv)(error.message);
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function updateExam(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        updateExam: updateExam
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useUpdateExamReservation);


/***/ }),

/***/ 61132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ loading_ResultLoadingPopup; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.components/Portal.tsx
var Portal = __webpack_require__(20901);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFive/loading/ExternalLoading.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 182px;\n    height: 12px;\n    border-radius: 6px;\n    background-color: #eeeeee;\n    position: relative;\n    overflow: hidden;\n    margin: 0 auto;\n\n    &::after {\n      content: '';\n      width: 100%;\n      height: 100%;\n      background-color: ",
        ";\n      border-radius: 6px;\n      animation: loadingAnimation 1s infinite ease-in-out;\n      position: absolute;\n      top: 0;\n      left: -100%;\n      will-change: left, animation;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @keyframes loadingAnimation {\n    0% {\n      left: -100%;\n    }\n    100% {\n      left: 100%;\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var ExternalLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {});
};
/* harmony default export */ var loading_ExternalLoading = (ExternalLoading);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ExternalLoading__StyledWrapper",
    componentId: "sc-45b2fbf4-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.color.primary_2);
});

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFive/loading/ResultLoadingPopup.tsx

function ResultLoadingPopup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    z-index: 500;\n    top: 0;\n    left: 0;\n    background: rgba(0, 0, 0, 0.7);\n\n    & > .popup-content {\n      width: 280px;\n      height: 300px;\n      background-color: ",
        ";\n      border-radius: 20px;\n      padding: 40px;\n      position: absolute;\n      z-index: 600;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n\n      & > strong {\n        width: 100%;\n        height: 26px;\n        font-size: 18px;\n        font-weight: bold;\n        line-height: 26px;\n        letter-spacing: -0.72px;\n        text-align: center;\n        color: ",
        ";\n        margin-bottom: 8px;\n        display: block;\n      }\n\n      & > p.loading-description {\n        // 전역으로 잡힌 스타일보다 우선순위를 높게 잡아야 합니다\n        height: 40px;\n        font-size: 14px;\n        font-weight: normal;\n        line-height: 20px;\n        letter-spacing: -0.56px;\n        text-align: center;\n        color: ",
        ";\n        margin-bottom: 20px;\n      }\n\n      & > .loading-image-wrapper {\n        width: 140px;\n        height: 140px;\n        margin: 0 auto 20px;\n\n        & > figure {\n          width: 100%;\n          height: 100%;\n          margin: 0;\n          padding: 0;\n\n          & > figcaption {\n            width: 0;\n            height: 0;\n            font-size: 0;\n          }\n        }\n      }\n    }\n  "
    ]);
    ResultLoadingPopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ResultLoadingPopup_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ResultLoadingPopup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ResultLoadingPopup = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Portal/* default */.Z, {
        id: "result-loading-popup",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultLoadingPopup_StyledWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "popup-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "결과를 불러오고 있습니다."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "loading-image-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                    children: "결과 요청 로딩 팝업"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/static/images/career/external_data_loading.png",
                                    width: 140,
                                    height: 140,
                                    alt: "결과 요청 로딩"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_ExternalLoading, {})
                ]
            })
        })
    });
};
/* harmony default export */ var loading_ResultLoadingPopup = (ResultLoadingPopup);
var ResultLoadingPopup_StyledWrapper = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "ResultLoadingPopup__StyledWrapper",
    componentId: "sc-317be04a-0"
})(ResultLoadingPopup_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(ResultLoadingPopup_templateObject(), theme.background.bg_8, theme.color.text_1, theme.color.text_1);
});


/***/ }),

/***/ 89391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PassedInfoBox_mobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.feature/exam/hooks/useIsGsat2025SecondRoute.ts
var useIsGsat2025SecondRoute = __webpack_require__(51128);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFive/passed/TestInfoLayout.mobile.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  > strong {\n    font-size: 18px;\n    font-weight: bold;\n    line-height: 2;\n    letter-spacing: -0.72px;\n    text-align: left;\n    color: #333;\n  }\n\n  > .sub-text {\n    font-size: 13px;\n    font-weight: normal;\n    line-height: 1.38;\n    letter-spacing: -0.52px;\n    text-align: left;\n    color: #333;\n    margin-top: 8px;\n  }\n\n  > .info-content {\n    margin-top: 16px;\n  }\n\n  > .guide-text {\n    font-size: 13px;\n    font-weight: normal;\n    line-height: 1.38;\n    letter-spacing: -0.52px;\n    text-align: left;\n    color: #666666;\n    margin-top: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var TestInfoLayoutMobile = function(param) {
    var title = param.title, children = param.children, subText = param.subText, guideText = param.guideText, className = param.className, _isDisplayedCorrectRate = param.isDisplayedCorrectRate, isDisplayedCorrectRate = _isDisplayedCorrectRate === void 0 ? false : _isDisplayedCorrectRate;
    var isGsat2025SecondRoute = (0,useIsGsat2025SecondRoute/* useIsGsat2025SecondRoute */.L)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: title
            }),
            subText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "sub-text",
                children: subText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "info-content",
                children: children
            }),
            guideText && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "guide-text",
                children: [
                    "※ ",
                    guideText
                ]
            }),
            isGsat2025SecondRoute && isDisplayedCorrectRate && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "guide-text",
                children: "※ 정답률은 맞은 문항 수 / 푼 문항 수를 백분율로 나타낸 값입니다."
            })
        ]
    });
};
/* harmony default export */ var TestInfoLayout_mobile = (TestInfoLayoutMobile);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TestInfoLayout.mobile__StyledWrapper",
    componentId: "sc-46c8256c-0"
})(_templateObject());

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/context/PredictionOfPassedContainerContext.tsx
var PredictionOfPassedContainerContext = __webpack_require__(87552);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/modules/testResult.module.ts
var testResult_module = __webpack_require__(86690);
// EXTERNAL MODULE: ./src/svgIcons/UpDownIcon.tsx
var UpDownIcon = __webpack_require__(83396);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFive/passed/circleInfo/CircleInfoItem.mobile.tsx

function CircleInfoItem_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n\n  > .info-circle {\n    width: 200px;\n    height: 200px;\n    border: solid 1px #e8e8e8;\n    background-color: #fff;\n    border-radius: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 16px;\n\n    > p {\n      width: 120px;\n      white-space: pre-wrap;\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 1.5;\n      letter-spacing: -0.64px;\n      text-align: center;\n      color: #333;\n    }\n\n    > .percent-box {\n      display: flex;\n      align-items: center;\n      color: #004eff;\n\n      > span {\n        font-size: 28px;\n        font-weight: bold;\n        letter-spacing: -1.12px;\n        text-align: center;\n      }\n\n      &[data-is-up='true'] {\n        color: #ef2929;\n      }\n    }\n  }\n\n  > p {\n    font-size: 13px;\n    font-weight: normal;\n    line-height: 1.38;\n    letter-spacing: -0.52px;\n    text-align: center;\n    color: #666666;\n    > span {\n      display: block;\n      font-weight: 500;\n    }\n  }\n"
    ]);
    CircleInfoItem_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var CircleInfoItemMobile = function(param) {
    var averagePercent = param.averagePercent, averageText = param.averageText, infoTitle = param.infoTitle, userPercent = param.userPercent;
    var isUp = userPercent >= 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CircleInfoItem_mobile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "info-circle",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: infoTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "percent-box",
                        "data-is-up": isUp,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    Math.abs(userPercent),
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UpDownIcon/* default */.Z, {
                                isUp: isUp
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    averageText,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            averagePercent,
                            "문항"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CircleInfoItem_mobile = (CircleInfoItemMobile);
var CircleInfoItem_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CircleInfoItem.mobile__StyledWrapper",
    componentId: "sc-9e2d5d9c-0"
})(CircleInfoItem_mobile_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFive/passed/circleInfo/CircleInfoArticle.mobile.tsx



function CircleInfoArticle_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 32px 0px;\n  border-radius: 20px;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 32px;\n"
    ]);
    CircleInfoArticle_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var CircleInfoArticleMobile = function() {
    var ref = (0,react.useContext)(PredictionOfPassedContainerContext/* PredictionOfPassedContainerContext */.K), examGradingResultData = ref.examGradingResultData, isLoading = ref.isLoading;
    if (isLoading) return null;
    var compareOverrallGradingRate = (0,testResult_module/* compareCorrectRates */._)((examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.correctRate) || 0, (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.overallExamGradingResult.correctRate) || 0);
    var compareTop30PercentGradingRate = (0,testResult_module/* compareCorrectRates */._)((examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.correctRate) || 0, (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.top30percentOfOverallExamGradingResult.correctRate) || 0);
    var compareSameInfoGradingRate = (0,testResult_module/* compareCorrectRates */._)((examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.correctRate) || 0, (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.subsidiaryJobExamGradingResultOfSameInfo.correctRate) || 0);
    var CICLE_INFO_DATA = [
        {
            infoTitle: "전체 응시생 \n평균 맞은 문항수보다 약",
            userPercent: compareOverrallGradingRate,
            averageText: "전체 응시생 평균 맞은 문항수",
            averagePercent: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.overallExamGradingResult.correctCount) || 0
        },
        {
            infoTitle: "상위 30% 응시생 \n평균 맞은 문항수보다 약",
            userPercent: compareTop30PercentGradingRate,
            averageText: "상위 30% 응시생 평균 맞은 문항수",
            averagePercent: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.top30percentOfOverallExamGradingResult.correctCount) || 0
        },
        {
            infoTitle: "동일 계열사/직무 \n응시생 평균 맞은 문항수보다 약",
            userPercent: compareSameInfoGradingRate,
            averageText: "동일 계열사/직무 응시생 평균 맞은 문항수",
            averagePercent: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.subsidiaryJobExamGradingResultOfSameInfo.correctCount) || 0
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleInfoArticle_mobile_StyledWrapper, {
        children: CICLE_INFO_DATA.map(function(data, index) {
            return /*#__PURE__*/ (0,react.createElement)(CircleInfoItem_mobile, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                key: "".concat(data.infoTitle, "-").concat(data.averagePercent, "-").concat(index)
            }));
        })
    });
};
/* harmony default export */ var CircleInfoArticle_mobile = (CircleInfoArticleMobile);
var CircleInfoArticle_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CircleInfoArticle.mobile__StyledWrapper",
    componentId: "sc-817cbfa4-0"
})(CircleInfoArticle_mobile_templateObject());

// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/components/detailInfoTable/DetailInfoTable.tsx + 2 modules
var DetailInfoTable = __webpack_require__(98722);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/modules/detailInfoArticleTableData.module.ts
var detailInfoArticleTableData_module = __webpack_require__(31049);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFive/passed/detailInfo/DetailInfoArticle.mobile.tsx


function DetailInfoArticle_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 24px 20px;\n  border-radius: 20px;\n  background-color: #fff;\n\n  > .table-scroll-box {\n    width: 100%;\n    overflow-x: scroll;\n  }\n"
    ]);
    DetailInfoArticle_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var DetailInfoArticleMobile = function() {
    var examGradingResultData = (0,react.useContext)(PredictionOfPassedContainerContext/* PredictionOfPassedContainerContext */.K).examGradingResultData;
    var tableDataList = {
        math: (0,_object_spread/* default */.Z)({}, examGradingResultData && (0,_object_spread/* default */.Z)({}, (0,detailInfoArticleTableData_module/* generateTableData */.F)(examGradingResultData, graphql/* ExamSubject.MATH */.rHe.MATH))),
        reasoning: (0,_object_spread/* default */.Z)({}, examGradingResultData && (0,_object_spread/* default */.Z)({}, (0,detailInfoArticleTableData_module/* generateTableData */.F)(examGradingResultData, graphql/* ExamSubject.REASONING */.rHe.REASONING)))
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailInfoArticle_mobile_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "table-scroll-box",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailInfoTable/* default */.Z, {
                tableDataList: tableDataList
            })
        })
    });
};
/* harmony default export */ var DetailInfoArticle_mobile = (DetailInfoArticleMobile);
var DetailInfoArticle_mobile_StyledWrapper = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "DetailInfoArticle.mobile__StyledWrapper",
    componentId: "sc-367d6cc8-0"
})(DetailInfoArticle_mobile_templateObject());

// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/components/Table/PredictionTable.tsx + 2 modules
var PredictionTable = __webpack_require__(64015);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/module/testResult.module.ts
var module_testResult_module = __webpack_require__(48659);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/passed/spreadScoreInfo/module/findTooltipArea.module.ts
var findTooltipArea_module = __webpack_require__(13678);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFive/passed/spreadScoreInfo/components/SpredScoreInfoTableColumns.mobile.tsx

function SpredScoreInfoTableColumns_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 14px 0px;\n  width: 100%;\n  font-size: 16px;\n  font-weight: normal;\n  letter-spacing: -0.64px;\n  text-align: center;\n  color: #333;\n\n  > .tooltip {\n    height: 23px;\n    position: absolute;\n    border-radius: 6px;\n    display: block;\n    z-index: 20;\n    font-size: 12px;\n    font-weight: 500;\n    letter-spacing: -0.48px;\n    line-height: 15px;\n    text-align: center;\n    color: #fff;\n    padding: 3px 8px;\n    background-color: #666666;\n    transform: translate(-50%, -100%);\n    left: 50%;\n    top: 10%;\n    box-shadow: 1px 2px 4px 0 rgba(102, 102, 102, 0.16);\n\n    &[data-tooltip-type='myScore'] {\n      width: 70px;\n      color: #ffdf11;\n      z-index: 30;\n    }\n\n    &[data-tooltip-type='average'] {\n      width: 90px;\n      color: #ffffff;\n    }\n\n    &::after {\n      border-color: #666666 transparent;\n      border-style: solid;\n      border-width: 8px 6px 0px 6.5px;\n      margin-left: -5px;\n      content: '';\n      display: block;\n      left: 50%;\n      position: absolute;\n      bottom: -6.5px;\n      width: 0;\n      z-index: 1;\n    }\n    &::before {\n      border-color: #666666 transparent;\n      border-style: solid;\n      border-width: 8px 6px 0px 6.5px;\n      margin-left: -5px;\n      content: '';\n      display: block;\n      left: 50%;\n      position: absolute;\n      bottom: -8px;\n      width: 0;\n      z-index: 0;\n    }\n  }\n\n  &[data-tooltip-type='myScore'] {\n    background-color: #edf9ff;\n  }\n\n  &[data-tooltip-type='average'] {\n    background-color: #f8fdff;\n  }\n"
    ]);
    SpredScoreInfoTableColumns_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var SpredScoreInfoTableColumnsMobile = function(param) {
    var tooltipType = param.tooltipType, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpredScoreInfoTableColumns_mobile_StyledWrapper, {
        "data-tooltip-type": tooltipType,
        children: [
            value,
            tooltipType && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                role: "tooltip",
                className: "tooltip",
                "data-tooltip-type": tooltipType,
                children: tooltipType === "myScore" ? "나의 점수" : "전체 평균 점수"
            })
        ]
    });
};
/* harmony default export */ var SpredScoreInfoTableColumns_mobile = (SpredScoreInfoTableColumnsMobile);
var SpredScoreInfoTableColumns_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SpredScoreInfoTableColumns.mobile__StyledWrapper",
    componentId: "sc-cf7c71a8-0"
})(SpredScoreInfoTableColumns_mobile_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFive/passed/spreadScoreInfo/SpreadScoreInfoArticle.mobile.tsx

function SpreadScoreInfoArticle_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px 20px;\n  border-radius: 20px;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  gap: 36px;\n\n  > .table-layout {\n    > label {\n      font-size: 15px;\n      font-weight: bold;\n      line-height: 1.47;\n      letter-spacing: -0.6px;\n      text-align: center;\n      color: #333;\n      display: block;\n      margin-bottom: 12px;\n\n      > span {\n        color: #004eff;\n      }\n    }\n  }\n"
    ]);
    SpreadScoreInfoArticle_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var SpreadScoreInfoArticleMobile = function() {
    var ref = (0,react.useContext)(PredictionOfPassedContainerContext/* PredictionOfPassedContainerContext */.K), examReserveInformation = ref.examReserveInformation, examGradingResultDistribution = ref.examGradingResultDistribution, examGradingResultDistributionSameInfo = ref.examGradingResultDistributionSameInfo, examGradingResultData = ref.examGradingResultData, examTestsData = ref.examTestsData, examGradingRankFromTestRate = ref.examGradingRankFromTestRate, examGradingRankOfSameInfoFromTestRate = ref.examGradingRankOfSameInfoFromTestRate;
    var examDate = (0,module_testResult_module/* parseTestResultDate */.U)({
        dateList: examTestsData || [],
        testId: (examReserveInformation === null || examReserveInformation === void 0 ? void 0 : examReserveInformation.examTest.id) || "",
        formatType: "slash"
    });
    var ref1 = (0,findTooltipArea_module/* findScrorePosition */.m)({
        myScore: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.correctCount) || 0,
        averageScore: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.averageScore.correctCount) || 0,
        smaeInfoAverageScore: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.sameInfoAverage.correctCount) || 0
    }), averageScoreIndex = ref1.averageScoreIndex, myScoreIndex = ref1.myScoreIndex, sameInfoAverageScoreIndex = ref1.sameInfoAverageScoreIndex;
    var COLUMNS = [
        {
            id: "0",
            label: "맞은 문항 수(개)",
            dataIndex: "name"
        },
        {
            id: "1",
            label: "응시자 비율(%)",
            dataIndex: "value",
            render: function(data) {
                var tooltipType = data.isMyScore ? "myScore" : data.isAverageScore ? "average" : false;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SpredScoreInfoTableColumns_mobile, {
                    tooltipType: tooltipType,
                    value: data.value
                });
            }
        }, 
    ];
    var spreadScoreInfoAllUser = (examGradingResultDistribution === null || examGradingResultDistribution === void 0 ? void 0 : examGradingResultDistribution.map(function(item, index) {
        return {
            name: item.range,
            value: item.rate,
            isMyScore: index === myScoreIndex,
            isAverageScore: index === averageScoreIndex
        };
    })) || [];
    var spreadScoreInfoSameInfo = (examGradingResultDistributionSameInfo === null || examGradingResultDistributionSameInfo === void 0 ? void 0 : examGradingResultDistributionSameInfo.map(function(item, index) {
        return {
            name: item.range,
            value: item.rate,
            isMyScore: index === myScoreIndex,
            isAverageScore: index === sameInfoAverageScoreIndex
        };
    })) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpreadScoreInfoArticle_mobile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "table-layout",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        children: [
                            examDate,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "전체 응시생 중\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "상위\xa0",
                                    examGradingRankFromTestRate,
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictionTable/* default */.Z, {
                        tableColumns: COLUMNS,
                        tableDataList: spreadScoreInfoAllUser
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "table-layout",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        children: [
                            examDate,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "동일 사업부/직무 응시생 중\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "상위\xa0",
                                    examGradingRankOfSameInfoFromTestRate,
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictionTable/* default */.Z, {
                        tableColumns: COLUMNS,
                        tableDataList: spreadScoreInfoSameInfo
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SpreadScoreInfoArticle_mobile = (SpreadScoreInfoArticleMobile);
var SpreadScoreInfoArticle_mobile_StyledWrapper = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "SpreadScoreInfoArticle.mobile__StyledWrapper",
    componentId: "sc-f3aa4a89-0"
})(SpreadScoreInfoArticle_mobile_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFive/passed/synthesisInfo/SynthesisScoreInfoArticle.mobile.tsx

function SynthesisScoreInfoArticle_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 24px 20px;\n  border-radius: 20px;\n  background-color: #fff;\n\n  > .table-scroll-box {\n    width: 100%;\n    overflow-x: scroll;\n    padding-bottom: 8px;\n\n    .synthesis-score-info-table {\n      width: 948px;\n    }\n  }\n"
    ]);
    SynthesisScoreInfoArticle_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 14px 0px;\n  font-size: 16px;\n  font-weight: normal;\n  letter-spacing: -0.64px;\n  text-align: center;\n  color: #333;\n\n  > span {\n    font-weight: bold;\n    color: #004eff;\n  }\n\n  &.bg-point {\n    background-color: #e5f5ff;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var SynthesisScoreInfoArticleMobile = function() {
    var examGradingResultData = (0,react.useContext)(PredictionOfPassedContainerContext/* PredictionOfPassedContainerContext */.K).examGradingResultData;
    var COLUMNS = [
        {
            id: "0",
            label: "구분",
            dataIndex: "구분"
        },
        {
            id: "1",
            label: "맞은 문항수 / 푼 문항수",
            dataIndex: "correctRate",
            render: function(data) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTableData, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                data.viewerResult.correctCount,
                                "문항"
                            ]
                        }),
                        " /",
                        " ",
                        data.viewerResult.answeredCount,
                        "문항"
                    ]
                });
            }
        },
        {
            id: "2",
            label: "정답률",
            dataIndex: "correctPercentage",
            render: function(data) {
                var correctCount = (data === null || data === void 0 ? void 0 : data.viewerResult.correctCount) || 0;
                var answeredCount = data.viewerResult.answeredCount || 0;
                var avgCorrectRate = answeredCount > 0 ? Math.round(correctCount / answeredCount * 100) : 0;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableData, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            avgCorrectRate,
                            "%"
                        ]
                    })
                });
            }
        },
        {
            id: "3",
            label: "전체석차",
            dataIndex: "viewerRank",
            render: function(data) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTableData, {
                    children: [
                        "상위 ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                data.viewerRank,
                                "%"
                            ]
                        })
                    ]
                });
            }
        },
        {
            id: "4",
            label: "동일 직무 내 석차",
            dataIndex: "viewerRankOfSameInfo",
            render: function(data) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTableData, {
                    className: "bg-point",
                    children: [
                        "상위 ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                data.viewerRankOfSameInfo,
                                "%"
                            ]
                        })
                    ]
                });
            }
        }, 
    ];
    var tableDataList = [
        {
            viewerResult: {
                answeredCount: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.answeredCount) || 0,
                correctCount: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.correctCount) || 0,
                correctRate: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.correctRate) || 0
            },
            viewerRank: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerRank) || 0,
            viewerRankOfSameInfo: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerRankOfSameInfo) || 0
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SynthesisScoreInfoArticle_mobile_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "table-scroll-box",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictionTable/* default */.Z, {
                tableColumns: COLUMNS,
                tableDataList: tableDataList,
                className: "synthesis-score-info-table"
            })
        })
    });
};
/* harmony default export */ var SynthesisScoreInfoArticle_mobile = (SynthesisScoreInfoArticleMobile);
var SynthesisScoreInfoArticle_mobile_StyledWrapper = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "SynthesisScoreInfoArticle.mobile__StyledWrapper",
    componentId: "sc-a7b78d89-0"
})(SynthesisScoreInfoArticle_mobile_templateObject());
var StyledTableData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SynthesisScoreInfoArticle.mobile__StyledTableData",
    componentId: "sc-a7b78d89-1"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFive/passed/testUserInfo/PredictionPassedMark.mobile.tsx

function PredictionPassedMark_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 112px;\n  height: 112px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  border: solid 3px #ef2929;\n\n  > strong {\n    font-size: 28px;\n    font-weight: bold;\n    line-height: 1.32;\n    letter-spacing: -1.12px;\n    text-align: center;\n    color: #ef2929;\n  }\n\n  > p {\n    font-size: 15px;\n    font-weight: 500;\n    line-height: 1.6;\n    letter-spacing: -0.6px;\n    text-align: left;\n    color: #ef2929;\n  }\n\n  &[data-is-passed='true'] {\n    border: solid 3px #004eff;\n\n    > strong {\n      color: #004eff;\n    }\n\n    > p {\n      color: #004eff;\n    }\n  }\n"
    ]);
    PredictionPassedMark_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var PredictionPassedMarkMobile = function(param) {
    var topPercent = param.topPercent;
    var isPassed = topPercent <= 30;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PredictionPassedMark_mobile_StyledWrapper, {
        "data-is-passed": isPassed,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: isPassed ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "합격",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "예상"
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "불합격",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "예상"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "상위 ",
                    topPercent,
                    "%"
                ]
            })
        ]
    });
};
/* harmony default export */ var PredictionPassedMark_mobile = (PredictionPassedMarkMobile);
var PredictionPassedMark_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PredictionPassedMark.mobile__StyledWrapper",
    componentId: "sc-69720e04-0"
})(PredictionPassedMark_mobile_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFive/passed/testUserInfo/UserInfoTextLayout.mobile.tsx

function UserInfoTextLayout_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  > p {\n    font-size: 16px;\n    font-weight: bold;\n    letter-spacing: -0.64px;\n    text-align: left;\n    color: #333;\n  }\n\n  > ul {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    > li {\n      list-style: disc;\n      list-style-position: inside;\n      > div {\n        display: inline;\n        position: relative;\n\n        > label {\n          font-size: 15px;\n          font-weight: 500;\n          line-height: 1.47;\n          letter-spacing: -0.6px;\n          text-align: left;\n          color: #333;\n        }\n\n        > p {\n          position: absolute;\n          width: max-content;\n          top: 0px;\n          left: 74px;\n          font-size: 15px;\n          font-weight: normal;\n          line-height: 1.47;\n          letter-spacing: -0.6px;\n          text-align: left;\n          color: #333;\n        }\n      }\n    }\n  }\n"
    ]);
    UserInfoTextLayout_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var UserInfoTextLayoutMobile = function(param) {
    var list = param.list, title = param.title, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserInfoTextLayout_mobile_StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: list.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    children: item.label
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        item.value,
                                        " "
                                    ]
                                })
                            ]
                        })
                    }, "".concat(item.label, "-").concat(index));
                })
            })
        ]
    });
};
/* harmony default export */ var UserInfoTextLayout_mobile = (UserInfoTextLayoutMobile);
var UserInfoTextLayout_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "UserInfoTextLayout.mobile__StyledWrapper",
    componentId: "sc-6387f3d9-0"
})(UserInfoTextLayout_mobile_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFive/passed/testUserInfo/TestUserInfoArticle.mobile.tsx

function TestUserInfoArticle_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-radius: 20px;\n  padding: 24px 20px 32px;\n  width: 100%;\n  background-color: #fff;\n\n  > .text-box {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 36px;\n    margin-top: 16px;\n  }\n"
    ]);
    TestUserInfoArticle_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var TestUserInfoArticleMobile = function() {
    var ref = (0,react.useContext)(PredictionOfPassedContainerContext/* PredictionOfPassedContainerContext */.K), examReserveInformation = ref.examReserveInformation, examGradingResultData = ref.examGradingResultData, examTestsData = ref.examTestsData;
    var examDate = (0,module_testResult_module/* parseTestResultDate */.U)({
        dateList: examTestsData || [],
        testId: (examReserveInformation === null || examReserveInformation === void 0 ? void 0 : examReserveInformation.examTest.id) || "",
        formatType: "kor"
    });
    var userInfoList = [
        {
            label: "닉네임",
            value: (examReserveInformation === null || examReserveInformation === void 0 ? void 0 : examReserveInformation.user.username) || ""
        },
        {
            label: "생년월일",
            value: (0,module_testResult_module/* calculateAgeFromTimestamp */.K)(examReserveInformation === null || examReserveInformation === void 0 ? void 0 : examReserveInformation.user.birthday)
        },
        {
            label: "응시일자",
            value: examDate
        }, 
    ];
    var testInfoList = [
        {
            label: "계열사",
            value: (examReserveInformation === null || examReserveInformation === void 0 ? void 0 : examReserveInformation.examSubsidiary.name) || ""
        },
        {
            label: "사업부",
            value: (examReserveInformation === null || examReserveInformation === void 0 ? void 0 : examReserveInformation.examDepartment.name) || ""
        },
        {
            label: "직무",
            value: (examReserveInformation === null || examReserveInformation === void 0 ? void 0 : examReserveInformation.examJob.name) || ""
        }, 
    ];
    if (!examReserveInformation) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) // TODO 스켈레톤 처리 필요합니다
    ;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TestUserInfoArticle_mobile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictionPassedMark_mobile, {
                topPercent: (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerRank) || 0
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-box",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfoTextLayout_mobile, {
                        title: "기본 정보",
                        list: userInfoList
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfoTextLayout_mobile, {
                        title: "응시 정보",
                        list: testInfoList
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TestUserInfoArticle_mobile = (TestUserInfoArticleMobile);
var TestUserInfoArticle_mobile_StyledWrapper = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "TestUserInfoArticle.mobile__StyledWrapper",
    componentId: "sc-391fdcf1-0"
})(TestUserInfoArticle_mobile_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFive/passed/PassedInfoBox.mobile.tsx

function PassedInfoBox_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 0px 20px;\n  background-color: #fafafa;\n\n  .margin-bottom-20 {\n    margin-bottom: 20px;\n  }\n\n  .margin-bottom-40 {\n    margin-bottom: 40px;\n  }\n"
    ]);
    PassedInfoBox_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var PassedInfoBoxMobile = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PassedInfoBox_mobile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestInfoLayout_mobile, {
                title: "응시자 인적사항",
                guideText: "위 결과는 서비스 참여 인원 및 가채점 결과에 따라 변동될 수 있습니다.",
                className: "margin-bottom-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestUserInfoArticle_mobile, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestInfoLayout_mobile, {
                title: "종합 점수 결과",
                guideText: "본 결과는 링커리어 합격 예측 서비스 이용자 데이터 기반으로, 실제 결과와 차이가 있을 수 있습니다.",
                className: "margin-bottom-40",
                isDisplayedCorrectRate: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SynthesisScoreInfoArticle_mobile, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestInfoLayout_mobile, {
                title: "전체 성적 비교",
                subText: "내 성적을 전체, 상위 30%, 동일 직무 응시생과 비교합니다.",
                className: "margin-bottom-40",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleInfoArticle_mobile, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestInfoLayout_mobile, {
                title: "성적 분포도",
                subText: "동일한 날짜에 응시한 전체 응시생 및 동일 직무 지원자들의 성적 분포를 시각적으로 분석하여, 내 성적 위치를 파악합니다.",
                className: "margin-bottom-40",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpreadScoreInfoArticle_mobile, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestInfoLayout_mobile, {
                title: "영역별 세부결과 분석",
                subText: "수리 및 추리 영역에서 내 성적을 다양한 응시자 그룹과 비교하여 세부적으로 분석합니다.",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailInfoArticle_mobile, {})
            })
        ]
    });
};
/* harmony default export */ var PassedInfoBox_mobile = (PassedInfoBoxMobile);
var PassedInfoBox_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PassedInfoBox.mobile__StyledWrapper",
    componentId: "sc-8d6c84d4-0"
})(PassedInfoBox_mobile_templateObject());


/***/ }),

/***/ 13439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TentativeScoringResultInfo_mobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.feature/exam/components/Button/ExamContainedButton.tsx
var ExamContainedButton = __webpack_require__(11923);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/components/button/PredictionButton.mobile.tsx + 1 modules
var PredictionButton_mobile = __webpack_require__(45285);
// EXTERNAL MODULE: ./src/svgIcons/GraphIcon.tsx
var GraphIcon = __webpack_require__(12017);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/context/PredictionOfPassedContainerContext.tsx
var PredictionOfPassedContainerContext = __webpack_require__(87552);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFive/result/AnswerCountingInfo.mobile.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  > .top {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 16px;\n\n    > strong {\n      font-size: 18px;\n      font-weight: bold;\n      line-height: 1.33;\n      letter-spacing: -0.72px;\n      text-align: left;\n      color: #333;\n    }\n\n    > p {\n      font-size: 12px;\n      font-weight: normal;\n      letter-spacing: -0.48px;\n      text-align: left;\n      color: ",
        ";\n    }\n  }\n\n  > .subject-answer-counting {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 12px;\n\n    > .subject-name {\n      font-size: 16px;\n      font-weight: normal;\n      letter-spacing: -0.64px;\n      color: #333;\n    }\n\n    > .counting-text {\n      font-size: 16px;\n      font-weight: normal;\n      letter-spacing: -0.64px;\n      color: #333;\n\n      > span {\n        font-weight: bold;\n      }\n    }\n  }\n\n  > hr {\n    width: 100%;\n    height: 1px;\n    background-color: #333;\n    margin: 0px;\n  }\n\n  > .all-counting-box {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 8px;\n    background-color: #f9f9f9;\n    margin-top: 12px;\n\n    > label {\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 1;\n      letter-spacing: -0.64px;\n      text-align: left;\n      color: #333;\n    }\n\n    > p {\n      font-size: 16px;\n      font-weight: 500;\n      letter-spacing: -0.64px;\n      color: #333;\n\n      > span {\n        font-weight: bold;\n        color: #004eff;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var AnswerCountingInfoMobile = function() {
    var examGradingResultData = (0,react.useContext)(PredictionOfPassedContainerContext/* PredictionOfPassedContainerContext */.K).examGradingResultData;
    var viewerMathData = examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.detail.find(function(item) {
        return item.subject === graphql/* ExamSubject.MATH */.rHe.MATH;
    });
    var viewerReasoningData = examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.detail.find(function(item) {
        return item.subject === graphql/* ExamSubject.REASONING */.rHe.REASONING;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "top",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "채점 결과"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "*맞은 문항/푼 문항"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "subject-answer-counting",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "subject-name",
                        children: "수리"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "counting-text",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: viewerMathData === null || viewerMathData === void 0 ? void 0 : viewerMathData.correctCount
                            }),
                            "/",
                            viewerMathData === null || viewerMathData === void 0 ? void 0 : viewerMathData.answeredCount,
                            " 문항"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "subject-answer-counting",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "subject-name",
                        children: "추리"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "counting-text",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: viewerReasoningData === null || viewerReasoningData === void 0 ? void 0 : viewerReasoningData.correctCount
                            }),
                            "/",
                            viewerReasoningData === null || viewerReasoningData === void 0 ? void 0 : viewerReasoningData.answeredCount,
                            " 문항"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "all-counting-box",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        children: "전체"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.correctCount
                            }),
                            "/",
                            examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.answeredCount,
                            "문항"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AnswerCountingInfo_mobile = (AnswerCountingInfoMobile);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AnswerCountingInfo.mobile__StyledWrapper",
    componentId: "sc-f9961616-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.text_3;
});

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFive/result/TentativeScoringDetailInfo.mobile.tsx

function TentativeScoringDetailInfo_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        font-size: 13px;\n        color: ",
        ";\n        text-align: center;\n        line-height: 1.54;\n      "
    ]);
    TentativeScoringDetailInfo_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 30px;\n\n  > .percent-box {\n    width: 100%;\n    padding: 12px 35px;\n    border-radius: 10px;\n    background-color: #f9f9f9;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n\n    > p {\n      font-size: 16px;\n      font-weight: normal;\n      line-height: 1;\n      letter-spacing: -0.64px;\n      text-align: left;\n      color: #333;\n    }\n\n    > strong {\n      font-size: 28px;\n      font-weight: bold;\n      letter-spacing: -1.12px;\n      text-align: left;\n      color: #004eff;\n    }\n\n    .correct-rate-guide-text {\n      ",
        "\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var TentativeScoringDetailInfoMobile = function() {
    var examGradingResultData = (0,react.useContext)(PredictionOfPassedContainerContext/* PredictionOfPassedContainerContext */.K).examGradingResultData;
    var router = (0,next_router.useRouter)();
    var isGsat2025SecondRoute = router.pathname === "/prediction/gsat2025-2";
    var correctCount = (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.correctCount) || 0;
    var answeredCount = (examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.answeredCount) || 0;
    var avgCorrectRate = answeredCount ? Math.round(correctCount / answeredCount * 100) : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TentativeScoringDetailInfo_mobile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerCountingInfo_mobile, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "percent-box",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "정답률"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                        children: [
                            avgCorrectRate,
                            "%"
                        ]
                    }),
                    isGsat2025SecondRoute && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "correct-rate-guide-text",
                        children: "ⓘ 정답률은 맞은 문항 수 / 푼 문항 수를 백분율로 나타낸 값입니다."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TentativeScoringDetailInfo_mobile = (TentativeScoringDetailInfoMobile);
var TentativeScoringDetailInfo_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TentativeScoringDetailInfo.mobile__StyledWrapper",
    componentId: "sc-46e0ba24-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(TentativeScoringDetailInfo_mobile_templateObject(), theme.color.text_2);
});

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFive/result/TentativeScoringResultInfo.mobile.tsx

function TentativeScoringResultInfo_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0px 20px;\n  margin-bottom: 24px;\n\n  > .tentative-score-box {\n    width: 100%;\n    display: flex;\n    padding: 24px;\n    border-radius: 20px;\n    border: solid 1px #e8e8e8;\n    background-color: #fff;\n    display: flex;\n    flex-direction: column;\n  }\n\n  > .get-data-button {\n    width: 100%;\n\n    i {\n      > svg {\n        width: 16px;\n        height: 16px;\n        margin-right: 4px;\n      }\n    }\n  }\n"
    ]);
    TentativeScoringResultInfo_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var TentativeScoringResultInfoMobile = function(param) {
    var onChangeStage = param.onChangeStage;
    var router = (0,next_router.useRouter)();
    var isGsat2024Route = router.pathname === "/prediction/gsat2024-2";
    var handleChangeStage = function() {
        onChangeStage();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TentativeScoringResultInfo_mobile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tentative-score-box",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TentativeScoringDetailInfo_mobile, {})
            }),
            isGsat2024Route ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictionButton_mobile/* default */.Z, {
                className: "get-data-button",
                type: "button",
                onClick: handleChangeStage,
                children: "석차분석 및 합격예측 리포트 받아보기"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExamContainedButton/* default */.Z, {
                className: "get-data-button",
                type: "button",
                onClick: handleChangeStage,
                isEndIcon: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GraphIcon/* default */.Z, {})
                    }),
                    "석차분석 및 합격예측 리포트 받아보기"
                ]
            })
        ]
    });
};
/* harmony default export */ var TentativeScoringResultInfo_mobile = (TentativeScoringResultInfoMobile);
var TentativeScoringResultInfo_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TentativeScoringResultInfo.mobile__StyledWrapper",
    componentId: "sc-ea68d611-0"
})(TentativeScoringResultInfo_mobile_templateObject());


/***/ }),

/***/ 69901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TentativeScoringQuestionList_mobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/app.feature/exam/context/ExamContext.tsx
var ExamContext = __webpack_require__(49546);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/constants/answerNumberMap.ts
var answerNumberMap = __webpack_require__(1170);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/context/TentativeScoringQuestionContext.tsx
var TentativeScoringQuestionContext = __webpack_require__(1074);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/components/radio/AnswerRadioButtonGroup.tsx + 1 modules
var AnswerRadioButtonGroup = __webpack_require__(60226);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFive/tentativeScoring/TentativeScoringQuestionItem.mobile.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 20px 20px;\n  display: flex;\n  flex-direction: column;\n  border-top: 1px solid #eeeeee;\n\n  > .question-number {\n    font-size: 15px;\n    font-weight: normal;\n    letter-spacing: -0.6px;\n    text-align: left;\n    color: #333;\n  }\n\n  > .prediction-answer-box {\n    display: flex;\n    align-items: center;\n    column-gap: 24px;\n    row-gap: 10px;\n    margin-top: 16px;\n    flex-wrap: wrap;\n\n    > p {\n      font-size: 15px;\n      font-weight: normal;\n      letter-spacing: -0.6px;\n      text-align: left;\n      color: #333;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      overflow-wrap: break-word;\n    }\n  }\n\n  > .choice-answer-box {\n    display: flex;\n    align-items: center;\n    gap: 21px;\n    margin-top: 10px;\n\n    > .selected-answer-text {\n      font-size: 15px;\n      font-weight: normal;\n      letter-spacing: -0.6px;\n      text-align: left;\n      color: #333;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var TentativeScoringQuestionItemMobile = function(param) {
    var questionData = param.questionData;
    var handleCheckReservation = (0,react.useContext)(ExamContext/* ExamContext */.J).handleCheckReservation;
    var subject = (0,react.useContext)(TentativeScoringQuestionContext/* TentativeScoringQuestionContext */.A).subject;
    var ref = (0,index_esm/* useFormContext */.Gc)(), setValue = ref.setValue, register = ref.register, resetField = ref.resetField;
    var predictionAnswer = answerNumberMap/* ANSWER_NUMVER_MAP */.e[questionData.answers[0] - 1];
    var handleChangeAnswer = function() {
        handleCheckReservation({
            onReservated: function() {
                setValue("".concat(subject, ".inputQuestions.").concat(questionData.seq - 1, ".questionId"), questionData.id);
            },
            onNotReservated: function() {
                resetField("".concat(subject, ".inputQuestions.").concat(questionData.seq - 1));
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "question-number",
                children: [
                    questionData.seq,
                    "번 문항"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "prediction-answer-box",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: questionData.content
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "가답안 ",
                            predictionAnswer,
                            "번"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "choice-answer-box",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "selected-answer-text",
                        children: "내가 고른답"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerRadioButtonGroup/* default */.Z, (0,_object_spread/* default */.Z)({
                        id: "tentative-scoring-".concat(subject, "-question-").concat(questionData.seq)
                    }, register("".concat(subject, ".inputQuestions.").concat(questionData.seq - 1, ".selectedAnswer"), {
                        onChange: handleChangeAnswer
                    })))
                ]
            })
        ]
    });
};
/* harmony default export */ var TentativeScoringQuestionItem_mobile = (TentativeScoringQuestionItemMobile);
var StyledWrapper = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "TentativeScoringQuestionItem.mobile__StyledWrapper",
    componentId: "sc-ddacef33-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFive/tentativeScoring/TentativeScoringQuestionList.mobile.tsx

function TentativeScoringQuestionList_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin: 16px 0px 24px;\n\n  & > li:first-child {\n    border-top: none;\n  }\n"
    ]);
    TentativeScoringQuestionList_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var TentativeScoringQuestionListMobile = function(param) {
    var examGradingQuestions = param.examGradingQuestions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TentativeScoringQuestionList_mobile_StyledWrapper, {
        children: examGradingQuestions === null || examGradingQuestions === void 0 ? void 0 : examGradingQuestions.map(function(question) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TentativeScoringQuestionItem_mobile, {
                questionData: question
            }, "question-id-".concat(question.id, "-").concat(question.seq));
        })
    });
};
/* harmony default export */ var TentativeScoringQuestionList_mobile = (TentativeScoringQuestionListMobile);
var TentativeScoringQuestionList_mobile_StyledWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "TentativeScoringQuestionList.mobile__StyledWrapper",
    componentId: "sc-bf86328d-0"
})(TentativeScoringQuestionList_mobile_templateObject());


/***/ }),

/***/ 6921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  > p {\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: -0.64px;\n    color: #333;\n  }\n  > .information-box {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var LevelRatingQuestionLabelLayoutMobile = function(param) {
    var label = param.label, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "information-box",
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LevelRatingQuestionLabelLayoutMobile);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "LevelRatingQuestionLabelLayout.mobile__StyledWrapper",
    componentId: "sc-d2317d8c-0"
})(_templateObject());


/***/ }),

/***/ 77478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_exam_gsat2024_2_components_button_PredictionButton_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69224);
/* harmony import */ var _app_feature_exam_gsat2024_2_desktop_components_notice_AccessRestrictionNotice_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81602);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 50px;\n  > .notice-text {\n    font-size: 44px;\n    font-weight: bold;\n    line-height: 1.34;\n    letter-spacing: -1.76px;\n    text-align: center;\n    color: #fff;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StepFourAccessRestrictionNoticeMobile = function() {
    var isOpenAccessRestrictionNotice = false;
    if (!isOpenAccessRestrictionNotice) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_feature_exam_gsat2024_2_desktop_components_notice_AccessRestrictionNotice_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("strong", {
                    className: "notice-text",
                    children: [
                        "서비스 이용 신청 후",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                        "GSAT 난이도 투표가 가능합니다."
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_feature_exam_gsat2024_2_components_button_PredictionButton_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    color: "primary",
                    children: "서비스 이용 신청"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StepFourAccessRestrictionNoticeMobile);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "StepFourAccessRestrictionNotice.mobile__StyledWrapper",
    componentId: "sc-60544e99-0"
})(_templateObject());


/***/ }),

/***/ 95927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LevelRatingCheckList_mobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/constants/questionSubjectMap.ts
var questionSubjectMap = __webpack_require__(96826);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFour/LevelRatingQuestionLabelLayout.mobile.tsx
var LevelRatingQuestionLabelLayout_mobile = __webpack_require__(6921);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
// EXTERNAL MODULE: ./src/app.feature/exam/context/ExamContext.tsx
var ExamContext = __webpack_require__(49546);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFour/checklist/ChoiceAnswerItem.mobile.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  > label {\n    width: 130px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    > span {\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 1.63;\n      letter-spacing: -0.64px;\n      color: #333;\n    }\n\n    > .check-item {\n      width: 24px;\n      height: 24px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border: 1px solid #cccccc;\n      border-radius: 5px;\n      > svg {\n        color: #fff;\n      }\n    }\n  }\n\n  > input {\n    display: none;\n\n    &:checked + label {\n      > .check-item {\n        border: 1px solid #004eff;\n        background-color: #004eff;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ChoiceAnswerItemMobile = function(param) {
    var label = param.label, id = param.id, questionId = param.questionId, questionSeq = param.questionSeq;
    var handleCheckReservation = (0,react.useContext)(ExamContext/* ExamContext */.J).handleCheckReservation;
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, control = ref.control, setValue = ref.setValue, resetField = ref.resetField;
    var choiceOneQuestionFormKey = "question".concat(questionSeq);
    var question = (0,index_esm/* useWatch */.qo)({
        control: control,
        name: "choiceOneQuestions.".concat(choiceOneQuestionFormKey)
    });
    var handleChangeQuestion = function() {
        handleCheckReservation({
            onReservated: function() {
                setValue("choiceOneQuestions.".concat(choiceOneQuestionFormKey, ".questionId"), questionId);
            },
            onNotReservated: function() {
                resetField("choiceOneQuestions.".concat(choiceOneQuestionFormKey));
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                type: "radio",
                id: "radio-".concat(label, "-").concat(id),
                defaultChecked: (question === null || question === void 0 ? void 0 : question.answerId) === id,
                value: id
            }, register("choiceOneQuestions.".concat(choiceOneQuestionFormKey, ".answerId"), {
                onChange: handleChangeQuestion
            }))),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: "radio-".concat(label, "-").concat(id),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "check-item",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Check */.Jr, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: label
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ChoiceAnswerItem_mobile = (ChoiceAnswerItemMobile);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ChoiceAnswerItem.mobile__StyledWrapper",
    componentId: "sc-4a687044-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFour/checklist/ChoiceQuestion.mobile.tsx

function ChoiceQuestion_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment ChoiceQuestion_examSurveyAnswer on ExamSurveyAnswer {\n    seq\n    content\n    id\n  }\n"
    ]);
    ChoiceQuestion_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 44px;\n\n  .answer-list-box {\n    display: flex;\n    align-items: center;\n    row-gap: 12px;\n    flex-wrap: wrap;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





src_default()(ChoiceQuestion_mobile_templateObject());
var ChoiceQuestionMobile = function(param) {
    var questioonLabel = param.questioonLabel, questionSeq = param.questionSeq, questionId = param.questionId, answerList = param.answerList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChoiceQuestion_mobile_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingQuestionLabelLayout_mobile/* default */.Z, {
            label: questioonLabel,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "answer-list-box",
                children: answerList.map(function(answer, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChoiceAnswerItem_mobile, {
                        label: answer.content,
                        id: answer.id,
                        questionId: questionId,
                        questionSeq: questionSeq
                    }, "".concat(answer.id, "-").concat(index));
                })
            })
        })
    });
};
/* harmony default export */ var ChoiceQuestion_mobile = (ChoiceQuestionMobile);
var ChoiceQuestion_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ChoiceQuestion.mobile__StyledWrapper",
    componentId: "sc-d08c038a-0"
})(_templateObject1());

// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/constants/subjectMaxQuestionCount.ts
var subjectMaxQuestionCount = __webpack_require__(10937);
// EXTERNAL MODULE: ./src/utils/inputUtils.ts
var inputUtils = __webpack_require__(92681);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFour/checklist/InputAnswerItem.mobile.tsx


function InputAnswerItem_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  > .answer-input {\n    width: 150px;\n    height: 50px;\n    border-radius: 8px;\n    border: solid 1px #ddd;\n    background-color: #fff;\n    padding-left: 16px;\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: -0.64px;\n    text-align: left;\n    color: #333;\n\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n    &::placeholder {\n      font-size: 16px;\n      font-weight: 500;\n      letter-spacing: -0.64px;\n      text-align: left;\n      color: #999999;\n    }\n  }\n\n  > label {\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: -0.64px;\n    color: #333;\n    margin-right: 16px;\n  }\n  > p {\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: -0.64px;\n    color: #333;\n    margin-left: 10px;\n  }\n"
    ]);
    InputAnswerItem_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var InputAnswerItemMobile = function(param) {
    var answer = param.answer, questionId = param.questionId, inputQuestionSubject = param.inputQuestionSubject, questionSeq = param.questionSeq;
    var handleCheckReservation = (0,react.useContext)(ExamContext/* ExamContext */.J).handleCheckReservation;
    var ref = (0,index_esm/* useFormContext */.Gc)(), setValue = ref.setValue, register = ref.register, resetField = ref.resetField;
    var inputQuestionFormKey = "question".concat(questionSeq);
    var handleChangeQuestion = function(e) {
        handleCheckReservation({
            onReservated: function() {
                (0,inputUtils/* changeOnlyNumber */.TG)(e);
                if (Number(e.target.value) <= subjectMaxQuestionCount/* default */.Z[inputQuestionSubject]) {
                    setValue("inputQuestions.".concat(inputQuestionFormKey, ".").concat(inputQuestionSubject), {
                        answerId: answer.id,
                        questionId: questionId
                    });
                } else {
                    resetField("inputQuestions.".concat(inputQuestionFormKey, ".").concat(inputQuestionSubject));
                }
            },
            onNotReservated: function() {
                resetField("inputQuestions.".concat(inputQuestionFormKey, ".").concat(inputQuestionSubject));
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputAnswerItem_mobile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                children: answer.content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                placeholder: "못푼 문제 수 입력",
                className: "answer-input",
                inputMode: "decimal",
                maxLength: 2
            }, register("inputQuestions.".concat(inputQuestionFormKey, ".").concat(inputQuestionSubject, ".numericAnswer"), {
                onChange: handleChangeQuestion
            }))),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "개/",
                    subjectMaxQuestionCount/* default */.Z[inputQuestionSubject]
                ]
            })
        ]
    });
};
/* harmony default export */ var InputAnswerItem_mobile = (InputAnswerItemMobile);
var InputAnswerItem_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InputAnswerItem.mobile__StyledWrapper",
    componentId: "sc-804449a0-0"
})(InputAnswerItem_mobile_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFour/checklist/InputQuestion.mobile.tsx

function InputQuestion_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 44px;\n\n  .input-layout {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n"
    ]);
    InputQuestion_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var InputQuestionMobile = function(param) {
    var questioonLabel = param.questioonLabel, answerList = param.answerList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputQuestion_mobile_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingQuestionLabelLayout_mobile/* default */.Z, {
            label: questioonLabel,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "input-layout",
                children: answerList.map(function(param, index) {
                    var answer = param.answer, questionId = param.questionId, questionSeq = param.questionSeq, inputQuestionSubject = param.inputQuestionSubject;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAnswerItem_mobile, {
                        answer: answer,
                        questionId: questionId,
                        inputQuestionSubject: inputQuestionSubject,
                        questionSeq: questionSeq
                    }, "".concat(answer.id, "-").concat(index));
                })
            })
        })
    });
};
/* harmony default export */ var InputQuestion_mobile = (InputQuestionMobile);
var InputQuestion_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InputQuestion.mobile__StyledWrapper",
    componentId: "sc-cb4ba2de-0"
})(InputQuestion_mobile_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFour/checklist/LevelRatingCheckList.mobile.tsx

function LevelRatingCheckList_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 32px 24px;\n  width: 100%;\n  min-height: 300px;\n  border-radius: 20px;\n  border: solid 1px #e8e8e8e8;\n  background-color: #fff;\n"
    ]);
    LevelRatingCheckList_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var LevelRatingCheckListMobile = function(param) {
    var questions = param.questions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingCheckList_mobile_StyledWrapper, {
        children: questions.map(function(question, index) {
            var answerList = question.answer.nodes;
            var questionLabel = "".concat(index + 1, ". ").concat(question.content);
            var inputQuestionArray = question.answer.nodes.map(function(answer) {
                return {
                    answer: answer,
                    questionId: question.id,
                    questionSeq: question.seq,
                    inputQuestionSubject: questionSubjectMap/* default */.Z[answer.seq]
                };
            });
            return question.isNumericAnswer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputQuestion_mobile, {
                questioonLabel: questionLabel,
                answerList: inputQuestionArray
            }, question.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChoiceQuestion_mobile, {
                questioonLabel: questionLabel,
                answerList: answerList,
                questionSeq: question.seq,
                questionId: question.id
            }, question.id);
        })
    });
};
/* harmony default export */ var LevelRatingCheckList_mobile = (LevelRatingCheckListMobile);
var LevelRatingCheckList_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "LevelRatingCheckList.mobile__StyledWrapper",
    componentId: "sc-53413fc8-0"
})(LevelRatingCheckList_mobile_templateObject());


/***/ }),

/***/ 44441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LevelRatingResultBox_mobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFour/LevelRatingQuestionLabelLayout.mobile.tsx
var LevelRatingQuestionLabelLayout_mobile = __webpack_require__(6921);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/components/Table/PredictionTable.tsx + 2 modules
var PredictionTable = __webpack_require__(64015);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFour/result/LevelRatingTable.mobile.tsx


var LevelRatingTableMobile = function(param) {
    var tableDataList = param.tableDataList;
    var columns = [
        {
            id: "data",
            label: "항목",
            dataIndex: "name"
        },
        {
            id: "percent",
            label: "투표율(%)",
            dataIndex: "dataText"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictionTable/* default */.Z, {
        tableColumns: columns,
        tableDataList: tableDataList
    });
};
/* harmony default export */ var LevelRatingTable_mobile = (LevelRatingTableMobile);

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFour/result/ResultCard.mobile.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 156px;\n  border-radius: 8px;\n  background-color: #fafafa;\n\n  > label {\n    font-size: 16px;\n    font-weight: normal;\n    letter-spacing: -0.64px;\n    color: #333;\n    margin-bottom: 6px;\n  }\n\n  > .data-text-layout {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n\n    > strong {\n      font-size: 28px;\n      font-weight: bold;\n      letter-spacing: -1.12px;\n      color: #004eff;\n    }\n\n    > p {\n      font-size: 18px;\n      font-weight: normal;\n      letter-spacing: -0.72px;\n      color: #666666;\n    }\n  }\n\n  .description-text {\n    font-size: 16px;\n    font-weight: normal;\n    letter-spacing: -0.64px;\n    color: #666666;\n    margin-top: 6px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ResultCardMobile = function(param) {
    var cardTitle = param.cardTitle, description = param.description, mainDataText = param.mainDataText, subText = param.subText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            cardTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                children: cardTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "data-text-layout",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: mainDataText
                    }),
                    subText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: subText
                    })
                ]
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "description-text",
                children: description
            })
        ]
    });
};
/* harmony default export */ var ResultCard_mobile = (ResultCardMobile);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ResultCard.mobile__StyledWrapper",
    componentId: "sc-32dbc039-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepFour/result/LevelRatingResultBox.mobile.tsx

function LevelRatingResultBox_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 36px;\n  padding: 32px 24px;\n  width: 100%;\n  min-height: 300px;\n  border-radius: 20px;\n  border: solid 1px #e8e8e8e8;\n  background-color: #fff;\n"
    ]);
    LevelRatingResultBox_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var LevelRatingResultBoxMobile = function(param) {
    var surveyResultData = param.surveyResultData;
    var question1 = surveyResultData.question1, question2 = surveyResultData.question2, question3 = surveyResultData.question3, question5 = surveyResultData.question5, question6 = surveyResultData.question6, question4 = surveyResultData.question4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LevelRatingResultBox_mobile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingQuestionLabelLayout_mobile/* default */.Z, {
                label: question1.label,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingTable_mobile, {
                    tableDataList: question1.tableDataList
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingQuestionLabelLayout_mobile/* default */.Z, {
                label: question2.label,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingTable_mobile, {
                    tableDataList: question2.tableDataList
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingQuestionLabelLayout_mobile/* default */.Z, {
                label: question3.label,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultCard_mobile, {
                    mainDataText: question3.mainDataText,
                    description: question3.description,
                    subText: question3.subText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingQuestionLabelLayout_mobile/* default */.Z, {
                label: question4.label,
                children: question4.cardList.map(function(card, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultCard_mobile, {
                        mainDataText: card.mainDataText,
                        cardTitle: card.cardTitle,
                        description: card.description
                    }, "".concat(card.cardTitle, "-").concat(index));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingQuestionLabelLayout_mobile/* default */.Z, {
                label: question5.label,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultCard_mobile, {
                    mainDataText: question5.mainDataText,
                    description: question5.description,
                    subText: question5.subText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelRatingQuestionLabelLayout_mobile/* default */.Z, {
                label: question6.label,
                children: question6.cardList.map(function(card, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultCard_mobile, {
                        mainDataText: card.mainDataText,
                        cardTitle: card.cardTitle,
                        subText: card.subText
                    }, "".concat(card.cardTitle, "-").concat(index));
                })
            })
        ]
    });
};
/* harmony default export */ var LevelRatingResultBox_mobile = (LevelRatingResultBoxMobile);
var LevelRatingResultBox_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "LevelRatingResultBox.mobile__StyledWrapper",
    componentId: "sc-e789aaf3-0"
})(LevelRatingResultBox_mobile_templateObject());


/***/ }),

/***/ 74558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 32px;\n\n  > .step-title {\n    white-space: pre;\n    font-size: 24px;\n    font-weight: bold;\n    line-height: 1.33;\n    letter-spacing: -0.96px;\n    text-align: center;\n    color: #333;\n    font-family: 'GmarketSansMedium';\n  }\n\n  > p {\n    font-size: 14px;\n    font-weight: normal;\n    letter-spacing: -0.56px;\n    text-align: center;\n    color: #333;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StepFourTitleLayoutMobile = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                className: "step-title",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                children: "*제출 후 수정이 불가 합니다."
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StepFourTitleLayoutMobile);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "StepFourTitleLayout.mobile__StyledWrapper",
    componentId: "sc-700e4b22-0"
})(_templateObject());


/***/ }),

/***/ 78327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CommunityReviewList_mobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/utils/config.ts
var config = __webpack_require__(15125);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepThree/ReviewItem.mobile.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  width: 100%;\n  height: 48px;\n  padding: 0px 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: none;\n  border: none;\n  border-top: 1px solid #eeeeee;\n\n  > .post-title {\n    max-width: 80%;\n    text-align: left;\n    font-size: 15px;\n    font-weight: normal;\n    letter-spacing: -0.6px;\n    text-align: left;\n    color: #333;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n  > .user-nickname {\n    width: 80px;\n    font-size: 15px;\n    font-weight: normal;\n    letter-spacing: -0.6px;\n    text-align: left;\n    color: #333;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ReviewItemMobile = function(param) {
    var postTitle = param.postTitle, userNickname = param.userNickname;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "post-title",
                children: postTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "user-nickname",
                children: userNickname
            })
        ]
    });
};
/* harmony default export */ var ReviewItem_mobile = (ReviewItemMobile);
var StyledWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "ReviewItem.mobile__StyledWrapper",
    componentId: "sc-25dfbe6e-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepThree/CommunityReviewList.mobile.tsx

function CommunityReviewList_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border-bottom: 1px solid #eeeeee;\n  margin-bottom: 36px;\n  width: 100%;\n"
    ]);
    CommunityReviewList_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var CommunityReviewListMobile = function(param) {
    var reviewPosts = param.reviewPosts;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityReviewList_mobile_StyledWrapper, {
        children: reviewPosts.map(function(postData) {
            var ref;
            var _title, _username;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: {
                    pathname: "".concat(config/* LINKAREER_ACADEMY_COMMUNITY_BASE_URL */.mw, "/").concat((ref = postData.board) === null || ref === void 0 ? void 0 : ref.slug, "/").concat(postData.id)
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewItem_mobile, {
                        postTitle: (_title = postData.title) !== null && _title !== void 0 ? _title : "",
                        userNickname: (_username = postData.username) !== null && _username !== void 0 ? _username : ""
                    })
                })
            }, postData.id);
        })
    });
};
/* harmony default export */ var CommunityReviewList_mobile = (CommunityReviewListMobile);
var CommunityReviewList_mobile_StyledWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "CommunityReviewList.mobile__StyledWrapper",
    componentId: "sc-a718a925-0"
})(CommunityReviewList_mobile_templateObject());


/***/ }),

/***/ 8666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_exam_context_ExamContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49546);
/* harmony import */ var hooks_useOutSideClick__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19468);
/* harmony import */ var svgIcons_OpenArrowIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28139);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  > label {\n    font-size: 16px;\n    font-weight: bold;\n    letter-spacing: -0.72px;\n    color: #333;\n  }\n\n  > .dropdown {\n    position: relative;\n    > .dropdown-toggle {\n      cursor: pointer;\n      width: 245px;\n      height: 45px;\n      border-radius: 8px;\n      border: solid 1px #dddddd;\n      background-color: #fff;\n      padding: 0px 12px 0px 16px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      > span {\n        font-size: 16px;\n        font-weight: 500;\n        letter-spacing: -0.64px;\n        color: #333;\n      }\n\n      > i {\n        > svg {\n          display: block;\n        }\n      }\n    }\n\n    > ul {\n      position: absolute;\n      z-index: 100;\n      top: 55px;\n      left: 0px;\n      padding: 10px 0px;\n      width: 100%;\n      border-radius: 8px;\n      border: solid 1px #dddddd;\n      background-color: #fff;\n\n      > li {\n        cursor: pointer;\n        width: 100%;\n        height: 40px;\n        border-bottom: solid 1px #fafafa;\n        display: flex;\n        align-items: center;\n        padding-left: 16px;\n        font-size: 16px;\n        font-weight: 500;\n        letter-spacing: -0.64px;\n        color: #333;\n\n        &:hover {\n          background-color: #fafafa;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var PredictionDropdownMobile = function(param) {
    var className = param.className, name = param.name, options = param.options, defaultValue = param.defaultValue, onChange = param.onChange;
    var ref;
    var dropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var handleCheckReservation = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_app_feature_exam_context_ExamContext__WEBPACK_IMPORTED_MODULE_3__/* .ExamContext */ .J).handleCheckReservation;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), selectedOption = ref2[0], setSelectedOption = ref2[1];
    var handleSelect = function(option) {
        return function() {
            onChange(option.value);
            setSelectedOption(option.label);
            setIsOpen(false);
        };
    };
    var handleToggleList = function() {
        handleCheckReservation({
            onReservated: function() {
                setIsOpen(function(prev) {
                    return !prev;
                });
            }
        });
    };
    var handleOutsideClick = function() {
        setIsOpen(false);
    };
    (0,hooks_useOutSideClick__WEBPACK_IMPORTED_MODULE_4__/* .useOutSideClick */ .A)({
        ref: dropdownRef,
        isActive: isOpen,
        onOutsideClick: handleOutsideClick
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        className: className,
        children: [
            name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                children: name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "dropdown",
                ref: dropdownRef,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "dropdown-toggle",
                        onClick: handleToggleList,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                children: selectedOption || defaultValue || ((ref = options[0]) === null || ref === void 0 ? void 0 : ref.label)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons_OpenArrowIcon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    isOpen: isOpen
                                })
                            })
                        ]
                    }),
                    isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                        children: options.map(function(option) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                onClick: handleSelect(option),
                                children: option.label
                            }, option.value);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PredictionDropdownMobile);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PredictionDropdown.mobile__StyledWrapper",
    componentId: "sc-f5654e29-0"
})(_templateObject());


/***/ }),

/***/ 3907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ItemKeywordsSection_mobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
// EXTERNAL MODULE: ./src/app.feature/exam/context/ExamContext.tsx
var ExamContext = __webpack_require__(49546);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/components/alert/ExamAlert.tsx
var ExamAlert = __webpack_require__(66263);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/hooks/examRestoredQuestions/useCreateQuestionKeywordForm.ts + 1 modules
var useCreateQuestionKeywordForm = __webpack_require__(46945);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/desktop/components/KeywordItem.tsx
var KeywordItem = __webpack_require__(81898);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/hooks/useGetQuestionKeywords.ts
var useGetQuestionKeywords = __webpack_require__(5416);
// EXTERNAL MODULE: ./src/hooks/useIsAdmin.ts
var useIsAdmin = __webpack_require__(76707);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepTwo/list/item/keywords/KeywordList.mobile.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  height: 30px;\n  font-size: 12px;\n  font-weight: 400;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.56;\n  letter-spacing: -0.72px;\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: scroll;\n  max-height: 140px;\n\n  &::-webkit-scrollbar {\n    width: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #cccccc;\n    border-radius: 100px;\n  }\n\n  > .scroll-box {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    column-gap: 8px;\n    row-gap: 10px;\n\n    > .infinite-scroll-ref {\n      width: 100%;\n      height: 1px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var KeywordListMobile = function(param) {
    var questionId = param.questionId;
    var ref;
    var isAdmin = (0,useIsAdmin/* default */.Z)();
    var ref1 = (0,useGetQuestionKeywords/* default */.Z)({
        questionId: questionId
    }), keywords = ref1.keywords, ref2 = ref1.ref;
    if (!(keywords === null || keywords === void 0 ? void 0 : keywords.nodes.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNullKeyword, {
            children: "등록된 키워드가 없습니다."
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "scroll-box",
            children: [
                keywords === null || keywords === void 0 ? void 0 : (ref = keywords.nodes) === null || ref === void 0 ? void 0 : ref.map(function(keywordData) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(KeywordItem/* default */.Z, {
                        id: keywordData.id,
                        label: keywordData.keyword,
                        isAdmin: isAdmin
                    }, keywordData.id);
                }),
                (keywords === null || keywords === void 0 ? void 0 : keywords.pageInfo.hasNextPage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: ref2,
                    className: "infinite-scroll-ref"
                })
            ]
        })
    });
};
/* harmony default export */ var KeywordList_mobile = (KeywordListMobile);
var StyledNullKeyword = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "KeywordList.mobile__StyledNullKeyword",
    componentId: "sc-45f040d6-0"
})(_templateObject());
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "KeywordList.mobile__StyledWrapper",
    componentId: "sc-45f040d6-1"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionFive/stepTwo/list/item/keywords/ItemKeywordsSection.mobile.tsx




function ItemKeywordsSection_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #fcfcfc;\n  padding: 18px 15px;\n  display: flex;\n  flex-direction: column;\n  margin-top: 12px;\n\n  > p {\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: -0.64px;\n    text-align: left;\n    color: #333;\n    margin-bottom: 12px;\n  }\n\n  > .add-keyword-layout {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 12px;\n\n    > .add-keyword-input {\n      width: 100%;\n      border-radius: 8px;\n      border: solid 1px #cccccc;\n      background-color: #fff;\n      height: 50px;\n      border-radius: 8px;\n      padding-left: 16px;\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 1.63;\n      letter-spacing: -0.64px;\n      text-align: left;\n      color: #333;\n\n      &::placeholder {\n        font-size: 16px;\n        font-weight: 500;\n        line-height: 1.63;\n        letter-spacing: -0.64px;\n        text-align: left;\n        color: #999;\n      }\n    }\n    > .add-keyword-button {\n      min-width: max-content;\n      height: 45px;\n    }\n  }\n"
    ]);
    ItemKeywordsSection_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var ItemKeywordsSectionMobile = function(param) {
    var questionId = param.questionId;
    var ref = (0,react.useState)(false), isOpenAlert = ref[0], setIsOpenAlert = ref[1];
    var handleCheckReservation = (0,react.useContext)(ExamContext/* ExamContext */.J).handleCheckReservation;
    var ref1 = (0,useCreateQuestionKeywordForm/* default */.Z)(), createQuestionKeywordMutation = ref1.createQuestionKeywordMutation, formMethods = ref1.formMethods;
    var handleSubmit = formMethods.handleSubmit, register = formMethods.register, reset = formMethods.reset;
    var handelAddQuestionKeyword = function(data) {
        handleCheckReservation({
            onReservated: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                var questionKeyword;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            questionKeyword = data.questionKeyword.trim();
                            if (!(questionKeyword !== "")) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                createQuestionKeywordMutation({
                                    variables: {
                                        keyword: data.questionKeyword,
                                        questionId: questionId
                                    },
                                    onError: function(error) {
                                        if (error.message === "이미 등록한 키워드입니다.") {
                                            setIsOpenAlert(function() {
                                                return true;
                                            });
                                        }
                                    }
                                })
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            })
        });
        reset();
    };
    var handleClickCloseAlert = function() {
        setIsOpenAlert(function() {
            return false;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemKeywordsSection_mobile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "복원 키워드"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(KeywordList_mobile, {
                questionId: questionId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "add-keyword-layout",
                onSubmit: handleSubmit(handelAddQuestionKeyword),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        className: "add-keyword-input",
                        placeholder: "키워드는 최대 8자 입력 가능합니다.",
                        maxLength: 8
                    }, register("questionKeyword"))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "primary",
                        className: "add-keyword-button",
                        type: "submit",
                        children: "등록"
                    })
                ]
            }),
            isOpenAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExamAlert/* default */.Z, {
                type: "alert",
                message: "이미 등록한 키워드입니다.",
                onClickConfirm: handleClickCloseAlert,
                isMobile: true
            })
        ]
    });
};
/* harmony default export */ var ItemKeywordsSection_mobile = (ItemKeywordsSectionMobile);
var ItemKeywordsSection_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemKeywordsSection.mobile__StyledWrapper",
    componentId: "sc-5f5884d4-0"
})(ItemKeywordsSection_mobile_templateObject());


/***/ }),

/***/ 95196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    white-space: pre-wrap;\n    font-size: 14px;\n    letter-spacing: -0.56px;\n    text-align: center;\n    font-weight: normal;\n    text-align: center;\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var PredictionInfoText = function(param) {
    var text = param.text, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        className: className,
        children: text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PredictionInfoText);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    displayName: "PredictionInfoText.mobile__StyledWrapper",
    componentId: "sc-1333072a-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), theme.color.text_1);
});


/***/ }),

/***/ 70387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: 24px;\n    font-weight: bold;\n    letter-spacing: -0.96px;\n    color: ",
        ";\n    font-family: 'GmarketSansMedium';\n    white-space: pre;\n    text-align: center;\n    margin-bottom: 36px;\n    > strong {\n      color: ",
        " !important;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var PredictionText = function(param) {
    var preText = param.preText, strongText = param.strongText, afterText = param.afterText, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        className: className,
        children: [
            preText,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                children: strongText
            }),
            afterText
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PredictionText);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    displayName: "PredictionText.mobile__StyledWrapper",
    componentId: "sc-d17173bb-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), theme.color.text_1, theme.color.primary_2);
});


/***/ }),

/***/ 63970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: 24px;\n    font-weight: bold;\n    letter-spacing: -0.96px;\n    color: ",
        ";\n    font-family: 'GmarketSansMedium';\n    white-space: pre-wrap;\n    text-align: center;\n\n    & > strong {\n      color: ",
        " !important;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var HeadingTitle = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadingTitle);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    displayName: "HeadingTitle__StyledWrapper",
    componentId: "sc-306bf16c-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), theme.color.text_1, theme.color.primary_2);
});


/***/ }),

/***/ 24989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_careerManage_desktop_careerContent_components_inputFields_select_components_SelectBox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34743);
/* harmony import */ var _app_feature_careerManage_desktop_careerContent_components_inputFields_select_components_SelectOption__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67308);
/* harmony import */ var hooks_useOutSideClick__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19468);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    height: auto;\n    & > .select-container {\n      width: 100%;\n      height: auto;\n      position: relative;\n      cursor: pointer;\n      li {\n        height: auto;\n        > p {\n          font-size: 16px;\n          font-weight: 500;\n          letter-spacing: -0.64px;\n        }\n      }\n      > div {\n        height: auto;\n        & > [aria-describedby='placeholder'] {\n          font-weight: 500;\n          color: ",
        ";\n        }\n      }\n    }\n\n    .select-options {\n      & > li {\n        display: flex;\n        align-items: flex-start;\n        height: auto;\n        p {\n          height: auto;\n          text-align: left;\n          color: ",
        ";\n          word-break: break-word;\n          display: -webkit-box;\n          -webkit-line-clamp: 2;\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var PredictionInputSelect = function(param) {
    var options = param.options, isErrors = param.isErrors, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "선택" : _placeholder, errorMessage = param.errorMessage, defaultSelectOption = param.defaultSelectOption, disabled = param.disabled, onChangeSelect = param.onChangeSelect;
    var ref;
    var selectRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isShowOption = ref1[0], setIsShowOption = ref1[1];
    var handleSelectOption = function(selectedOption) {
        onChangeSelect(selectedOption.value);
        setIsShowOption(false);
    };
    var handleShowOption = function() {
        setIsShowOption(function(value) {
            return !value;
        });
    };
    var handleOutsideClick = function() {
        setIsShowOption(false);
    };
    var valueHasIcon = (ref = options === null || options === void 0 ? void 0 : options.find(function(option) {
        return (option === null || option === void 0 ? void 0 : option.label) === (defaultSelectOption === null || defaultSelectOption === void 0 ? void 0 : defaultSelectOption.label);
    })) === null || ref === void 0 ? void 0 : ref.icon;
    (0,hooks_useOutSideClick__WEBPACK_IMPORTED_MODULE_5__/* .useOutSideClick */ .A)({
        ref: selectRef,
        isActive: isShowOption,
        onOutsideClick: handleOutsideClick
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "select-container",
            ref: selectRef,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_feature_careerManage_desktop_careerContent_components_inputFields_select_components_SelectBox__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    placeholder: placeholder,
                    isErrors: isErrors || !!errorMessage,
                    icon: valueHasIcon,
                    disabled: disabled,
                    isFocused: isShowOption,
                    selectValue: (defaultSelectOption === null || defaultSelectOption === void 0 ? void 0 : defaultSelectOption.label) || "",
                    onClick: handleShowOption
                }),
                isShowOption && (options === null || options === void 0 ? void 0 : options.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_feature_careerManage_desktop_careerContent_components_inputFields_select_components_SelectOption__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "select-options",
                    options: options,
                    onClick: handleSelectOption
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PredictionInputSelect);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PredictionInputSelect.mobile__StyledWrapper",
    componentId: "sc-f6dc3ad6-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject(), theme.color.text_2, theme.color.text_1);
});


/***/ }),

/***/ 38456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87536);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_exam_gsat2024_2_hooks_useGetExamTestSelectOptions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61748);
/* harmony import */ var _input_PredictionInputSelect_mobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24989);
/* harmony import */ var _label_PredictionFormLabel_mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99289);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 45px;\n  display: flex;\n  align-items: center;\n  margin-right: 66px;\n\n  > p {\n    flex: 3;\n  }\n\n  > div {\n    flex: 7;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var FormItemDepartment = function(param) {
    var companyId = param.companyId, termId = param.termId;
    var ref;
    var departments = (0,_app_feature_exam_gsat2024_2_hooks_useGetExamTestSelectOptions__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        companyId: companyId,
        termId: termId
    }).departments;
    var departmentId = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useWatch */ .qo)({
        name: "departmentId"
    });
    var ref1 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useFormContext */ .Gc)(), setValue = ref1.setValue, errors = ref1.formState.errors;
    var handleOnChangeDepartments = function(value) {
        setValue("departmentId", value, {
            shouldValidate: true,
            shouldDirty: true
        });
        setValue("jobId", "", {
            shouldValidate: true,
            shouldDirty: true
        });
    };
    var defaultOption = departments === null || departments === void 0 ? void 0 : departments.find(function(departments) {
        return (departments === null || departments === void 0 ? void 0 : departments.value) === departmentId;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_label_PredictionFormLabel_mobile__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                label: "사업부"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_input_PredictionInputSelect_mobile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                placeholder: "사업부 선택",
                isErrors: !!((ref = errors.departmentId) === null || ref === void 0 ? void 0 : ref.message),
                defaultSelectOption: defaultOption,
                options: departments,
                onChangeSelect: handleOnChangeDepartments
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormItemDepartment);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormItemDepartment.mobile__StyledWrapper",
    componentId: "sc-db3de12a-0"
})(_templateObject());


/***/ }),

/***/ 95303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_exam_gsat2024_2_desktop_SectionThree_preReservation_preReservation_form_input_PredictionInputCheckbox_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50639);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  margin-top: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var FormItemHasAgreedToPrivacy = function() {
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useFormContext */ .Gc)(), register = ref.register, errors = ref.formState.errors;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_feature_exam_gsat2024_2_desktop_SectionThree_preReservation_preReservation_form_input_PredictionInputCheckbox_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            buttonSize: "small",
            buttonId: "hasAgreedToPrivacy",
            label: "개인정보 수집/이용 및 마케팅 수신 동의"
        }, register("hasAgreedToPrivacy")), {
            isErrors: !!errors.hasAgreedToPrivacy
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormItemHasAgreedToPrivacy);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormItemHasAgreedToPrivacy.mobile__StyledWrapper",
    componentId: "sc-cbebc053-0"
})(_templateObject());


/***/ }),

/***/ 72826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87536);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_exam_gsat2024_2_hooks_useGetExamTestSelectOptions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61748);
/* harmony import */ var _input_PredictionInputSelect_mobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24989);
/* harmony import */ var _label_PredictionFormLabel_mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99289);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 45px;\n  display: flex;\n  align-items: center;\n\n  > p {\n    flex: 3;\n  }\n  > div {\n    flex: 7;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var FormItemJob = function(param) {
    var companyId = param.companyId, termId = param.termId;
    var ref;
    var jobs = (0,_app_feature_exam_gsat2024_2_hooks_useGetExamTestSelectOptions__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        companyId: companyId,
        termId: termId
    }).jobs;
    var jobId = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useWatch */ .qo)({
        name: "jobId"
    });
    var ref1 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useFormContext */ .Gc)(), setValue = ref1.setValue, errors = ref1.formState.errors;
    var handleOnChangeDepartment = function(value) {
        setValue("jobId", value, {
            shouldValidate: true,
            shouldDirty: true
        });
    };
    var defaultOption = jobs === null || jobs === void 0 ? void 0 : jobs.find(function(job) {
        return (job === null || job === void 0 ? void 0 : job.value) === jobId;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_label_PredictionFormLabel_mobile__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                label: "직무"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_input_PredictionInputSelect_mobile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                placeholder: "직무 선택",
                isErrors: !!((ref = errors.jobId) === null || ref === void 0 ? void 0 : ref.message),
                defaultSelectOption: defaultOption,
                options: jobs,
                onChangeSelect: handleOnChangeDepartment
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormItemJob);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormItemJob.mobile__StyledWrapper",
    componentId: "sc-cd09c22d-0"
})(_templateObject());


/***/ }),

/***/ 8423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FormItemPhoneNumber_mobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/utils/inputUtils.ts
var inputUtils = __webpack_require__(92681);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionThree/preReservation/preReservation.form/input/PredictionInputText.mobile.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    min-height: 45px;\n\n    & > input {\n      width: 100%;\n      height: 45px;\n      padding: 13px 15px;\n      border-radius: 8px;\n      border: solid 1px ",
        ";\n      background-color: ",
        ";\n      font-family: Noto Sans KR;\n      font-size: 16px;\n      font-weight: 500;\n      letter-spacing: -0.64px;\n      text-align: left;\n      color: ",
        ";\n\n      &:focus {\n        outline: none;\n      }\n\n      &::placeholder {\n        color: ",
        ";\n        font-weight: normal;\n      }\n\n      &:disabled {\n        background-color: ",
        ";\n        color: ",
        ";\n      }\n\n      &:read-only {\n        background-color: ",
        ";\n        pointer-events: none;\n      }\n\n      &[type='number'] {\n        -moz-appearance: textfield; // Firefox용 input number 증감 버튼 hidden\n\n        &::-webkit-inner-spin-button, // webkit 기반 (크롬, 사파리)용 input number 증감 버튼 hidden\n        &::-webkit-outer-spin-button {\n          -webkit-appearance: none;\n          margin: 0;\n        }\n      }\n\n      &.error {\n        color: ",
        ";\n        border: solid 1px ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var PredictionInputText = /*#__PURE__*/ (0,react.forwardRef)(function(_param, inputTextRef) {
    var _type = _param.type, type = _type === void 0 ? "text" : _type, isErrors = _param.isErrors, restInputProps = (0,_object_without_properties/* default */.Z)(_param, [
        "type",
        "isErrors"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
            type: type,
            ref: inputTextRef,
            className: isErrors ? "error" : ""
        }, restInputProps))
    });
});
/* harmony default export */ var PredictionInputText_mobile = (PredictionInputText);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PredictionInputText.mobile__StyledWrapper",
    componentId: "sc-53ea665e-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.line.line_2, theme.background.bg_8, theme.color.text_1, theme.color.text_3, theme.background.bg_3, theme.color.text_2, theme.background.bg_3, theme.color.error_1, theme.color.error_1);
});

// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionThree/preReservation/preReservation.form/label/PredictionFormLabel.mobile.tsx
var PredictionFormLabel_mobile = __webpack_require__(99289);
;// CONCATENATED MODULE: ./src/app.feature/exam/gsat2024-2/mobile/components/SectionThree/preReservation/preReservation.form/item/FormItemPhoneNumber.mobile.tsx


function FormItemPhoneNumber_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 45px;\n  display: flex;\n  align-items: center;\n\n  > p {\n    flex: 3;\n  }\n  > div {\n    flex: 7;\n  }\n"
    ]);
    FormItemPhoneNumber_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var FormItemPhoneNumber = function(param) {
    var disabled = param.disabled;
    var ref;
    var ref1 = (0,index_esm/* useFormContext */.Gc)(), register = ref1.register, errors = ref1.formState.errors;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormItemPhoneNumber_mobile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictionFormLabel_mobile/* default */.Z, {
                label: "휴대폰 번호"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictionInputText_mobile, (0,_object_spread/* default */.Z)({
                type: "tel",
                disabled: disabled,
                minLength: 12,
                maxLength: 13,
                isErrors: !!((ref = errors.phoneNumber) === null || ref === void 0 ? void 0 : ref.message),
                placeholder: "010-0000-0000"
            }, register("phoneNumber", {
                onChange: inputUtils/* changePhoneNumber */.Sl
            })))
        ]
    });
};
/* harmony default export */ var FormItemPhoneNumber_mobile = (FormItemPhoneNumber);
var FormItemPhoneNumber_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FormItemPhoneNumber.mobile__StyledWrapper",
    componentId: "sc-fbf01d97-0"
})(FormItemPhoneNumber_mobile_templateObject());


/***/ }),

/***/ 28235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87536);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_exam_gsat2024_2_hooks_useGetExamTestSelectOptions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61748);
/* harmony import */ var _input_PredictionInputSelect_mobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24989);
/* harmony import */ var _label_PredictionFormLabel_mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99289);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 45px;\n  display: flex;\n  align-items: center;\n\n  > p {\n    flex: 3;\n  }\n  > div {\n    flex: 7;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var FormItemSubsidiary = function(param) {
    var companyId = param.companyId, termId = param.termId;
    var ref;
    var subsidiaries = (0,_app_feature_exam_gsat2024_2_hooks_useGetExamTestSelectOptions__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        companyId: companyId,
        termId: termId
    }).subsidiaries;
    var ref1 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useFormContext */ .Gc)(), setValue = ref1.setValue, errors = ref1.formState.errors;
    var subsidiaryId = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useWatch */ .qo)({
        name: "subsidiaryId"
    });
    var handleOnChangeSubsidiary = function(value) {
        setValue("subsidiaryId", value, {
            shouldValidate: true,
            shouldDirty: true
        });
        setValue("departmentId", "", {
            shouldValidate: true,
            shouldDirty: true
        });
        setValue("jobId", "", {
            shouldValidate: true,
            shouldDirty: true
        });
    };
    var defaultOption = subsidiaries === null || subsidiaries === void 0 ? void 0 : subsidiaries.find(function(subsidary) {
        return (subsidary === null || subsidary === void 0 ? void 0 : subsidary.value) === subsidiaryId;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_label_PredictionFormLabel_mobile__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                label: "계열사"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_input_PredictionInputSelect_mobile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                placeholder: "계열사 선택",
                isErrors: !!((ref = errors.subsidiaryId) === null || ref === void 0 ? void 0 : ref.message),
                defaultSelectOption: defaultOption,
                options: subsidiaries,
                onChangeSelect: handleOnChangeSubsidiary
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormItemSubsidiary);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormItemSubsidiary.mobile__StyledWrapper",
    componentId: "sc-7f2e6b72-0"
})(_templateObject());


/***/ }),

/***/ 40413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87536);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_exam_gsat2024_2_hooks_useGetExamTermSelectOptions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14299);
/* harmony import */ var _app_feature_exam_hooks_useExamQuestionInfo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67913);
/* harmony import */ var _input_PredictionInputSelect_mobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24989);
/* harmony import */ var _label_PredictionFormLabel_mobile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99289);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 45px;\n  display: flex;\n  align-items: center;\n\n  > p {\n    flex: 3;\n  }\n  > div {\n    flex: 7;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var FormItemTestDate = function(param) {
    var companyId = param.companyId, termId = param.termId;
    var ref;
    var ref1 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_8__/* .useFormContext */ .Gc)(), setValue = ref1.setValue, errors = ref1.formState.errors;
    var ref2 = (0,_app_feature_exam_hooks_useExamQuestionInfo__WEBPACK_IMPORTED_MODULE_5__/* .useExamQuestionInfo */ .k)({
        companyId: companyId,
        termId: termId
    }), testDate = ref2.testDate, defaultTest = ref2.defaultTest;
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().query;
    var selectOptions = (0,_app_feature_exam_gsat2024_2_hooks_useGetExamTermSelectOptions__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        companyId: companyId,
        termId: termId
    });
    var testId = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_8__/* .useWatch */ .qo)({
        name: "testId"
    });
    var defaultSelectOption = selectOptions === null || selectOptions === void 0 ? void 0 : selectOptions.find(function(option) {
        return (option === null || option === void 0 ? void 0 : option.value) === testId;
    });
    var handleOnChangeTestDate = function(value) {
        setValue("testId", value, {
            shouldValidate: true,
            shouldDirty: true
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (defaultTest) {
            var ref;
            setValue("testId", (ref = testDate === null || testDate === void 0 ? void 0 : testDate.id) !== null && ref !== void 0 ? ref : defaultTest === null || defaultTest === void 0 ? void 0 : defaultTest.id, {
                shouldValidate: true,
                shouldDirty: true
            });
        }
    }, [
        defaultTest,
        query
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_label_PredictionFormLabel_mobile__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                label: "응시 날짜"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_input_PredictionInputSelect_mobile__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                placeholder: "날짜 선택",
                isErrors: !!((ref = errors.testId) === null || ref === void 0 ? void 0 : ref.message),
                defaultSelectOption: defaultSelectOption,
                options: selectOptions,
                onChangeSelect: handleOnChangeTestDate
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormItemTestDate);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormItemTestDate.mobile__StyledWrapper",
    componentId: "sc-922a6b2-0"
})(_templateObject());


/***/ }),

/***/ 99289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    flex-shrink: 0;\n    font-size: 16px;\n    color: ",
        ";\n    letter-spacing: -0.64px;\n    font-weight: bold;\n    text-align: left;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var PredictionFormLabel = function(param) {
    var label = param.label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        children: label
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PredictionFormLabel);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    displayName: "PredictionFormLabel.mobile__StyledWrapper",
    componentId: "sc-d086eddf-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), theme.color.text_1);
});


/***/ }),

/***/ 31049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ generateTableData; }
/* harmony export */ });
var generateTableData = function(examGradingResultData, subject) {
    var myAnswerData = examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.viewerResult.detail.find(function(item) {
        return item.subject === subject;
    });
    var allUserAverageData = examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.overallExamGradingResult.detail.find(function(item) {
        return item.subject === subject;
    });
    var top30UserAverageData = examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.top30percentOfOverallExamGradingResult.detail.find(function(item) {
        return item.subject === subject;
    });
    var sameInfoAverageData = examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.subsidiaryJobExamGradingResultOfSameInfo.detail.find(function(item) {
        return item.subject === subject;
    });
    var top30SameInfoAverageData = examGradingResultData === null || examGradingResultData === void 0 ? void 0 : examGradingResultData.subsidiaryJobtop30percentExamGradingResultOfSameInfo.detail.find(function(item) {
        return item.subject === subject;
    });
    return {
        answeredCount: myAnswerData === null || myAnswerData === void 0 ? void 0 : myAnswerData.answeredCount,
        correctCount: myAnswerData === null || myAnswerData === void 0 ? void 0 : myAnswerData.correctCount,
        correctRate: myAnswerData === null || myAnswerData === void 0 ? void 0 : myAnswerData.correctRate,
        allUserAverageAnsweredCount: allUserAverageData === null || allUserAverageData === void 0 ? void 0 : allUserAverageData.answeredCount,
        allUserAverageCorrectCount: allUserAverageData === null || allUserAverageData === void 0 ? void 0 : allUserAverageData.correctCount,
        allUserAverageCorrectRate: allUserAverageData === null || allUserAverageData === void 0 ? void 0 : allUserAverageData.correctRate,
        top30UserAverageAnsweredCount: top30UserAverageData === null || top30UserAverageData === void 0 ? void 0 : top30UserAverageData.answeredCount,
        top30UserAverageCorrectCount: top30UserAverageData === null || top30UserAverageData === void 0 ? void 0 : top30UserAverageData.correctCount,
        top30UserAverageCorrectRate: top30UserAverageData === null || top30UserAverageData === void 0 ? void 0 : top30UserAverageData.correctRate,
        sameInfoAverageAnsweredCount: sameInfoAverageData === null || sameInfoAverageData === void 0 ? void 0 : sameInfoAverageData.answeredCount,
        sameInfoAverageCorrectCount: sameInfoAverageData === null || sameInfoAverageData === void 0 ? void 0 : sameInfoAverageData.correctCount,
        sameInfoAverageCorrectRate: sameInfoAverageData === null || sameInfoAverageData === void 0 ? void 0 : sameInfoAverageData.correctRate,
        top30SameInfoAverageAnsweredCount: top30SameInfoAverageData === null || top30SameInfoAverageData === void 0 ? void 0 : top30SameInfoAverageData.answeredCount,
        top30SameInfoAverageCorrectCount: top30SameInfoAverageData === null || top30SameInfoAverageData === void 0 ? void 0 : top30SameInfoAverageData.correctCount,
        top30SameInfoAverageCorrectRate: top30SameInfoAverageData === null || top30SameInfoAverageData === void 0 ? void 0 : top30SameInfoAverageData.correctRate
    };
};


/***/ }),

/***/ 9729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ parsedUpdateInputValues; },
/* harmony export */   "c": function() { return /* binding */ parsedCreateInputValues; }
/* harmony export */ });
/* harmony import */ var _modules__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5143);

var parsedUpdateInputValues = function(values) {
    return {
        companyId: values.companyId,
        termId: values.termId,
        subsidiaryId: values.subsidiaryId,
        departmentId: values.departmentId,
        jobId: values.jobId,
        testId: values.testId,
        hasAgreedToPrivacy: values.hasAgreedToPrivacy
    };
};
var parsedCreateInputValues = function(values) {
    return {
        companyId: values.companyId,
        termId: values.termId,
        subsidiaryId: values.subsidiaryId,
        departmentId: values.departmentId,
        jobId: values.jobId,
        testId: values.testId,
        phoneNumber: (0,_modules__WEBPACK_IMPORTED_MODULE_0__/* .removeHyphensFromPhoneNumber */ .Y$)(values.phoneNumber),
        hasAgreedToPrivacy: values.hasAgreedToPrivacy
    };
};


/***/ }),

/***/ 77012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kz": function() { return /* binding */ tentativeScoringQuestionListDefaultValues; },
/* harmony export */   "yB": function() { return /* binding */ checkSubmitData; }
/* harmony export */ });
/* unused harmony export parseFormData */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29496);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47079);



/**
 * @description 가채점 데이터를 mutation input 데이터에 맞도록 변환하여 반환합니다.
 * @param inputQuestions 가채점 데이터
 * @returns
 */ var parseFormData = function(inputQuestions, subject) {
    var questionList = inputQuestions.map(function(question) {
        var _selectedAnswer;
        return {
            questionId: question.questionId,
            answers: [
                parseInt((_selectedAnswer = question.selectedAnswer) !== null && _selectedAnswer !== void 0 ? _selectedAnswer : "0", 10)
            ]
        };
    }).filter(function(question) {
        return question.answers[0] !== 0;
    });
    return {
        subject: subject,
        submitAnswerItems: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(questionList)
    };
};
/**
 * @description 제출 데이터를 확인하고, 제출 가능 여부를 반환합니다.
 * 입력된 항목이 0개면 제출불가, 1개만 입력해도 제출가능
 * 전체입력된답안이0개일때
 * - 체크한 문항이 없습니다. 답을 체크한 후 진행해 주세요.
 *
 * 수리영역에만 입력된 답안이 0개일 경우
 * - 수리영역 항목에 입력한 답안이 없습니다. 그래도 진행하시겠습니까?
 *
 * 추리영역에만 입력된 답안이 0개일 경우
 * - 추리영역 항목에 입력한 답안이 없습니다. 그래도 진행하시겠습니까?
 * @param data 가채점 입력 데이터
 */ var checkSubmitData = function(data) {
    var isMobile = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref, ref1;
    var mathAnswerList = data === null || data === void 0 ? void 0 : (ref = data.math) === null || ref === void 0 ? void 0 : ref.inputQuestions.filter(function(question) {
        return !!question.selectedAnswer;
    });
    var reasoningAnswerList = data === null || data === void 0 ? void 0 : (ref1 = data.reasoning) === null || ref1 === void 0 ? void 0 : ref1.inputQuestions.filter(function(question) {
        return !!question.selectedAnswer;
    });
    if ((mathAnswerList === null || mathAnswerList === void 0 ? void 0 : mathAnswerList.length) === 0 && (reasoningAnswerList === null || reasoningAnswerList === void 0 ? void 0 : reasoningAnswerList.length) === 0) {
        if (isMobile) {
            (0,notistack__WEBPACK_IMPORTED_MODULE_0__/* .enqueueSnackbar */ .yv)("체크한 문항이 없습니다. 답을 체크한 후 진행해 주세요.", {
                style: {
                    borderRadius: "20px"
                }
            });
        } else {
            alert("체크한 문항이 없습니다. 답을 체크한 후 진행해 주세요.");
        }
        return {
            isConfirmData: false,
            submitData: null
        };
    } else if ((mathAnswerList === null || mathAnswerList === void 0 ? void 0 : mathAnswerList.length) === 0) {
        return {
            isConfirmData: confirm("수리영역 항목에 입력한 답안이 없습니다. 그래도 진행하시겠습니까?"),
            submitData: [
                parseFormData(reasoningAnswerList !== null && reasoningAnswerList !== void 0 ? reasoningAnswerList : [], generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ExamSubject.REASONING */ .rHe.REASONING), 
            ]
        };
    } else if ((reasoningAnswerList === null || reasoningAnswerList === void 0 ? void 0 : reasoningAnswerList.length) === 0) {
        return {
            isConfirmData: confirm("추리영역 항목에 입력한 답안이 없습니다. 그래도 진행하시겠습니까?"),
            submitData: [
                parseFormData(mathAnswerList !== null && mathAnswerList !== void 0 ? mathAnswerList : [], generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ExamSubject.MATH */ .rHe.MATH)
            ]
        };
    } else {
        return {
            isConfirmData: true,
            submitData: [
                parseFormData(mathAnswerList !== null && mathAnswerList !== void 0 ? mathAnswerList : [], generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ExamSubject.MATH */ .rHe.MATH),
                parseFormData(reasoningAnswerList !== null && reasoningAnswerList !== void 0 ? reasoningAnswerList : [], generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ExamSubject.REASONING */ .rHe.REASONING), 
            ]
        };
    }
};
var tentativeScoringQuestionListDefaultValues = function(examGradingQuestions) {
    if (examGradingQuestions) {
        var questionList = examGradingQuestions.map(function(question) {
            return {
                questionId: question.id,
                selectedAnswer: question.userAnswers[0] ? question.userAnswers[0].toString() : null
            };
        });
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(questionList);
    } else {
        return [];
    }
};


/***/ }),

/***/ 86690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ compareCorrectRates; }
/* harmony export */ });
/**
 * @description 내 정답률과 평균 정답률을 비교하여 결과를 반환하는 함수
 * @param myCorrectRate 내 정답률
 * @param comparisonRate 평균 정답률
 * @returns
 */ var compareCorrectRates = function(myCorrectRate, comparisonRate) {
    if (comparisonRate === 0) {
        return myCorrectRate;
    }
    return myCorrectRate - comparisonRate;
};


/***/ }),

/***/ 67913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useExamQuestionInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47079);
/* harmony import */ var _app_feature_exam_modules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5143);
/* harmony import */ var hooks_useCurrentUser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38405);





var useExamQuestionInfo = function(param) {
    var companyId = param.companyId, termId = param.termId;
    var ref;
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().query;
    var user = (0,hooks_useCurrentUser__WEBPACK_IMPORTED_MODULE_2__/* .useCurrentUserContext */ .O)().user;
    var data = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .useGqlExamTestsQuery */ .nsG)({
        variables: {
            input: {
                companyId: companyId,
                termId: termId
            }
        }
    }).data;
    var testDate = data === null || data === void 0 ? void 0 : data.examTests.find(function(item) {
        if (query.adminTestId) {
            return query.adminTestId === item.id;
        } else {
            return query.testId === item.id;
        }
    });
    var examDateList = data === null || data === void 0 ? void 0 : (ref = data.examTests) === null || ref === void 0 ? void 0 : ref.map(function(test) {
        return {
            label: (0,_app_feature_exam_modules__WEBPACK_IMPORTED_MODULE_3__/* .formatToCustomDate */ .nZ)(test.date),
            value: test.id
        };
    });
    /**
   * @description 현재 날짜와 시간을 기준으로 기본 시험을 결정하는 함수
   *
   * 1. 현재 날짜가 모든 시험보다 이전인 경우: 가장 이른 시험 날짜를 반환
   * 2. 현재 날짜가 일부 시험 이후인 경우: 현재 날짜 이전의 가장 최근 시험을 반환
   *    예) 시험일이 3/21 오전 9시, 4/1 오후 10시, 4/30 오전 9시인 경우:
   *        - 3/21 오전 9시 이후부터 4/1 오후 9시 59분까지는 3/21 오전 9시 시험을 반환
   *        - 4/1 오후 10시부터 4/30 오전 8시 59분까지는 4/1 오후 10시 시험을 반환
   * 3. 현재 날짜가 모든 시험보다 이후인 경우: 마지막 시험 날짜를 반환
   */ var getDefaultTest = function() {
        var nowDate = new Date();
        if (!(data === null || data === void 0 ? void 0 : data.examTests) || data.examTests.length === 0) {
            return null;
        }
        var sortedTests = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(data.examTests).sort(function(a, b) {
            return Number(a.date) - Number(b.date);
        });
        var futureTests = sortedTests.filter(function(test) {
            return Number(test.date) > nowDate.getTime();
        });
        var pastTests = sortedTests.filter(function(test) {
            return Number(test.date) <= nowDate.getTime();
        });
        if (futureTests.length === sortedTests.length) {
            return sortedTests[0];
        }
        if (pastTests.length === sortedTests.length) {
            return sortedTests[sortedTests.length - 1];
        }
        if (pastTests.length > 0) {
            return pastTests[pastTests.length - 1];
        }
        return futureTests[0];
    };
    var defaultTest = getDefaultTest();
    var isAdmin = user === null || user === void 0 ? void 0 : user.isSuperuser;
    var date = testDate === null || testDate === void 0 ? void 0 : testDate.date;
    var examDate = date ? date : defaultTest === null || defaultTest === void 0 ? void 0 : defaultTest.date;
    return {
        isAdmin: isAdmin,
        examDate: examDate,
        testDate: testDate,
        examDateList: examDateList,
        defaultTest: defaultTest
    };
};


/***/ }),

/***/ 95200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var date_fns_fromUnixTime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42227);
/* harmony import */ var date_fns_subDays__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7069);
/* harmony import */ var date_fns_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92311);
/* harmony import */ var date_fns_isBefore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(313);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);






/**
 * 사전 예약 가능 여부를 확인하는 커스텀 훅
 *
 * 이 훅은 시험 응시날짜 리스트를 가져온 후,
 * 현재 시간이 사전 예약 마감 시간(가장 이른 시험 전날 23:59) 이전인지 확인합니다.
 *
 * @param {TUseGetIsPreReservedProps} params - 훅 파라미터
 * @param {string} params.companyId - 기업 ID
 * @param {string} params.termId - term ID
 * @returns {boolean} - 사전 예약이 가능하면 true, 불가능하면 false를 반환합니다.
 */ var useGetIsPreReserved = function(param) {
    var companyId = param.companyId, termId = param.termId;
    var ref;
    var ref1 = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .useGqlExamTestsQuery */ .nsG)({
        variables: {
            input: {
                companyId: companyId,
                termId: termId
            }
        },
        nextFetchPolicy: "cache-first"
    }), listData = ref1.data, loading = ref1.loading;
    var sortedExamTests = (listData === null || listData === void 0 ? void 0 : listData.examTests) ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(listData.examTests).sort(function(a, b) {
        return a.date - b.date;
    }) : [];
    var ref2;
    var earliestExamTimestamp = (ref2 = (ref = sortedExamTests[0]) === null || ref === void 0 ? void 0 : ref.date) !== null && ref2 !== void 0 ? ref2 : 0;
    var earliestExamDate = (0,date_fns_fromUnixTime__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(earliestExamTimestamp / 1000);
    var dayBeforeExam = (0,date_fns_subDays__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(earliestExamDate, 1);
    var preReservationDeadline = (0,date_fns_set__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(dayBeforeExam, {
        hours: 23,
        minutes: 59,
        seconds: 0,
        milliseconds: 0
    });
    var currentDate = new Date();
    var isPreReservation = loading ? true : (0,date_fns_isBefore__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(currentDate, preReservationDeadline);
    return isPreReservation;
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetIsPreReserved);


/***/ }),

/***/ 579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var generated_graphql_community__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35888);


var useGetReviewPosts = function(param) {
    var boardID = param.boardID, topicID = param.topicID;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var query = router.query;
    var data = (0,generated_graphql_community__WEBPACK_IMPORTED_MODULE_1__/* .useGqlPostsQuery */ .WJ)({
        variables: {
            filterBy: {
                boardID: boardID,
                topicID: topicID
            },
            orderBy: {
                direction: generated_graphql_community__WEBPACK_IMPORTED_MODULE_1__/* .OrderDirection.DESC */ .N9.DESC,
                field: generated_graphql_community__WEBPACK_IMPORTED_MODULE_1__/* .PostOrderField.CREATED_AT */ .d3.CREATED_AT
            },
            pagination: {
                page: query.page ? Number(query.page) : 1,
                pageSize: 6
            }
        },
        fetchPolicy: "network-only"
    }).data;
    return {
        reviewPostsData: data === null || data === void 0 ? void 0 : data.posts
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetReviewPosts);


/***/ }),

/***/ 98016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useHandleLogin; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17563);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15125);



var useHandleLogin = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var handleOnLogin = function() {
        var next = "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .LINKAREER_BASE_URL */ .dN).concat(router.pathname);
        router.push("/login?".concat(query_string__WEBPACK_IMPORTED_MODULE_1__.stringify({
            next: next
        })));
    };
    return {
        handleOnLogin: handleOnLogin
    };
};


/***/ }),

/***/ 51128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsGsat2025SecondRoute; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

var GSAT_2025_SECOND_PATH = "/prediction/gsat2025-2";
/**
 * @description 현재 라우터의 경로가 GSAT 2025 하반기 페이지('/prediction/gsat2025-2')와
 * 일치하는지 확인합니다.
 */ var useIsGsat2025SecondRoute = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    return router.pathname === GSAT_2025_SECOND_PATH;
};


/***/ }),

/***/ 36244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants_tabs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82708);



var useScrollTab = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var query = router.query;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(query.tab || null), activeTab = ref[0], setActiveTab = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        window.document.documentElement.style.scrollBehavior = "smooth";
        return function() {
            window.document.documentElement.style.scrollBehavior = "unset";
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var sectionOne = document === null || document === void 0 ? void 0 : document.querySelector("#section1");
        var sectionTwo = document === null || document === void 0 ? void 0 : document.querySelector("#section2");
        if (!sectionOne || !sectionTwo) return;
        var observer = new IntersectionObserver(function(entries) {
            var hasIntersectingEntry = false;
            entries.forEach(function(entry) {
                if (!entry.isIntersecting) return;
                hasIntersectingEntry = true;
                var target = entry.target;
                if (target.id === "section1") {
                    setActiveTab(_constants_tabs__WEBPACK_IMPORTED_MODULE_2__/* .EXAM_STAGE_TAB.FULL_RESERVATION */ .Ds.FULL_RESERVATION);
                }
                if (target.id === "section2") {
                    switch(query.tab){
                        case _constants_tabs__WEBPACK_IMPORTED_MODULE_2__/* .EXAM_STAGE_TAB.REAL_TIME_RESTORE */ .Ds.REAL_TIME_RESTORE:
                            setActiveTab(_constants_tabs__WEBPACK_IMPORTED_MODULE_2__/* .EXAM_STAGE_TAB.REAL_TIME_RESTORE */ .Ds.REAL_TIME_RESTORE);
                            break;
                        case _constants_tabs__WEBPACK_IMPORTED_MODULE_2__/* .EXAM_STAGE_TAB.EXAM_REVIEW */ .Ds.EXAM_REVIEW:
                            setActiveTab(_constants_tabs__WEBPACK_IMPORTED_MODULE_2__/* .EXAM_STAGE_TAB.EXAM_REVIEW */ .Ds.EXAM_REVIEW);
                            break;
                        case _constants_tabs__WEBPACK_IMPORTED_MODULE_2__/* .EXAM_STAGE_TAB.EXAM_VOTE */ .Ds.EXAM_VOTE:
                            setActiveTab(_constants_tabs__WEBPACK_IMPORTED_MODULE_2__/* .EXAM_STAGE_TAB.EXAM_VOTE */ .Ds.EXAM_VOTE);
                            break;
                        case _constants_tabs__WEBPACK_IMPORTED_MODULE_2__/* .EXAM_STAGE_TAB.PREDICTION_SCORE */ .Ds.PREDICTION_SCORE:
                            setActiveTab(_constants_tabs__WEBPACK_IMPORTED_MODULE_2__/* .EXAM_STAGE_TAB.PREDICTION_SCORE */ .Ds.PREDICTION_SCORE);
                            break;
                        default:
                            setActiveTab(_constants_tabs__WEBPACK_IMPORTED_MODULE_2__/* .EXAM_STAGE_TAB.REAL_TIME_RESTORE */ .Ds.REAL_TIME_RESTORE);
                            break;
                    }
                }
            });
            if (!hasIntersectingEntry) {
                setActiveTab(null);
            }
        }, {
            rootMargin: "0px 0px 0px 0px",
            threshold: [
                0.1
            ]
        });
        observer.observe(sectionOne);
        observer.observe(sectionTwo);
        return function() {
            observer.disconnect();
        };
    }, [
        query.tab
    ]);
    return {
        activeTab: activeTab
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useScrollTab);


/***/ }),

/***/ 5143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AR": function() { return /* binding */ parseAcquiredDate; },
/* harmony export */   "U1": function() { return /* binding */ formatKorDate; },
/* harmony export */   "Y$": function() { return /* binding */ removeHyphensFromPhoneNumber; },
/* harmony export */   "_w": function() { return /* binding */ formatStep3Timestamp; },
/* harmony export */   "nZ": function() { return /* binding */ formatToCustomDate; },
/* harmony export */   "un": function() { return /* binding */ formatPhoneNumber; }
/* harmony export */ });
/* unused harmony export formatStep2Timestamp */
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32912);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3006);


/**
 * 타임스탬프 값을 받아 MM/dd 오전 09시 형태로 반환합니다.
 * @param date
 * @returns
 */ var formatToCustomDate = function(date) {
    var dateToString = (0,date_fns_format__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), "MM/dd a hh시");
    return dateToString.replace("AM", "오전").replace("PM", "오후");
};
/**
 * 타임스탬프 값을 받아 MM월dd일 오전 09시 형태로 반환합니다.
 * @param date
 * @returns
 */ var formatKorDate = function(date) {
    var dateToString = (0,date_fns_format__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), "MM월dd일 a hh시");
    return dateToString.replace("AM", "오전").replace("PM", "오후");
};
/**
 * 서버에서 숫자로 되어있는 phoneNumber를 받아 000-0000-0000 형태로 반환합니다.
 * @param phoneNumber
 * @returns
 */ var formatPhoneNumber = function(phoneNumber) {
    if (!phoneNumber) return "";
    if (phoneNumber.length === 11) {
        return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
    } else if (phoneNumber.length === 10) {
        return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    } else {
        return phoneNumber;
    }
};
/**
 * 전화번호에서 하이픈(-)을 제거하고 숫자만 반환합니다.
 * @param phoneNumber
 */ var removeHyphensFromPhoneNumber = function(phoneNumber) {
    return phoneNumber.replace(/-/g, "");
};
// 요일을 한글로 변환하는 함수
var getKoreanDay = function(date) {
    var dayNames = [
        "일",
        "월",
        "화",
        "수",
        "목",
        "금",
        "토"
    ];
    return dayNames[date.getDay()];
};
// 타임스탬프를 "MM월 DD일(요일)) HH시" 형식으로 변환하는 함수
var formatStep2Timestamp = function(timestamp) {
    var date = new Date(timestamp);
    var formattedDate = format(date, "MM월 dd일", {
        locale: ko
    });
    var day = getKoreanDay(date);
    var formattedTime = format(date, "HH시", {
        locale: ko
    });
    return "".concat(formattedDate, "(").concat(day, ") ").concat(formattedTime);
};
// 타임스탬프를 "MM/DD (요일) H시" 형식으로 변환하는 함수
var formatStep3Timestamp = function(timestamp) {
    var date = new Date(timestamp);
    var formattedDate = (0,date_fns_format__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(date, "MM/dd", {
        locale: date_fns_locale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
    });
    var day = getKoreanDay(date);
    var formattedTime = (0,date_fns_format__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(date, "H시", {
        locale: date_fns_locale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
    });
    return "".concat(formattedDate, " (").concat(day, ") ").concat(formattedTime);
};
/**
 * @desc 타임스태프 형식 날짜를 YYYY.MM.DD 형식으로 변환하여 반환합니다
 * @param date
 */ var parseAcquiredDate = function(date) {
    return date ? (0,date_fns_format__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(date, "yyyy.MM.dd") : undefined;
};


/***/ }),

/***/ 23913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



var useIntersect = function(handleIntersect) {
    var deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var target = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var observer;
        if (target.current) {
            observer = new IntersectionObserver(_handleIntersect, {
                threshold: 1
            });
            observer.observe(target.current);
        }
        return function() {
            observer && observer.disconnect();
        };
    }, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(deps));
    // TODO eslint 에러 원인 찾기
    // eslint-disable-next-line no-undef
    var _handleIntersect = function(param, observer) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 1), entry = _param[0];
        if (entry.isIntersecting) {
            handleIntersect(entry, observer);
        }
    };
    return target;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIntersect);


/***/ }),

/***/ 76707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);

var useIsAdmin = function() {
    var ref;
    var data = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .useCurrentUserQuery */ .rkO)().data;
    var ref1;
    return (ref1 = data === null || data === void 0 ? void 0 : (ref = data.currentUser) === null || ref === void 0 ? void 0 : ref.isSuperuser) !== null && ref1 !== void 0 ? ref1 : false;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsAdmin);


/***/ }),

/***/ 19468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useOutSideClick; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * @desc 검색 결과에 따라 리스트를 표시한 뒤 다른 영역을 클릭하거나 esc, tab 키를 입력시 리스트를 닫도록 합니다.
 *
 */ var useOutSideClick = function(param) {
    var ref = param.ref, onOutsideClick = param.onOutsideClick, isActive = param.isActive, _isDeferOutSideClick = param.isDeferOutSideClick, isDeferOutSideClick = _isDeferOutSideClick === void 0 ? false : _isDeferOutSideClick;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleMouseDown = function(e) {
            if (isActive && ref.current && !ref.current.contains(e.target)) {
                if (isDeferOutSideClick) {
                    setTimeout(function() {
                        onOutsideClick();
                    }, 0);
                } else {
                    onOutsideClick();
                }
            }
        };
        var handleKeyDown = function(e) {
            if (isActive && (e.code === "Escape" || e.code === "Tab")) {
                onOutsideClick();
            }
        };
        document.addEventListener("mousedown", handleMouseDown);
        document.addEventListener("keydown", handleKeyDown);
        return function() {
            document.removeEventListener("mousedown", handleMouseDown);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        isActive,
        onOutsideClick,
        ref
    ]);
};


/***/ }),

/***/ 27914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export defaultComputeVisiblePieces */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
// https://github.com/eliseumds/react-pagination-hook/blob/master/src/react-pagination-hook.ts

// x = disabled, o = enable
// (1 x) < 1 2 3 4 5 > (6 o)
// (2 o) < 6 7 8 9 10 > 1(1 o)
// (3 o) < 11 12 13 14 15 > 1(6 o)
// (4 o) < 16 17 18 19 20 > 2(0 o)
// (5 o) < 21 22 23 > 2(3 x)
function defaultComputeVisiblePieces(config) {
    var numberOfPages = config.numberOfPages, maxButtons = config.maxButtons, activePage = config.activePage;
    var visiblePieces = [];
    if (!numberOfPages) {
        return [];
    }
    var startPage = maxButtons * (Math.ceil(activePage / maxButtons) - 1) + 1;
    var prePageNumber = Math.max(1, startPage - maxButtons);
    visiblePieces.push({
        type: "previous",
        pageNumber: prePageNumber,
        isDisabled: startPage - maxButtons < 1
    });
    for(var i = 0; i < maxButtons && i + startPage <= numberOfPages; i++){
        visiblePieces.push({
            type: "page-number",
            pageNumber: i + startPage
        });
    }
    visiblePieces.push({
        type: "next",
        pageNumber: Math.min(numberOfPages, startPage + maxButtons),
        isDisabled: startPage + maxButtons > numberOfPages
    });
    return visiblePieces;
}
function usePagination(config) {
    var _maxButtons = config.maxButtons, maxButtons = _maxButtons === void 0 ? 5 : _maxButtons, activePage = config.activePage;
    var setActivePage = config.setActivePage, scrollToTop = config.scrollToTop;
    var _computeVisiblePieces = config.computeVisiblePieces, computeVisiblePieces = _computeVisiblePieces === void 0 ? defaultComputeVisiblePieces : _computeVisiblePieces, tmp = config.numberOfPages, numberOfPagesProp = tmp === void 0 ? 0 : tmp;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(numberOfPagesProp), numberOfPagesState = ref[0], setNumberOfPages = ref[1];
    // prop 으로 전달 된 numberOfPages 가 있으면 사용
    var numberOfPages = numberOfPagesProp || numberOfPagesState;
    if (numberOfPages && activePage > numberOfPages) {
        activePage = numberOfPages;
    }
    if (numberOfPages && maxButtons > numberOfPages) {
        maxButtons = numberOfPages;
    }
    var isFirst = activePage === 1;
    var isLast = activePage === numberOfPages;
    var hasPrevious = numberOfPages > 1 && activePage > 1;
    var hasNext = activePage < numberOfPages;
    var visiblePieces = computeVisiblePieces({
        maxButtons: maxButtons,
        activePage: activePage,
        numberOfPages: numberOfPages
    });
    var goToPage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(pageNumber) {
        if (setActivePage) {
            setActivePage(pageNumber);
            if (scrollToTop && "object" !== "undefined") {
                window.scrollTo(0, 0);
            }
        }
    }, [
        setActivePage
    ]);
    var setNumberOfPagesCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(newNumberOfPages) {
        setNumberOfPages(newNumberOfPages);
    }, []);
    return {
        activePage: activePage,
        isFirst: isFirst,
        isLast: isLast,
        hasPrevious: hasPrevious,
        hasNext: hasNext,
        visiblePieces: visiblePieces,
        goToPage: goToPage,
        setNumberOfPages: setNumberOfPagesCallback,
        numberOfPages: numberOfPages,
        maxButtons: maxButtons,
        computeVisiblePieces: computeVisiblePieces
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (usePagination);


/***/ }),

/***/ 12017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var GraphIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "graphIconClipPath",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        "data-name": "사각형 32244",
                        style: {
                            fill: "#fff"
                        },
                        d: "M0 0h20.571v24H0z"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                "data-name": "ic / 24 / graph / white",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        "data-name": "사각형 32243",
                        style: {
                            fill: "none"
                        },
                        d: "M0 0h24v24H0z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        "data-name": "그룹 45156",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                            "data-name": "그룹 45155",
                            style: {
                                clipPath: "url(#graphIconClipPath)"
                            },
                            transform: "translate(1.715)",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    "data-name": "패스 16461",
                                    d: "M208.862 112.9V97.607a1.736 1.736 0 0 1 1.817-1.818h2.009a1.71 1.71 0 0 1 1.8 1.8v13.333a3.361 3.361 0 0 1-.052.691 1.651 1.651 0 0 1-1.559 1.314c-1.311.02-2.623.005-3.934 0a.37.37 0 0 1-.079-.028",
                                    transform: "translate(-193.918 -88.938)",
                                    style: {
                                        fill: "#fff"
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    "data-name": "패스 16462",
                                    d: "M107.518 157.31h-5.942v-.3c0-3.83.019-7.66-.011-11.49a1.826 1.826 0 0 1 1.92-1.921c.748.035 1.5 0 2.249.008a1.735 1.735 0 0 1 1.791 1.768q.008 5.879 0 11.758c0 .052-.005.1-.009.176",
                                    transform: "translate(-94.298 -133.325)",
                                    style: {
                                        fill: "#fff"
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    "data-name": "패스 16463",
                                    d: "M5.55 179.661v11.119c-.09.005-.167.014-.245.014H1.771A1.707 1.707 0 0 1 0 189.018v-7.6a1.7 1.7 0 0 1 1.754-1.762h3.56c.07 0 .14.006.233.011",
                                    transform: "translate(0 -166.796)",
                                    style: {
                                        fill: "#fff"
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    "data-name": "패스 16464",
                                    d: "M46.18 3.183c-.115.155-.229.31-.347.463a15.541 15.541 0 0 1-5.716 4.524c-.944.454-1.941.8-2.922 1.173a1.12 1.12 0 0 1-.573.049.825.825 0 0 1-.664-.8.874.874 0 0 1 .615-.845c.8-.294 1.62-.553 2.4-.906a14.015 14.015 0 0 0 5.5-4.229c.2-.268.388-.553.627-.895h-.309c-.464 0-.928 0-1.392-.009a.852.852 0 0 1-.85-.854.842.842 0 0 1 .842-.854q1.847 0 3.693.037a.813.813 0 0 1 .832.834q.033 1.807.035 3.614a.841.841 0 0 1-.863.838.854.854 0 0 1-.845-.831c-.009-.214 0-.428-.005-.642s0-.426 0-.639l-.059-.026",
                                    transform: "translate(-33.385 .001)",
                                    style: {
                                        fill: "#fff"
                                    }
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GraphIcon);


/***/ }),

/***/ 79579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var GuideIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "28",
        height: "28",
        viewBox: "0 0 28 28"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("desc", {
                children: "정보 아이콘"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                d: "M0 0h28v28H0z",
                "data-name": "사각형 21578"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                fill: "#fff",
                stroke: "#333",
                strokeWidth: "1.5",
                "data-name": "그룹 29747",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        "data-name": "타원 1756",
                        transform: "translate(5 5)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                cx: "9",
                                cy: "9",
                                r: "9",
                                stroke: "none"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                cx: "9",
                                cy: "9",
                                r: "8.25",
                                fill: "none"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        strokeLinecap: "round",
                        "data-name": "사각형 21584",
                        transform: "translate(13.25 9.636)",
                        fill: "#333",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                width: "1.5",
                                height: "6",
                                stroke: "none",
                                rx: "0.75"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                height: "4.5",
                                x: "0.75",
                                y: "0.75",
                                fill: "none"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        "data-name": "타원 1757",
                        transform: "translate(13.25 16.976)",
                        fill: "#333",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                cx: "0.75",
                                cy: "0.75",
                                r: "0.75",
                                stroke: "none"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                cx: "0.75",
                                cy: "0.75",
                                fill: "none"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (GuideIcon);


/***/ }),

/***/ 28139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var OpenArrowIcon = function(_param) {
    var isOpen = _param.isOpen, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "isOpen"
    ]);
    return isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("desc", {
                children: "열림 아이콘"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                fill: "none",
                "data-name": "icon /16/close",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M0 0h20v20H0z",
                        "data-name": "사각형 30330"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        stroke: "#333",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "1.2",
                        d: "M16.516 13.276L9.96 6.72l-6.556 6.556",
                        "data-name": "패스 16073"
                    })
                ]
            })
        ]
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("desc", {
                children: "닫힘 아이콘"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                fill: "none",
                "data-name": "icon /16/more",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M0 0h20v20H0z",
                        "data-name": "사각형 30330"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        stroke: "#333",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "1.2",
                        d: "M3.329 6.573l6.411 6.411 6.411-6.411",
                        "data-name": "패스 16073"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (OpenArrowIcon);


/***/ }),

/***/ 83396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var UpDownIcon = function(_param) {
    var isUp = _param.isUp, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "isUp"
    ]);
    return isUp ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("desc", {
                children: "up 아이콘"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                d: "M0 0h32v32H0z",
                "data-name": "사각형 30942"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                "data-name": "그룹 43588",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M23.584 12.033a.875.875 0 01-.709 1.388H19.55v14.322A2.266 2.266 0 0117.275 30h-2.8a2.266 2.266 0 01-2.275-2.257V13.421H8.875a.875.875 0 01-.709-1.388l7-9.671a.875.875 0 011.418 0z",
                    "data-name": "패스 16090"
                })
            })
        ]
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("desc", {
                children: "down 아이콘"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                d: "M0 0h32v32H0z",
                "data-name": "사각형 30942"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                "data-name": "그룹 43588",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M8.166 19.967a.875.875 0 01.709-1.388H12.2V4.257A2.266 2.266 0 0114.475 2h2.8a2.266 2.266 0 012.275 2.257v14.322h3.325a.875.875 0 01.709 1.388l-7 9.671a.875.875 0 01-1.418 0z",
                    "data-name": "패스 16090"
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (UpDownIcon);


/***/ }),

/***/ 92681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J3": function() { return /* binding */ formatDateYearMonth; },
/* harmony export */   "L0": function() { return /* binding */ changeDateToDot; },
/* harmony export */   "SU": function() { return /* binding */ isArrayFullyPopulated; },
/* harmony export */   "Sl": function() { return /* binding */ changePhoneNumber; },
/* harmony export */   "TG": function() { return /* binding */ changeOnlyNumber; },
/* harmony export */   "bV": function() { return /* binding */ changeOnlyNumberAndDot; },
/* harmony export */   "fF": function() { return /* binding */ changeInputMaxLength; }
/* harmony export */ });
// 커리어관리 입력 이벤트 유틸
/**
 * @desc 년월 입력 필드에서 숫자와 마침표만 입력이 가능하도록 처라하고 형식에 맞도록 반환합니다
 */ var changeOnlyNumberAndDot = function(e) {
    var inputText = e.target.value;
    e.target.value = inputText.replace(/[^0-9.]/g, "");
};
/**
 * @desc 년월일 입력 필드에서 숫자 입력시 마침표를 자동으로 할당합니다.
 */ var changeDateToDot = function(e) {
    var inputText = e.target.value.replace(/[^0-9]/g, "");
    if (inputText.length > 4 && inputText.length <= 6) {
        inputText = inputText.replace(/([0-9]{4})([0-9]{0,2})/, "$1.$2");
    } else if (inputText.length > 6) {
        inputText = inputText.replace(/([0-9]{4})([0-9]{2})([0-9]{0,2})/, "$1.$2.$3");
    }
    e.target.value = inputText;
};
/**
 * @desc 0-9까지의 숫자만 입력받을 수 있도록 처리합니다
 */ var changeOnlyNumber = function(e) {
    var inputText = e.target.value.toString();
    e.target.value = inputText.replace(/[^0-9]/g, "");
};
/**
 * @desc 휴대폰 번호 입력시 숫자만 입력받을 수 있도록 처리하고 형식에 맞도록 반환합니다
 */ var changePhoneNumber = function(e) {
    var onlyNumber = e.target.value.replace(/\D/g, "");
    switch(onlyNumber.length){
        case 10:
            e.target.value = onlyNumber.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
            return;
        case 11:
            e.target.value = onlyNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
            return;
        default:
            e.target.value = onlyNumber;
            return;
    }
};
/**
 * @desc api를 통해 가져온 재직기간의 기간 정보를 YYYY.MM 형식의 문자열로 변환합니다
 */ var formatDateYearMonth = function(num) {
    if (!num) return;
    var strNum = num.toString();
    var year = strNum.substring(0, 4);
    var month = strNum.substring(4);
    return "".concat(year, ".").concat(month);
};
/**
 * @desc 입력 가능한 텍스트 수를 제한하고 입력 수 이상 입력시 아무것도 입력되지 않도록 합니다
 * @param e input event
 * @param maxLength 최대 입력 가능 텍스트 수
 * @returns
 */ var changeInputMaxLength = function(e, maxLength) {
    var inputText = e.target.value;
    if (inputText.length >= maxLength) {
        e.target.value = e.target.value.substring(0, maxLength);
        return;
    }
};
/**
 * @desc 배열 내부의 값을 탐색해 해당 값이 비어있는지 판별합니다.
 * @param array 체크할 데이터 배열
 * @returns {boolean} 하나라도 비어있지 않으면 true, 모두 비어 있으면 false
 */ var isArrayFullyPopulated = function(array) {
    var checkValue = function(value) {
        if (Array.isArray(value)) {
            return value.some(checkValue);
        } else if (typeof value === "object" && value !== null) {
            var values = Object.values(value);
            return values.length > 0 && values.some(checkValue);
        } else {
            return Boolean(value);
        }
    };
    return array.some(checkValue);
};


/***/ })

}]);